import PropTypes from "prop-types"
import React from "react"
import i18n from "helpers/i18nHelper"

export const Sdg1 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="299.1,113.2 299.1,164.6 287.5,164.6 287.5,82.8 301,82.8 315.9,129.7 315.9,82.8 327.4,82.8 
      327.4,164.6 315.3,164.6 "
        />
        <path
          d="M357.1,165.5c14.6,0,20.9-9.4,20.9-22.1v-39.5c0-12.8-6.2-22.1-20.9-22.1s-20.7,9.3-20.7,22.1v39.6
      C336.4,156.1,342.6,165.5,357.1,165.5 M350.1,101.7c0-5,2.2-8.4,7-8.4s7.1,3.5,7.1,8.4v43.9c0,5-2.2,8.4-7.1,8.4s-7-3.5-7-8.4V101.7
      z"
        />
        <path
          d="M301.3,257.6h6.6c13.9,0,18.9-7,18.9-18.4V222c0-11.5-5.1-18.3-18.9-18.3h-20.4v81.8h13.8V257.6z M301.3,214.8
      h5.1c4.7,0,6.8,2.2,6.8,6.6v18.8c0,4.5-2,6.8-6.8,6.8h-5.1V214.8z"
        />
        <path
          d="M355.8,286.3c14.6,0,20.9-9.4,20.9-22.1v-39.6c0-12.8-6.3-22.1-20.9-22.1s-20.7,9.3-20.7,22.1v39.6
      C335.1,276.9,341.3,286.3,355.8,286.3 M348.8,222.5c0-5,2.2-8.4,7-8.4s7.1,3.5,7.1,8.4v43.9c0,5-2.2,8.5-7.1,8.5s-7-3.5-7-8.5V222.5
      z"
        />
        <polygon points="411.8,285.4 427.3,203.6 414.4,203.6 404.8,260.6 404.6,260.6 395.2,203.6 381.2,203.6 396.8,285.4 " />
        <polygon
          points="467,274.2 447.9,274.2 447.9,249.3 461.5,249.3 461.5,238.2 447.9,238.2 447.9,214.8 467,214.8 
      467,203.6 434.2,203.6 434.2,285.4 467,285.4 "
        />
        <path
          d="M489.2,247.9l12.9,37.5h14.5l-13.1-37.1c7.8-1.8,11-7,11-15.8V222c0-11.5-5.1-18.3-18.9-18.3h-20v81.8h13.8
      L489.2,247.9z M489.2,214.9h4.6c4.7,0,6.8,2.2,6.8,6.6v12c0,4.4-2,6.8-6.8,6.8h-4.6V214.9z"
        />
        <polygon points="531.5,285.4 545.3,285.4 545.3,214.8 556.7,214.8 556.7,203.6 520.1,203.6 520.1,214.8 531.5,214.8 " />
        <polygon
          points="577.3,285.4 591,285.4 591,254.3 606.2,203.6 593.1,203.6 584.8,234.6 584.7,234.6 576.3,203.6 
      562,203.6 577.3,254.3 "
        />
        <polygon
          points="139.6,131.5 139.9,131.5 139.9,285.9 173.8,285.9 173.8,84.2 146.7,84.2 115.5,120.8 115.5,156.2 
      115.8,156.2 "
        />
        {!quantitative && (
          <>
            <g>
              <path
                d="M770.1,477.1c0-15.3,12.4-27.7,27.7-27.6c15.3,0,27.7,12.4,27.6,27.7c0,15.3-12.4,27.6-27.6,27.6
        C782.5,504.8,770.1,492.4,770.1,477.1"
              />
              <path
                d="M830.2,515.5c19,1.8,33.5,17.7,33.5,36.8V629c0,5.9-4.8,10.7-10.7,10.7c-5.9,0-10.7-4.8-10.7-10.7v-66
        c0-2.5-0.7-5.8-5.2-5.8c-3.1,0-3.8,3.3-3.9,5.4v197.5c0,8.5-6.9,15.4-15.4,15.4c-8.5,0-15.4-6.9-15.4-15.4V646.4
        c0-1.3-0.5-4.5-4.4-4.5l0,0c-3.9,0-4.4,3.3-4.5,4.5v113.8c0.2,8.5-6.5,15.6-15,15.8s-15.6-6.5-15.8-15c0-0.3,0-0.5,0-0.8V562.7
        c-0.1-2.1-0.8-5.4-3.9-5.4c-4.5,0-5.2,3.3-5.2,5.8V629c-0.3,5.9-5.3,10.5-11.2,10.3c-5.6-0.2-10-4.7-10.3-10.3v-76.8
        c0-19.1,14.5-35,33.5-36.8c0.7-0.1,1.3-0.2,2-0.2H828C828.7,515.3,829.4,515.3,830.2,515.5"
              />
            </g>
            <g>
              <path
                d="M605.5,491.6c0-14.5-11.7-26.2-26.2-26.2c-14.5,0-26.2,11.7-26.2,26.2s11.7,26.2,26.2,26.2c0,0,0,0,0,0
        C593.8,517.8,605.5,506.1,605.5,491.6"
              />
              <path
                d="M526.5,551l-21.8,71c0,0-3.9,13,7.1,16.2s14.3-9.4,14.3-9.4l17.6-59.2c0,0,1-4.6,4.4-3.6s2.1,5.8,2.1,5.8
        l-30.6,111h28.4v79.5c0.2,7.5,6.5,13.5,14,13.3c7.3-0.2,13.1-6,13.3-13.3v-79.6h7.8v79.5c0.2,7.5,6.5,13.5,14,13.3
        c7.3-0.2,13.1-6,13.3-13.3v-79.5h28.4l-30.6-111c0,0-1.3-4.8,2.1-5.8s4.4,3.6,4.4,3.6l17.6,59.2c0,0,3.3,12.7,14.3,9.4
        s7.2-16.2,7.2-16.2l-21.8-71c0,0-7.8-20.5-25-20.5h-55.6C534.3,530.5,526.5,551,526.5,551"
              />
            </g>
            <g>
              <path
                d="M448.5,491.6c0-14.5-11.7-26.2-26.2-26.2c-14.5,0-26.2,11.7-26.2,26.2c0,14.5,11.7,26.2,26.2,26.2l0,0
        C436.8,517.8,448.5,506.1,448.5,491.6"
              />
              <path
                d="M369.5,551l-21.8,71c0,0-3.9,13,7.1,16.2s14.3-9.4,14.3-9.4l17.6-59.2c0,0,1-4.6,4.4-3.6s2.1,5.8,2.1,5.8
        l-30.6,111h28.4v79.5c0,7.5,6.1,13.7,13.7,13.7s13.7-6.1,13.7-13.7l0,0v-79.6h7.8v79.5c0.2,7.5,6.5,13.5,14,13.3
        c7.3-0.2,13.1-6,13.3-13.3v-79.5h28.5l-30.6-111c0,0-1.3-4.9,2.1-5.8s4.4,3.6,4.4,3.6l17.6,59.2c0,0,3.3,12.7,14.3,9.4
        s7.1-16.2,7.1-16.2l-21.8-71c0,0-7.8-20.5-25-20.5h-55.6C377.3,530.5,369.5,551,369.5,551"
              />
            </g>
            <g>
              <path
                d="M693.5,638.3c12.1,0,21.8-9.8,21.8-21.8c0-12.1-9.8-21.8-21.8-21.8c-12,0-21.8,9.8-21.8,21.8
        C671.7,628.5,681.4,638.3,693.5,638.3C693.5,638.3,693.5,638.3,693.5,638.3"
              />
              <path
                d="M641.2,706.1c-1.1,2.5-1.9,8,3.2,10.3c6,2.8,9.3-3,9.3-3l11.9-37.8c0,0,2.1-2.5,2.1,0.1v89h0
        c0.2,6.2,5.3,11,11.5,10.9c5.9-0.2,10.7-4.9,10.9-10.9v-35.2c0,0-0.7-5,3.4-5s3.4,5,3.4,5v35.2c0,6.2,5,11.2,11.2,11.2
        c6.2,0,11.2-5,11.2-11.2v-89.1c0-2.6,1.4-0.8,1.4-0.8l9.3,25.9c0,0,4,11.6,5.3,12.1c4.2,1.8,9-0.2,10.8-4.4c0,0,0,0,0,0
        c1.1-2.6,0.8-5.7-0.9-8l0.1-0.1c-0.3-0.8-13.9-34.3-15.5-39c-4.9-14.4-13.9-14.2-22.5-14.5s-13.8,0-13.8,0s-5.5-0.2-16.9,0.1
        s-15,6.2-27.5,38.5C647.3,690.1,641.2,705.2,641.2,706.1L641.2,706.1z"
              />
            </g>
            <g>
              <path
                d="M186.7,504.8c15.3,0,27.7-12.4,27.7-27.7c0-15.3-12.4-27.7-27.7-27.7S159,461.8,159,477.1c0,0,0,0,0,0
        C159,492.4,171.4,504.7,186.7,504.8z"
              />
              <path
                d="M219.2,515.3c-0.7-0.1-1.5-0.3-2.2-0.3h-60.5c-0.7,0.1-1.3,0.2-2,0.3c-19,1.8-33.5,17.8-33.5,36.9V629
        c0,3.9,2.1,7.6,5.6,9.5c-0.2,0.3-0.3,0.6-0.4,0.9l-24.6,130.3c-0.4,2.2,1,4.3,3.1,4.7c0,0,0.1,0,0.1,0c0.2,0,0.5,0.1,0.8,0.1
        c2,0,3.6-1.4,4-3.3l24.6-130.3c0-0.5,0-1-0.1-1.5c4.7-1.2,8-5.5,7.9-10.4v-66c0-2.5,0.6-5.8,5.2-5.8c3.1,0,3.8,3.3,3.8,5.4v197.5
        c0,8.6,6.9,15.5,15.5,15.5s15.5-6.9,15.5-15.5V646.4c0-2.4,1.8-4.3,4.2-4.4c0.1,0,0.3,0,0.4,0l0,0c3.9,0,4.3,3.1,4.3,4.4v113.8
        c0,8.6,6.9,15.5,15.5,15.5s15.5-6.9,15.5-15.5V562.7c0-2.1,0.7-5.4,3.8-5.4c4.6,0,5.2,3.3,5.2,5.8V629c0,6.1,4.9,11,11,11
        s11-4.9,11-11v-76.8C252.9,533.1,238.3,517.1,219.2,515.3z"
              />
            </g>
            <g>
              <path
                d="M326.2,674.4l20.2-36.8c0,0,2.4-5.3,2.4-6.5c-0.1-4.4-3.7-7.9-8.1-7.9c-2.7,0-5.1,1.4-6.6,3.7H334
        c-0.6,0.5-10.8,18.6-14.2,22c-3.5,3.6-6.7,3.1-6.7,3.1h-26.4c0,0-3.2,0.5-6.7-3.1c-3.4-3.4-13.5-21.5-14.2-22l-0.1,0.1
        c-2.4-3.7-7.4-4.7-11.1-2.3c-2.2,1.4-3.5,3.8-3.6,6.4c0.1,1.2,0.4,2.4,0.8,3.5l22,39.8c0.8,1.7,1.2,3.4,1.3,5.2v7.8L263.5,730H275
        v35h0.1c0.1,6,4.9,10.8,10.9,10.8c6,0.1,10.8-4.7,10.9-10.7v-33.7c-0.3-0.4-0.5-0.9-0.4-1.4h6.5c0.1,0.5,0,1-0.1,1.4v33.7
        c0,6.1,4.9,11,11,11s11-4.9,11-11V730h11.3L325,687.2v-7.6C325.1,677.9,325.5,676.1,326.2,674.4z"
              />
              <path
                d="M299.9,638.3c12.1,0,21.8-9.8,21.8-21.8s-9.8-21.8-21.8-21.8c-12,0-21.8,9.8-21.8,21.8
        C278,628.5,287.8,638.3,299.9,638.3C299.8,638.3,299.9,638.3,299.9,638.3z"
              />
            </g>
          </>
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <>
              <path
                d="m0 0c0 11.06 8.968 20.014 20.02 20.014 11.034 0 19.977-8.954 19.977-20.014 0-11.049-8.943-20.009-19.977-20.009-11.052 0-20.02 8.96-20.02 20.009"
                fill="currentColor"
                transform="translate(563.8556 385.1975)"
              />
              <path
                d="m0 0c13.573-1.228 24.213-12.646 24.213-26.57v-6.649-2.907-45.904c0-4.265-3.474-7.751-7.746-7.751-4.301 0-7.762 3.486-7.762 7.751v47.632c0 1.787-.517 4.205-3.784 4.205-2.259 0-2.729-2.394-2.812-3.918v-142.766c0-6.135-4.969-11.142-11.135-11.142-6.171 0-11.165 5.007-11.165 11.142v82.272c-.031.907-.334 3.266-3.162 3.266h-.013c-2.843 0-3.189-2.359-3.22-3.266v-82.272c0-6.135-4.964-11.142-11.13-11.142-6.18 0-11.148 5.007-11.148 11.142v142.766c-.075 1.524-.561 3.918-2.803 3.918-3.284 0-3.78-2.418-3.78-4.205v-47.632c0-4.265-3.478-7.751-7.763-7.751-4.289 0-7.744 3.486-7.744 7.751v45.904 2.907 6.649c0 13.924 10.648 25.342 24.243 26.57.443.057.93.122 1.464.122h21.894 21.831c.574 0 1.044-.065 1.522-.122"
                fill="currentColor"
                transform="translate(607.2291 357.4739)"
              />
              <path
                d="m0 0c0 10.464-8.46 18.966-18.928 18.966-10.473 0-18.955-8.502-18.955-18.966 0-10.468 8.482-18.947 18.955-18.947 10.468 0 18.928 8.479 18.928 18.947"
                fill="currentColor"
                transform="translate(444.8833 374.6895)"
              />
              <path
                d="m0 0-15.748-51.268s-2.807-9.398 5.166-11.744c7.933-2.35 10.341 6.826 10.341 6.826l12.7 42.788s.689 3.291 3.162 2.579c2.478-.709 1.548-4.23 1.548-4.23l-22.103-80.186h20.555v-57.434c0-5.434 4.426-9.857 9.881-9.857 5.447 0 9.855 4.423 9.855 9.857v57.434h2.82 2.789v-57.434c0-5.434 4.399-9.857 9.863-9.857 5.469 0 9.885 4.423 9.885 9.857v57.434h20.546l-22.085 80.186s-.93 3.521 1.539 4.23c2.478.712 3.167-2.579 3.167-2.579l12.696-42.788s2.416-9.176 10.337-6.826c7.99 2.346 5.17 11.744 5.17 11.744l-15.748 51.268s-5.627 14.821-18.091 14.821h-20.068-20.078c-12.459 0-18.099-14.821-18.099-14.821"
                fill="currentColor"
                transform="translate(387.7786 331.7745)"
              />
              <path
                d="m0 0c0 10.464-8.473 18.966-18.937 18.966-10.473 0-18.945-8.502-18.945-18.966 0-10.468 8.472-18.947 18.945-18.947 10.464 0 18.937 8.479 18.937 18.947"
                fill="currentColor"
                transform="translate(331.415 374.6895)"
              />
              <path
                d="m0 0-15.74-51.268s-2.815-9.398 5.162-11.744c7.929-2.35 10.336 6.826 10.336 6.826l12.701 42.788s.689 3.291 3.162 2.579c2.482-.709 1.544-4.23 1.544-4.23l-22.095-80.186h20.551v-57.434c0-5.434 4.438-9.857 9.881-9.857 5.456 0 9.863 4.423 9.863 9.857v57.434h2.829 2.781v-57.434c0-5.434 4.39-9.857 9.867-9.857 5.469 0 9.872 4.423 9.872 9.857v57.434h20.555l-22.081 80.186s-.938 3.521 1.526 4.23c2.474.712 3.171-2.579 3.171-2.579l12.687-42.788s2.417-9.176 10.342-6.826c7.986 2.346 5.166 11.744 5.166 11.744l-15.749 51.268s-5.614 14.821-18.081 14.821h-20.056-20.091c-12.454 0-18.103-14.821-18.103-14.821"
                fill="currentColor"
                transform="translate(274.3019 331.7745)"
              />
              <path
                d="m0 0c8.723 0 15.762 7.059 15.762 15.784 0 8.718-7.039 15.755-15.762 15.755s-15.77-7.037-15.77-15.755c0-8.725 7.047-15.784 15.77-15.784"
                fill="currentColor"
                transform="translate(508.5094 268.6571)"
              />
              <path
                d="m0 0c-.772-1.844-1.404-5.754 2.298-7.46 4.342-1.993 6.758 2.202 6.758 2.202l8.574 27.337s1.487 1.831 1.487-.061v-64.357h.039c0-4.479 3.605-8.091 8.091-8.091 4.474 0 8.088 3.612 8.088 8.091v25.398s-.469 3.589 2.425 3.589 2.448-3.589 2.448-3.589v-25.398c0-4.479 3.63-8.091 8.104-8.091 4.464 0 8.109 3.612 8.109 8.091v64.357c0 1.892 1 .541 1 .541l6.718-18.72s2.917-8.365 3.816-8.733c3.03-1.274 6.535.173 7.814 3.231.838 1.996.518 4.139-.64 5.754l.057.06c-.192.605-10.042 24.759-11.2 28.149-3.557 10.383-10.03 10.293-16.262 10.464-6.237.148-9.964 0-9.964 0s-3.982.162-12.214-.081c-8.215-.259-10.811-4.47-19.875-27.792-1.294-3.359-5.671-14.227-5.728-14.878z"
                fill="currentColor"
                transform="translate(470.7012 219.6681)"
              />
              <path
                d="m0 0c0 11.06-8.977 20.014-20.025 20.014-11.038 0-19.981-8.954-19.981-20.014 0-11.049 8.943-20.009 19.981-20.009 11.048 0 20.025 8.96 20.025 20.009"
                fill="currentColor"
                transform="translate(162.2196 385.1975)"
              />
              <path
                d="m0 0c-13.569-1.228-24.222-12.646-24.222-26.57v-6.649-2.907-45.904c0-4.265 3.478-7.751 7.762-7.751 4.29 0 7.759 3.486 7.759 7.751v47.632c0 1.787.517 4.205 3.784 4.205 2.254 0 2.724-2.394 2.821-3.918v-142.766c0-6.135 4.96-11.142 11.13-11.142 6.162 0 11.144 5.007 11.144 11.142v82.272c.048.907.346 3.266 3.179 3.266h.009c2.842 0 3.188-2.359 3.215-3.266v-82.272c0-6.135 4.973-11.142 11.135-11.142 6.175 0 11.143 5.007 11.143 11.142v142.766c.066 1.524.575 3.918 2.811 3.918 3.285 0 3.777-2.418 3.777-4.205v-47.632c0-4.265 3.477-7.751 7.762-7.751s7.749 3.486 7.749 7.751v45.904 2.907 6.649c0 13.924-10.644 25.342-24.239 26.57-.451.057-.929.122-1.469.122h-21.893-21.831c-.574 0-1.053-.065-1.526-.122"
                fill="currentColor"
                transform="translate(118.8376 357.4739)"
              />
              <path
                d="m0 0-17.766-94.17"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeMiterlimit="10"
                strokeWidth="8.511"
                transform="translate(101.3914 267.3832)"
              />
            </>
          )}
          <g fill="currentColor">
            {!quantitative && (
              <>
                <path
                  d="m0 0c-1.035 1.616-2.816 2.695-4.868 2.695-3.166 0-5.745-2.578-5.745-5.732 0-.916.562-2.522.562-2.522l15.897-28.769s.974-1.982.974-3.794v-61.777h.03c0-4.311 3.478-7.771 7.776-7.771 4.289 0 7.749 3.46 7.749 7.771v24.38s-.438 3.449 2.347 3.449c2.776 0 2.342-3.449 2.342-3.449v-24.38c0-4.311 3.486-7.771 7.78-7.771 4.289 0 7.784 3.46 7.784 7.771v61.777c0 1.812.96 3.794.96 3.794l14.696 26.559s1.798 3.816 1.798 4.732c0 3.154-2.57 5.732-5.749 5.732-2.079 0-3.855-1.079-4.863-2.695l-.066.033c-.461-.397-7.82-13.503-10.249-15.93-2.571-2.59-4.868-2.303-4.868-2.303h-9.565-9.543s-2.316-.287-4.873 2.303c-2.46 2.427-9.788 15.533-10.258 15.93z"
                  transform="translate(199.2951 276.9194)"
                />
                <path
                  d="m0 0c8.723 0 15.761 7.059 15.761 15.784 0 8.718-7.038 15.755-15.761 15.755-8.719 0-15.762-7.037-15.762-15.755 0-8.725 7.043-15.784 15.762-15.784"
                  transform="translate(224.0168 268.6571)"
                />
                <path
                  d="m0 0 17.823-12.999 8.468-31.185h-26.291-26.313l8.49 31.185z"
                  transform="translate(224.0429 246.5229)"
                />
              </>
            )}
            <path
              d="m0 0h.216v-111.543h24.493v145.716h-19.56l-22.559-26.436v-25.569h.214z"
              transform="translate(108.202 634.9429)"
            />
            <path
              d="m0 0v-24.147h3.797c3.527 0 5.066 1.718 5.066 5.066v14.107c0 3.346-1.539 4.974-5.066 4.974zm-10.31 8.411h15.284c10.399 0 14.199-5.155 14.199-13.747v-12.931c0-8.592-3.8-13.837-14.199-13.837h-4.974v-20.801h-10.31z"
              transform="translate(212.7234 660.1661)"
            />
            <path
              d="m0 0h8.227l-4.067 24.599h-.093zm-12.934-19.443 11.576 61.316h11.757l11.665-61.316h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
              transform="translate(244.9351 626.7046)"
            />
            <path
              d="m0 0v8.23h9.588v-8.411c0-3.438 1.536-5.425 5.063-5.425 3.256 0 4.703 2.168 4.703 5.425v2.35c0 3.526-1.447 5.699-4.611 8.681l-6.061 6.062c-5.877 5.788-8.59 9.315-8.59 16.368v2.08c0 7.597 4.43 13.475 14.47 13.475 10.309 0 14.377-5.064 14.377-13.926v-4.974h-9.404v5.336c0 3.526-1.628 5.244-4.884 5.244-2.894 0-4.882-1.628-4.882-5.066v-1.266c0-3.434 1.899-5.425 4.882-8.319l6.602-6.513c5.606-5.695 8.319-9.133 8.319-15.913v-2.987c0-8.411-4.519-14.377-15.01-14.377-10.492 0-14.562 5.877-14.562 13.926"
              transform="translate(269.8197 620.4652)"
            />
            <path
              d="m0 0c4.248 0 5.877 2.532 5.877 6.239v32.104c0 3.619-1.629 6.15-5.877 6.15h-4.341v-44.493zm16.187 36.444v-28.395c0-9.407-3.889-16.46-14.922-16.46h-15.916v61.315h15.916c11.033 0 14.922-6.964 14.922-16.46"
              transform="translate(217.0643 529.7199)"
            />
            <path
              d="m0 0h24.599v-8.411h-14.289v-17.545h10.218v-8.319h-10.218v-18.629h14.289v-8.412h-24.599z"
              transform="translate(239.147 582.6244)"
            />
            <path
              d="m0 0v-24.147h3.797c3.527 0 5.066 1.718 5.066 5.067v14.107c0 3.345-1.539 4.973-5.066 4.973zm-10.31 8.411h15.284c10.399 0 14.199-5.155 14.199-13.747v-12.93c0-8.593-3.8-13.838-14.199-13.838h-4.974v-20.801h-10.31z"
              transform="translate(295.0816 574.213)"
            />
            <path
              d="m0 0h8.227l-4.067 24.599h-.093zm-12.933-19.443 11.575 61.316h11.757l11.665-61.316h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
              transform="translate(327.29 540.7515)"
            />
            <path
              d="m0 0v-46.395c0-9.496-4.071-15.643-14.562-15.643-10.851 0-15.373 6.147-15.373 15.643v46.395h10.31v-47.39c0-3.616 1.447-6.058 5.063-6.058 3.619 0 5.066 2.442 5.066 6.058v47.39z"
              transform="translate(382.1986 582.6244)"
            />
            <path
              d="m0 0-11.668-61.316h-11.213l-11.665 61.316h10.489l7.053-42.776h.092l7.235 42.776z"
              transform="translate(421.1042 582.6244)"
            />
            <path
              d="m0 0v-19.08h3.435c3.527 0 5.066 1.806 5.066 5.062v9.045c0 3.345-1.539 4.973-5.066 4.973zm0-24.779v-28.126h-10.31v61.316h15.014c10.399 0 14.196-5.155 14.196-13.747v-7.868c0-6.602-2.351-10.491-8.231-11.845l9.859-27.856h-10.85z"
              transform="translate(435.6756 574.213)"
            />
            <path
              d="m0 0h24.598v-8.411h-14.288v-17.545h10.217v-8.319h-10.217v-18.629h14.288v-8.412h-24.598z"
              transform="translate(460.1981 582.6244)"
            />
            <path
              d="m0 0h27.403v-8.411h-8.501v-52.905h-10.402v52.905h-8.5z"
              transform="translate(489.15 582.6244)"
            />
            <path
              d="m0 0-16.19-2.08v5.788l16.19 3.434zm-21.434-4.341h24.598v-8.412h-14.288v-17.544h10.217v-8.319h-10.217v-18.63h14.288v-8.411h-24.598z"
              transform="translate(542.7924 586.9659)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Sdg2 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="_Path_2"
          d="M187,257.8h-55.6v-9.5c0-15.8,5.6-21.7,14.3-30.9l21.7-22.9c17.6-18.7,21.4-30.6,21.4-50.9v-19.6
	c0-28.8-14-42.5-44.3-42.5c-29.7,0-44.9,15.8-44.9,44v24.4h30.9v-25.3c0-12.2,5.9-15.8,13.1-15.8c6.5,0,12.2,2.7,12.2,15.2v16.7
	c0,16.7-1.5,23.2-12.5,34.8l-19,20.2C105.8,215.2,99,228.3,99,248.2v37.2h88V257.8z"
        />
        {!quantitative && (
          <g>
            <path
              id="_Path_3"
              d="M413.1,849.7v14.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0.1,3.5,3,6.3,6.5,6.3c0,0,0.1,0,0.1,0
		h0.2h165c0,0,0.1,0,0.1,0h0.2c3.6-0.1,6.5-3,6.5-6.6l0,0c0,0,0,0,0,0v-16c92.9-30.4,162.4-105.7,177.7-197.4c0-0.2,0.1-0.4,0.1-0.5
		c0.1-0.3,0.1-0.6,0.1-0.9c0-3.7-3-6.7-6.7-6.7c0,0,0,0,0,0H237.1c-3.7,0-6.7,3-6.7,6.6c0,0,0,0,0,0l0.4,3
		C246.9,744.8,318.3,820.5,413.1,849.7"
            />
            <path
              id="_Path_4"
              d="M591.5,418.2c-2.2,3.1-53,76.2,1.1,135.3c24.8,27.1,22.7,51.1,15.6,67.2h34.7
		c7-23.9,4.1-53.8-24-84.6c-39.9-43.6,0.5-102.5,1.1-103.4c4.8-6.7,2.2-15.4-5.6-19.4S596.3,411.5,591.5,418.2"
            />
            <path
              id="_Path_5"
              d="M503.6,620.8h34.7c7-23.9,4.1-53.8-24.1-84.6c-39.9-43.6,0.5-102.5,1.1-103.4
		c4.7-6.7,2.2-15.3-5.6-19.4s-18.1-1.9-22.8,4.8c-2.2,3.1-53,76.2,1.1,135.3C512.8,580.7,510.7,604.6,503.6,620.8"
            />
            <path
              id="_Path_6"
              d="M382.3,418.2c-2.2,3.1-53,76.2,1.1,135.3c24.8,27.2,22.7,51.1,15.6,67.2h34.7
		c7-23.9,4.1-53.8-24.1-84.6c-39.9-43.6,0.5-102.5,1.1-103.4c4.7-6.7,2.2-15.4-5.7-19.4S387.1,411.5,382.3,418.2"
            />
          </g>
        )}
        <g id="_Group_">
          <path
            id="_Compound_Path_"
            d="M299.1,154.3h20.9v11.2h-35.2v-11.2L306.3,95h-19.4V83.8h33.9V95L299.1,154.3z"
          />
          <path
            id="_Compound_Path_2"
            d="M329.2,83.8H362V95h-19.1v23.4h13.6v11.1h-13.6v24.8H362v11.2h-32.8V83.8z"
          />
          <path
            id="_Compound_Path_3"
            d="M384.3,128v37.5h-13.8V83.8h20c13.9,0,18.9,6.9,18.9,18.3v10.5c0,8.8-3.1,14-11,15.8
		l13.1,37.1h-14.4L384.3,128z M384.3,95v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12.1c0-4.5-2-6.6-6.8-6.6H384.3z"
          />
          <path
            id="_Compound_Path_4"
            d="M418.2,144.4v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
		c0,12.7-6.3,22.1-20.9,22.1S418.2,157.1,418.2,144.4z M446,146.6v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
		c0,4.9,2.2,8.4,7,8.4S446,151.5,446,146.6z"
          />
        </g>
        <g id="_Group_2">
          <path
            id="_Compound_Path_5"
            d="M312.5,249.2h-13.3v36h-13.7v-81.7h13.7v34.6h13.3v-34.6h13.9v81.7h-13.9V249.2z"
          />
          <path
            id="_Compound_Path_6"
            d="M375.3,203.5v61.8c0,12.7-5.4,20.9-19.4,20.9c-14.5,0-20.5-8.2-20.5-20.9v-61.8h13.7
		v63.2c0,4.8,1.9,8.1,6.8,8.1s6.8-3.3,6.8-8.1v-63.2H375.3z"
          />
          <path
            id="_Compound_Path_7"
            d="M395.9,233.9v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12.1L395.9,233.9z"
          />
          <path
            id="_Compound_Path_8"
            d="M453.9,241.6h19.5v43.6h-9.9v-8.9c-1.8,6.1-5.7,9.9-13.1,9.9
		c-11.8,0-17.2-9.4-17.2-22.1v-39.5c0-12.8,6.1-22.1,20.6-22.1c15.2,0,19.7,8.4,19.7,20.5v7.2h-12.5V222c0-5.1-1.9-7.9-6.9-7.9
		s-7.1,3.5-7.1,8.4v43.9c0,4.9,2,8.4,6.8,8.4c4.5,0,6.8-2.5,6.8-7.8v-14.5h-6.5L453.9,241.6z"
          />
          <path
            id="_Compound_Path_9"
            d="M482.5,203.5h32.8v11.2h-19.1v23.4h13.6v11.1h-13.6v24.8h19.1v11.2h-32.8L482.5,203.5z"
          />
          <path
            id="_Compound_Path_10"
            d="M537.6,247.8v37.5h-13.8v-81.7h20c13.9,0,18.9,6.9,18.9,18.3v10.5
		c0,8.8-3.1,14-11,15.8l13.1,37.1h-14.4L537.6,247.8z M537.6,214.8v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12.1c0-4.5-2-6.6-6.8-6.6
		L537.6,214.8z"
          />
        </g>
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <>
              <path
                d="m0 0v-10.161c-.009-.07-.035-.154-.035-.229 0-.087.026-.166.035-.24.105-2.514 2.158-4.518 4.688-4.566.031 0 .057-.018.092-.018s.079.018.118.018h119.21c.03 0 .065-.018.1-.018s.07.018.106.018c2.604.048 4.683 2.166 4.701 4.771 0 .009.017.018.017.035 0 0-.017.018-.017.036v11.499c67.108 21.998 117.38 76.388 128.436 142.671.026.141.044.273.066.395.039.233.065.443.065.666 0 2.667-2.148 4.821-4.819 4.821h-377.665-2.271c-2.68 0-4.833-2.154-4.833-4.821l.25-2.166c11.613-66.915 63.266-121.608 131.756-142.711"
                transform="translate(295.7782 115.9029)"
              />
              <path
                d="m0 0c-1.566-2.228-38.273-55.075.82-97.807 17.928-19.613 16.371-36.918 11.254-48.606h25.076c5.078 17.257 2.983 38.9-17.376 61.144-28.804 31.488.369 74.05.807 74.708 3.439 4.855 1.597 11.113-4.07 14.034-5.687 2.903-13.059 1.351-16.511-3.473"
                transform="translate(424.6834 427.7575)"
              />
              <path
                d="m0 0h25.086c5.069 17.262 2.964 38.897-17.394 61.144-28.813 31.493.338 74.033.799 74.731 3.42 4.832 1.609 11.082-4.079 14.012-5.666 2.894-13.051 1.355-16.49-3.474-1.574-2.219-38.313-55.074.816-97.807 17.928-19.617 16.367-36.927 11.262-48.606"
                transform="translate(361.1758 281.3443)"
              />
              <path
                d="m0 0c-1.588-2.228-38.295-55.075.807-97.807 17.937-19.622 16.384-36.927 11.28-48.606h25.076c5.07 17.249 2.974 38.892-17.401 61.144-28.814 31.488.359 74.05.82 74.726 3.407 4.837 1.591 11.095-4.096 14.016-5.667 2.921-13.048 1.36-16.486-3.473"
                transform="translate(273.4994 427.7575)"
              />
            </>
          )}
          <path
            d="m0 0h-40.189v6.876c0 11.386 4.087 15.688 10.314 22.35l15.683 16.546c12.679 13.539 15.477 22.134 15.477 36.756v14.183c0 20.84-10.104 30.734-32.023 30.734-21.486 0-32.45-11.394-32.45-31.813v-17.613h22.354v18.266c0 8.802 4.298 11.389 9.459 11.389 4.719 0 8.806-1.938 8.806-10.963v-12.034c0-12.043-1.078-16.771-9.025-25.148l-13.762-14.612c-13.314-14.192-18.262-23.647-18.262-38.041v-26.865h63.618z"
            transform="translate(146.283 543.7013)"
          />
          <path
            d="m0 0h24.147v-8.411h-13.837v-17.545h10.31v-8.32h-10.31v-27.04h-10.31z"
            transform="translate(208.1402 668.5775)"
          />
          <path
            d="m0 0h8.227l-4.067 24.599h-.093zm-12.933-19.443 11.575 61.316h11.757l11.665-61.316h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
            transform="translate(244.5084 626.7046)"
          />
          <path d="m270.84 668.578h10.31v-61.316h-10.31z" />
          <path
            d="m0 0h-.27l-6.964-39.793h-4.793l-7.686 39.793h-.181v-39.793h-8.501v61.316h12.027l6.694-34.549h.09l5.969 34.549h13.022v-61.316h-9.407z"
            transform="translate(315.5175 647.0542)"
          />
          <path
            d="m0 0-4.885-13.204 4.885-13.201h-7.143l-5.065 13.201 5.065 13.204zm-10.492 0-4.881-13.204 4.881-13.201h-7.142l-5.066 13.201 5.066 13.204z"
            transform="translate(230.2965 555.4916)"
          />
          <path
            d="m0 0h15.646v-8.411h-26.408v8.411l16.19 44.493h-14.562v8.411h25.413v-8.411z"
            transform="translate(245.682 529.7199)"
          />
          <path
            d="m0 0-16.19-2.08v5.788l16.19 3.434zm-21.434-4.341h24.598v-8.412h-14.288v-17.544h10.217v-8.319h-10.217v-18.63h14.288v-8.411h-24.598z"
            transform="translate(288.8367 586.9659)"
          />
          <path
            d="m0 0v-19.08h3.435c3.527 0 5.066 1.806 5.066 5.062v9.045c0 3.345-1.539 4.973-5.066 4.973zm0-24.779v-28.126h-10.31v61.316h15.014c10.399 0 14.196-5.155 14.196-13.747v-7.868c0-6.602-2.35-10.491-8.231-11.845l9.859-27.856h-10.85z"
            transform="translate(307.8375 574.213)"
          />
          <path
            d="m0 0v32.918c0 3.708-1.628 6.331-5.336 6.331-3.616 0-5.244-2.623-5.244-6.331v-32.918c0-3.708 1.628-6.332 5.244-6.332 3.708 0 5.336 2.624 5.336 6.332m-20.89 1.628v29.662c0 9.585 4.703 16.549 15.554 16.549 10.942 0 15.646-6.964 15.646-16.549v-29.662c0-9.496-4.704-16.549-15.646-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(353.2502 535.5079)"
          />
          <path
            d="m0 0 5.062-13.204-5.062-13.201h-7.146l4.885 13.201-4.885 13.204zm-10.491 0 5.063-13.204-5.063-13.201h-7.146l4.885 13.201-4.885 13.204z"
            transform="translate(386.5495 555.4916)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg3 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
      >
        <g>
          <path
            id="_Path_2"
            d="M142.7,288.1c34.2,0,49.1-18.1,49.1-46.1v-29.7c0-18.4-8-30.3-25-34.2
          c14-4.5,23.2-15.8,23.2-32.7v-17.5c0-28.5-13.7-46.1-44.9-46.1c-35.1,0-47.3,20.8-47.3,50.6v17.8h30.9v-20.5
          c0-12.5,3.9-19.6,14.6-19.6s14.6,7.1,14.6,18.1v21.7c0,10.7-7.1,16.4-18.1,16.4h-12.8v25.9h14.3c11.9,0,16.6,5.6,16.6,16.4v33.3
          c0,10.7-4.8,18.2-15.2,18.2c-11.6,0-15.8-7.8-15.8-19.6v-28.8H96v26.5C96,268.5,108.2,288.1,142.7,288.1"
          />
          {!quantitative && (
            <g>
              <path
                id="_Path_3"
                d="M835.3,625c0-28.1-18-51-45.4-51c-13.7,0-30.2,15-39.1,24.2c-9-9.2-24.4-24.2-38-24.2
            c-27.3,0-46.5,22.8-46.5,51c0,13.4,5.2,26.4,14.5,36l0,0l70.1,70.2l70-70.2l-0.1,0C830.1,651.4,835.3,638.4,835.3,625z"
              />
              <g id="_Group_">
                <path
                  id="_Path_4"
                  d="M536.8,845.9h-0.7c-5.3-0.3-9.7-4.3-10.6-9.5l-35.6-207.4l-53.9,100c-3,5.6-10,7.7-15.6,4.7
              c-3.2-1.7-5.4-4.9-5.9-8.5l-22.9-160l-41.9,94.1c-1.8,4.2-6,6.8-10.5,6.9H176.2c-6.4-0.4-11.2-5.8-10.8-12.2
              c0.3-5.8,5-10.5,10.8-10.8h155.4l55.1-123.8c2.6-5.8,9.4-8.4,15.2-5.9c3.6,1.6,6.1,4.9,6.7,8.9l23.6,165l53.2-98.6
              c3-5.6,10-7.7,15.6-4.6c3.1,1.7,5.3,4.7,5.9,8.2l33,192.1L660,385c1.8-6.1,8.3-9.5,14.4-7.7c3.1,0.9,5.6,3.1,7,6l63.2,131.1
              c2.9,5.7,0.6,12.6-5.1,15.5c-5.7,2.9-12.6,0.6-15.5-5.1c-0.1-0.1-0.1-0.3-0.2-0.4L673.6,420L547.8,837.7
              C546.4,842.5,541.9,845.9,536.8,845.9z"
                />
              </g>
            </g>
          )}
          <g id="_Group_2">
            <path
              id="_Compound_Path_"
              d="M306.2,121.8h19.5v43.7h-9.9v-8.9c-1.8,6.1-5.7,9.9-13.1,9.9
            c-11.8,0-17.2-9.4-17.2-22.1v-39.6c0-12.8,6.1-22.1,20.6-22.1c15.2,0,19.7,8.4,19.7,20.5v7.2h-12.5v-8.3c0-5.1-1.9-8-6.9-8
            s-7.1,3.5-7.1,8.4v43.9c0,4.9,2,8.4,6.8,8.4c4.5,0,6.8-2.5,6.8-7.8v-14.4h-6.5L306.2,121.8z"
            />
            <path
              id="_Compound_Path_2"
              d="M334.8,144.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
            c0,12.7-6.3,22.1-20.9,22.1S334.8,157,334.8,144.3z M362.6,146.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
            c0,4.9,2.2,8.4,7,8.4S362.6,151.4,362.6,146.5z"
            />
            <path
              id="_Compound_Path_3"
              d="M385.4,144.3v-39.5c0-12.8,6.3-22.1,20.7-22.1S427,92,427,104.8v39.5
            c0,12.7-6.3,22.1-20.9,22.1S385.4,157,385.4,144.3z M413.3,146.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
            c0,4.9,2.2,8.4,7,8.4S413.3,151.4,413.3,146.5z"
            />
            <path
              id="_Compound_Path_4"
              d="M477.2,105.6v37.8c0,12.5-5.2,21.9-19.9,21.9h-21.2V83.7h21.2
            C472,83.7,477.2,93,477.2,105.6z M455.6,154.2c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3H455.6z"
            />
            <path
              id="_Compound_Path_5"
              d="M531.9,129.4h-13.3v36.1h-13.7V83.7h13.8v34.6h13.3V83.7h13.9v81.7h-13.9V129.4z"
            />
            <path
              id="_Compound_Path_6"
              d="M554.8,83.7h32.8v11.2h-19v23.4h13.6v11.1h-13.7v24.8h19v11.2h-32.8L554.8,83.7z"
            />
            <path
              id="_Compound_Path_7"
              d="M594,165.4l15.4-81.7h15.7l15.5,81.7h-14.1l-2.5-14.9h-14.6l-2.4,14.9H594z
            M611.2,139.5h11l-5.4-32.8h-0.1L611.2,139.5z"
            />
            <path
              id="_Compound_Path_8"
              d="M647.5,83.7h13.7v70.5h16.4v11.2h-30.1V83.7z"
            />
            <path
              id="_Compound_Path_9"
              d="M675.7,83.7h36.5v11.2h-11.3v70.5h-13.9V94.9h-11.3V83.7z"
            />
            <path
              id="_Compound_Path_10"
              d="M746.9,129.4h-13.3v36.1h-13.7V83.7h13.7v34.6h13.3V83.7h13.9v81.7h-13.9V129.4z"
            />
          </g>
          <g id="_Group_3">
            <path
              id="_Compound_Path_11"
              d="M283.4,285.3l15.4-81.7h15.7l15.5,81.7H316l-2.5-15h-14.6l-2.4,15H283.4z
            M300.7,259.4h11l-5.4-32.8h-0.1L300.7,259.4z"
            />
            <path
              id="_Compound_Path_12"
              d="M348.5,233.9v51.4H337v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12.1L348.5,233.9z"
            />
            <path
              id="_Compound_Path_13"
              d="M426.9,225.5v37.9c0,12.5-5.2,21.9-19.9,21.9h-21.2v-81.7H407
            C421.7,203.5,426.9,212.8,426.9,225.5z M405.3,274.1c5.7,0,7.8-3.4,7.8-8.3V223c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3L405.3,274.1z"
            />
            <path
              id="_Compound_Path_14"
              d="M479.5,234.8l-7.7,50.5h-12.9l-11-81.7h13.3l6.4,51.8h0.1l6.9-51.8h11.2l7.6,51.8h0.1
            l6.3-51.8h11.6l-10.6,81.7h-13l-8.1-50.5L479.5,234.8z"
            />
            <path
              id="_Compound_Path_15"
              d="M518.4,203.5h32.8v11.2h-19v23.4h13.6v11.1h-13.7v24.8h19v11.2h-32.8V203.5z"
            />
            <path
              id="_Compound_Path_16"
              d="M559.7,203.5h13.8v70.5h16.4v11.2h-30.1V203.5z"
            />
            <path
              id="_Compound_Path_17"
              d="M597.4,203.5h13.7v70.5h16.4v11.2h-30.1V203.5z"
            />
            <path id="_Compound_Path_18" d="M625.7,237H645v11h-19.3V237z" />
            <path
              id="_Compound_Path_19"
              d="M653.2,203.5h19.9c13.7,0,18.3,6.4,18.3,18v8.3c0,6.9-2.5,11.2-8.2,13
            c6.9,1.6,10.2,6.1,10.2,13.6v10.9c0,11.6-5.2,18-18.9,18h-21.3V203.5z M666.9,238h4.8c4.5,0,6.5-2.3,6.5-6.6v-10
            c0-4.5-2-6.6-6.6-6.6h-4.7V238z M666.9,248.5V274h6c4.6,0,6.8-2.3,6.8-6.6v-12.3c0-4.3-2-6.6-6.9-6.6H666.9z"
            />
            <path
              id="_Compound_Path_20"
              d="M701.5,203.5h32.8v11.2h-19v23.4h13.6v11.1h-13.7v24.8h19v11.2h-32.7V203.5z"
            />
            <path
              id="_Compound_Path_21"
              d="M742.9,203.5h13.7v81.7h-13.7V203.5z"
            />
            <path
              id="_Compound_Path_22"
              d="M777.3,233.9v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12L777.3,233.9z"
            />
            <path
              id="_Compound_Path_23"
              d="M835.3,241.6h19.5v43.6H845v-8.9c-1.8,6.1-5.7,9.9-13.1,9.9
            c-11.8,0-17.2-9.4-17.2-22.1v-39.5c0-12.8,6.2-22.1,20.6-22.1c15.2,0,19.7,8.4,19.7,20.5v7.2h-12.6V222c0-5.1-1.9-8-6.9-8
            s-7.1,3.5-7.1,8.4v43.9c0,4.9,2,8.4,6.8,8.4c4.5,0,6.8-2.5,6.8-7.8v-14.4h-6.5V241.6z"
            />
          </g>
        </g>
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <>
              <path
                d="m0 0c0 20.333-13.047 36.819-32.809 36.819-9.881 0-21.801-10.821-28.274-17.477-6.472 6.664-17.603 17.494-27.488 17.494-19.762 0-33.611-16.487-33.611-36.828 0-10.168 4.004-19.371 10.485-26.039l50.659-50.75 50.587 50.693-.039.038c6.481 6.666 10.49 15.877 10.49 26.05"
                transform="translate(616.6271 278.3301)"
              />
              <path
                d="m0 0c-.171 0-.342.004-.517.016-3.851.233-7.031 3.091-7.684 6.895l-25.73 149.862-38.979-72.268c-1.706-3.166-5.272-4.87-8.776-4.24-3.539.63-6.267 3.456-6.78 7.008l-16.546 115.657-30.274-68.001c-1.338-3-4.315-4.934-7.6-4.934h-117.666c-4.596 0-8.319 3.725-8.319 8.317 0 4.594 3.723 8.319 8.319 8.319h112.262l39.822 89.444c1.508 3.386 5.074 5.362 8.749 4.856 3.671-.513 6.561-3.39 7.087-7.061l17.06-119.255 38.439 71.27c1.684 3.131 5.162 4.842 8.671 4.261 3.499-.573 6.249-3.305 6.85-6.802l23.827-138.796 86.847 288.484c.992 3.285 3.895 5.627 7.312 5.894 3.429.255 6.661-1.587 8.148-4.677l45.697-94.735c1.996-4.137.259-9.109-3.876-11.104-4.136-1.998-9.114-.261-11.109 3.877l-36.405 75.471-90.869-301.838c-1.062-3.532-4.311-5.92-7.96-5.92"
                transform="translate(400.9528 118.6969)"
              />
            </>
          )}
          <path
            d="m0 0c24.722 0 35.462 13.115 35.462 33.31v21.488c0 13.323-5.802 21.926-18.051 24.715 10.1 3.219 16.762 11.391 16.762 23.638v12.681c0 20.629-9.886 33.308-32.45 33.308-25.366 0-34.176-15.036-34.176-36.53v-12.891h22.348v14.826c0 9.025 2.803 14.179 10.539 14.179 7.74 0 10.521-5.154 10.521-13.105v-15.689c0-7.739-5.153-11.815-13.1-11.815h-9.249v-18.707h10.324c8.591 0 12.025-4.076 12.025-11.815v-24.07c0-7.729-3.434-13.113-10.955-13.113-8.381 0-11.394 5.594-11.394 14.187v20.846h-22.335v-19.122c0-22.14 8.801-36.321 33.729-36.321"
            transform="translate(115.706 521.7384)"
          />
          <path
            d="m0 0v-19.169h4.522c3.434 0 5.062 1.716 5.062 4.973v9.223c0 3.256-1.535 4.973-5.155 4.973zm0 7.868h3.615c3.349 0 4.885 1.72 4.885 4.977v7.505c0 3.345-1.536 4.974-4.973 4.974h-3.527zm-10.31 25.867h14.921c10.31 0 13.748-4.795 13.748-13.477v-6.24c0-5.154-1.902-8.408-6.151-9.766 5.155-1.177 7.687-4.611 7.687-10.218v-8.141c0-8.682-3.89-13.474-14.2-13.474h-16.005z"
            transform="translate(217.8874 634.8229)"
          />
          <path
            d="m0 0v32.918c0 3.708-1.628 6.332-5.336 6.332-3.616 0-5.244-2.624-5.244-6.332v-32.918c0-3.708 1.628-6.331 5.244-6.331 3.708 0 5.336 2.623 5.336 6.331m-20.89 1.628v29.661c0 9.586 4.703 16.55 15.554 16.55 10.943 0 15.646-6.964 15.646-16.55v-29.661c0-9.496-4.703-16.549-15.646-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(263.8432 621.4408)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.316h10.129l11.124-35.182v35.182h8.589v-61.316h-9.04z"
            transform="translate(288.7311 645.766)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.316h10.129l11.124-35.182v35.182h8.59v-61.316h-9.041z"
            transform="translate(324.4662 645.766)"
          />
          <path
            d="m0 0h24.599v-8.411h-14.289v-17.545h10.218v-8.32h-10.218v-18.629h14.289v-8.411h-24.599z"
            transform="translate(351.5229 668.558)"
          />
          <path
            d="m0 0v8.23h9.588v-8.411c0-3.438 1.536-5.425 5.063-5.425 3.256 0 4.703 2.168 4.703 5.425v2.35c0 3.526-1.447 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.59 9.315-8.59 16.368v2.08c0 7.597 4.43 13.475 14.47 13.475 10.31 0 14.378-5.064 14.378-13.926v-4.974h-9.404v5.336c0 3.527-1.629 5.244-4.885 5.244-2.894 0-4.882-1.628-4.882-5.066v-1.266c0-3.434 1.899-5.425 4.882-8.319l6.602-6.513c5.606-5.695 8.319-9.133 8.319-15.913v-2.987c0-8.411-4.519-14.377-15.01-14.377s-14.562 5.877-14.562 13.926"
            transform="translate(396.607 620.4457)"
          />
          <path
            d="m0 0h8.227l-4.067 24.599h-.092zm-12.933-19.443 11.575 61.316h11.757l11.665-61.316h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
            transform="translate(442.0223 626.685)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.316h10.129l11.124-35.182v35.182h8.589v-61.316h-9.04z"
            transform="translate(477.0358 645.766)"
          />
          <path
            d="m0 0h27.403v-8.411h-8.5v-52.905h-10.403v52.905h-8.5z"
            transform="translate(502.9162 668.558)"
          />
          <path
            d="m0 0-16.19-2.08v5.788l16.19 3.435zm-21.434-4.341h24.598v-8.411h-14.288v-17.545h10.217v-8.319h-10.217v-18.629h14.288v-8.412h-24.598z"
            transform="translate(556.5587 672.8988)"
          />
          <path
            d="m0 0h24.598v-8.411h-14.288v-17.545h10.217v-8.319h-10.217v-18.63h14.288v-8.411h-24.598z"
            transform="translate(207.5775 582.6049)"
          />
          <path
            d="m0 0h27.403v-8.411h-8.501v-52.905h-10.402v52.905h-8.5z"
            transform="translate(236.5293 582.6049)"
          />
          <path
            d="m0 0v-19.17h4.522c3.435 0 5.063 1.717 5.063 4.974v9.222c0 3.257-1.536 4.974-5.155 4.974zm0 7.868h3.616c3.348 0 4.885 1.72 4.885 4.976v7.506c0 3.345-1.537 4.973-4.974 4.973h-3.527zm-10.31 25.866h14.921c10.31 0 13.748-4.795 13.748-13.477v-6.239c0-5.155-1.901-8.408-6.15-9.766 5.155-1.177 7.686-4.611 7.686-10.218v-8.142c0-8.681-3.889-13.474-14.199-13.474h-16.006z"
            transform="translate(294.5435 548.8705)"
          />
          <path d="m319.609 582.605h10.31v-61.316h-10.31z" />
          <path
            d="m0 0h24.599v-8.411h-14.289v-17.545h10.218v-8.319h-10.218v-18.63h14.289v-8.411h-24.599z"
            transform="translate(335.8948 582.6049)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.316h10.129l11.124-35.182v35.182h8.59v-61.316h-9.042z"
            transform="translate(374.7053 559.8129)"
          />
          <path d="m401.126 553.936h14.47v-8.32h-14.47z" />
          <path
            d="m0 0v4.974l6.51 4.792h4.522l6.51-4.792v-4.974l-8.682 2.621zm-4.252-2.261h24.598v-8.412h-14.288v-17.544h10.218v-8.319h-10.218v-18.63h14.288v-8.411h-24.598z"
            transform="translate(425.1011 584.8662)"
          />
          <path
            d="m0 0h27.403v-8.411h-8.501v-52.905h-10.401v52.905h-8.501z"
            transform="translate(449.8014 582.6049)"
          />
          <path
            d="m0 0v-19.08h3.434c3.527 0 5.067 1.806 5.067 5.062v9.045c0 3.345-1.54 4.973-5.067 4.973zm0-24.779v-28.126h-10.31v61.316h15.014c10.398 0 14.196-5.155 14.196-13.747v-7.868c0-6.602-2.351-10.491-8.231-11.845l9.859-27.856h-10.851z"
            transform="translate(492.3197 574.1934)"
          />
          <path
            d="m0 0h24.599v-8.411h-14.288v-17.545h10.217v-8.319h-10.217v-18.63h14.288v-8.411h-24.599z"
            transform="translate(516.8383 582.6049)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg4 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M301.2,165.4v5.6l25.9,4.8v-10.3l-10.1-1.9c7-3.4,10.1-10.4,10.1-19.3v-39.6c0-12.8-6.3-22.1-20.8-22.1
        s-20.7,9.3-20.7,22.1v39.6C285.5,155.4,290.2,163.5,301.2,165.4 M299.3,102.6c0-4.9,2.2-8.4,7-8.4s7.1,3.5,7.1,8.4v44.6
        c0,4.8-2.2,8.4-7.1,8.4s-7-3.6-7-8.4V102.6z"
        />
        <path
          d="M356.7,166.4c14,0,19.4-8.2,19.4-20.9V83.7h-12.7v63.2c0,4.8-1.9,8.1-6.8,8.1s-6.8-3.3-6.8-8.1V83.7h-13.8v61.9
        C336.2,158.2,342.2,166.4,356.7,166.4"
        />
        <path
          d="M396.5,150.5H411l2.5,15h14.1l-15.5-81.8h-15.7L381,165.4h13L396.5,150.5z M403.7,106.7h0.1l5.4,32.8h-11
        L403.7,106.7z"
        />
        <polygon points="464.7,154.2 448.3,154.2 448.3,83.7 434.6,83.7 434.6,165.4 464.7,165.4 " />
        <rect x="471.1" y="83.7" width="13.7" height="81.8" />
        <polygon points="502.6,165.4 516.5,165.4 516.5,94.9 527.8,94.9 527.8,83.7 491.3,83.7 491.3,94.9 502.6,94.9 " />
        <polygon
          points="547.3,165.4 561.1,165.4 561.1,134.3 576.2,83.7 563.1,83.7 554.8,114.7 554.7,114.7 546.3,83.7 
        532,83.7 547.3,134.3 "
        />
        <polygon
          points="318.3,274.1 299.3,274.1 299.3,249.3 312.9,249.3 312.9,238.2 299.3,238.2 299.3,214.8 318.3,214.8 
        318.3,203.6 285.5,203.6 285.5,285.3 318.3,285.3 "
        />
        <path
          d="M367.9,263.4v-37.9c0-12.7-5.2-22-19.9-22h-21.2v81.8H348C362.7,285.3,367.9,275.9,367.9,263.4 M340.5,274
        v-59.2h5.8c5.7,0,7.8,3.4,7.8,8.2v42.8c0,4.9-2.2,8.3-7.8,8.3L340.5,274z"
        />
        <path
          d="M376.9,203.6v61.9c0,12.7,6,20.9,20.5,20.9c14,0,19.4-8.2,19.4-20.9v-61.9h-12.6v63.2c0,4.8-1.9,8.1-6.8,8.1
        s-6.8-3.2-6.8-8.1v-63.2H376.9z"
        />
        <path
          d="M425.8,264.2c0,12.7,6,22.1,20.5,22.1s19.4-8.7,19.4-20.4v-14.1h-12.5v15.1c0,4.8-1.7,8-6.6,8s-7-3.5-7-8.5
        v-43.9c0-4.9,2-8.4,7-8.4s6.6,2.9,6.6,8v10.7h12.5v-9.7c0-12-4.2-20.5-19.4-20.5c-14.5,0-20.5,9.3-20.5,22.1V264.2z"
        />
        <path
          d="M485.4,270.4H500l2.5,15h14.1L501,203.6h-15.7l-15.4,81.8h13L485.4,270.4z M492.6,226.6h0.1l5.4,32.8h-11
        L492.6,226.6z"
        />
        <polygon points="514.9,214.8 526.2,214.8 526.2,285.3 540.1,285.3 540.1,214.8 551.4,214.8 551.4,203.6 514.9,203.6 " />
        <rect x="559" y="203.6" width="13.8" height="81.8" />
        <path
          d="M602.7,286.3c14.6,0,20.8-9.4,20.8-22.1v-39.6c0-12.8-6.3-22.1-20.8-22.1s-20.7,9.3-20.7,22.1v39.6
        C581.9,276.9,588.2,286.3,602.7,286.3 M595.7,222.5c0-4.9,2.2-8.4,7-8.4s7.1,3.5,7.1,8.4v43.9c0,5-2.2,8.5-7.1,8.5s-7-3.5-7-8.5
        V222.5z"
        />
        <polygon
          points="644.1,233.9 660.3,285.3 672.3,285.3 672.3,203.6 660.9,203.6 660.9,250.5 646,203.6 632.6,203.6 
        632.6,285.3 644.1,285.3 "
        />
        <path
          d="M156.6,285.4h32.1v-32.7h13.7v-26.5h-13.7V83.8h-33.3L96.9,231.9v20.8h59.8V285.4z M126.6,226.3l30.3-83h0.3v83
        H126.6z"
        />
        {!quantitative && (
          <g>
            <polygon points="438.3,536.2 259,432.6 259,767.6 438.3,821.7 	" />
            <polygon points="458,536.9 458,821.9 638.5,767.6 638.5,432.6 	" />
            <path d="M779.3,424.1c0.3-11.7-9-21.4-20.8-21.7c-11.7-0.3-21.4,9-21.7,20.8c0,0.3,0,0.6,0,0.9V447h42.4V424.1z" />
            <polygon
              points="742.2,761.7 736.9,761.7 758.1,835.8 779.3,761.7 774,761.7 779.3,761.7 779.3,463.6 774,463.6
          768.8,463.6 763.2,463.6 752.6,463.6 747.4,463.6 742.2,463.6 736.9,463.6 736.9,761.7 	"
            />
            <polygon
              points="677.1,447 657.8,431.8 657.8,776.7 458.6,841.1 449.3,841.1 447.5,841.1 438.3,841.1 239.9,785.7
          239.9,431.8 220.7,447 220.7,799.2 437.4,859.2 447.5,859.2 449.3,859.2 459.5,859.2 659.4,795.7 677.1,790.5 	"
            />
          </g>
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g fill="currentColor">
          {!quantitative && (
            <>
              <path
                d="m0 0-129.612 74.84v-242.106l129.612-39.106z"
                transform="translate(327.8633 342.4883)"
              />
              <path
                d="m0 0v-205.96l130.453 39.22v242.067z"
                transform="translate(342.1162 341.9927)"
              />
              <path
                d="m0 0h-3.807l15.341-53.596 15.314 53.596h-3.806 3.806v215.402h-3.806-3.807-4.034-7.632-3.762-3.807-3.815v-215.402z"
                transform="translate(547.4578 179.5159)"
              />
              <path
                d="m0 0-13.893 10.977v-249.25l-144.014-46.535h-6.666-1.316-6.657l-143.373 40.053v255.732l-13.903-10.977v-254.504l156.618-43.356h7.315 1.316 7.315l144.496 45.877 12.762 3.754z"
                transform="translate(500.4091 406.9305)"
              />
            </>
          )}
          <g clipPath="url(#a)">
            {!quantitative && (
              <path
                d="m0 0c0 8.477-6.868 15.34-15.323 15.34-8.482 0-15.341-6.863-15.341-15.34v-16.529h30.664z"
                transform="translate(574.3152 423.4551)"
              />
            )}
            <path
              d="m0 0 21.919 59.964h.219v-59.964zm21.709-42.759h23.208v23.638h9.894v19.121h-9.894v102.956h-24.076l-42.33-107.034v-15.043h43.198z"
              transform="translate(98.9091 566.4712)"
            />
            <path
              d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.434-4.341h24.602v-8.411h-14.292v-17.545h10.221v-8.32h-10.221v-18.628h14.292v-8.412h-24.602z"
              transform="translate(241.2479 672.9184)"
            />
            <path
              d="m0 0c4.248 0 5.877 2.531 5.877 6.239v32.104c0 3.619-1.629 6.15-5.877 6.15h-4.344v-44.493zm16.187 36.444v-28.395c0-9.407-3.886-16.46-14.921-16.46h-15.92v61.316h15.92c11.035 0 14.921-6.965 14.921-16.461"
              transform="translate(264.5967 615.673)"
            />
            <path
              d="m0 0v-46.395c0-9.496-4.07-15.643-14.558-15.643-10.857 0-15.38 6.147-15.38 15.643v46.395h10.31v-47.391c0-3.615 1.451-6.057 5.07-6.057 3.612 0 5.062 2.442 5.062 6.057v47.391z"
              transform="translate(316.6174 668.5775)"
            />
            <path
              d="m0 0v29.661c0 9.585 4.522 16.55 15.379 16.55 11.392 0 14.559-6.332 14.559-15.373v-7.235h-9.407v8.049c0 3.797-1.266 5.969-4.974 5.969s-5.247-2.623-5.247-6.332v-32.917c0-3.708 1.539-6.332 5.247-6.332s4.974 2.35 4.974 5.97v11.305h9.407v-10.584c0-8.771-3.619-15.28-14.559-15.28-10.857 0-15.379 7.053-15.379 16.549"
              transform="translate(322.5071 623.0886)"
            />
            <path
              d="m0 0h8.23l-4.07 24.599h-.089zm-12.93-19.443 11.575 61.316h11.754l11.665-61.316h-10.577l-1.902 11.213h-10.94l-1.812-11.213z"
              transform="translate(368.4727 626.7046)"
            />
            <path
              d="m0 0h27.4v-8.411h-8.503v-52.905h-10.4v52.905h-8.497z"
              transform="translate(389.1057 668.5775)"
            />
            <path d="m421.308 668.578h10.31v-61.316h-10.31z" />
            <path
              d="m0 0v32.918c0 3.708-1.628 6.332-5.336 6.332-3.619 0-5.248-2.624-5.248-6.332v-32.918c0-3.708 1.629-6.331 5.248-6.331 3.708 0 5.336 2.623 5.336 6.331m-20.893 1.628v29.661c0 9.586 4.706 16.55 15.557 16.55 10.945 0 15.646-6.964 15.646-16.55v-29.661c0-9.496-4.701-16.549-15.646-16.549-10.851 0-15.557 7.053-15.557 16.549"
              transform="translate(458.49 621.4604)"
            />
            <path
              d="m0 0v-38.524h-8.682v61.316h10.133l11.124-35.182v35.182h8.592v-61.316h-9.044z"
              transform="translate(483.3712 645.7855)"
            />
            <path
              d="m0 0c4.249 0 5.877 2.532 5.877 6.239v32.104c0 3.619-1.628 6.15-5.877 6.15h-4.344v-44.493zm16.187 36.444v-28.395c0-9.407-3.886-16.46-14.921-16.46h-15.92v61.315h15.92c11.035 0 14.921-6.964 14.921-16.46"
              transform="translate(235.9638 529.7199)"
            />
            <path
              d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.319h-10.221v-18.629h14.291v-8.412h-24.601z"
              transform="translate(258.0472 582.6244)"
            />
            <path
              d="m0 0v33.461c0 3.708-1.628 6.332-5.336 6.332-3.619 0-5.248-2.624-5.248-6.332v-33.461c0-3.616 1.629-6.332 5.248-6.332 3.708 0 5.336 2.716 5.336 6.332m-9.133-17.815v4.159c-8.23 1.448-11.76 7.505-11.76 15.828v29.661c0 9.585 4.706 16.55 15.557 16.55 10.946 0 15.646-6.965 15.646-16.55v-29.661c0-6.695-2.353-11.938-7.594-14.47l7.594-1.447v-7.689z"
              transform="translate(324.5712 534.9641)"
            />
            <path
              d="m0 0v-46.395c0-9.496-4.07-15.643-14.558-15.643-10.857 0-15.38 6.147-15.38 15.643v46.395h10.31v-47.39c0-3.616 1.45-6.058 5.07-6.058 3.612 0 5.062 2.442 5.062 6.058v47.39z"
              transform="translate(370.7087 582.6244)"
            />
            <path
              d="m0 0h8.23l-4.07 24.599h-.089zm-12.93-19.443 11.575 61.316h11.754l11.665-61.316h-10.577l-1.902 11.213h-10.94l-1.812-11.213z"
              transform="translate(386.5521 540.7515)"
            />
            <path
              d="m0 0h10.31v-52.904h12.301v-8.412h-22.611z"
              transform="translate(412.8839 582.6244)"
            />
            <path d="m440.201 582.624h10.31v-61.316h-10.31z" />
            <path
              d="m0 0h27.401v-8.411h-8.504v-52.905h-10.4v52.905h-8.497z"
              transform="translate(455.313 582.6244)"
            />
            <path
              d="m0 0-16.187-2.08v5.788l16.187 3.434zm-21.434-4.341h24.601v-8.412h-14.291v-17.544h10.221v-8.319h-10.221v-18.63h14.291v-8.411h-24.601z"
              transform="translate(508.9561 586.9659)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Sdg5 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M302.8,166.4c7.5,0,11.4-3.7,13.1-9.9v8.9h9.9v-43.7h-19.5v10.8h6.5v14.5c0,5.3-2.3,7.8-6.8,7.8
        c-4.7,0-6.8-3.5-6.8-8.4v-43.9c0-4.9,2.2-8.4,7.1-8.4s6.9,2.9,6.9,8v8.3h12.5v-7.2c0-12.1-4.5-20.5-19.6-20.5
        c-14.5,0-20.6,9.3-20.6,22.1v39.6C285.5,157,291,166.4,302.8,166.4"
        />
        <polygon
          points="367.6,154.2 348.6,154.2 348.6,129.4 362.2,129.4 362.2,118.3 348.6,118.3 348.6,94.9 367.6,94.9 
        367.6,83.7 334.9,83.7 334.9,165.4 367.6,165.4 "
        />
        <polygon
          points="387.8,114.1 403.9,165.4 416,165.4 416,83.7 404.5,83.7 404.5,130.6 389.7,83.7 376.2,83.7 
        376.2,165.4 387.8,165.4 "
        />
        <path
          d="M466.1,143.5v-37.9c0-12.7-5.2-22-19.9-22H425v81.8h21.2C460.9,165.4,466.1,156,466.1,143.5 M438.7,154.1V94.9
        h5.8c5.7,0,7.8,3.4,7.8,8.2v42.8c0,4.9-2.2,8.3-7.8,8.3L438.7,154.1z"
        />
        <polygon
          points="508,154.2 488.9,154.2 488.9,129.4 502.6,129.4 502.6,118.3 488.9,118.3 488.9,94.9 508,94.9 508,83.7 
        475.2,83.7 475.2,165.4 508,165.4 "
        />
        <path
          d="M530.2,127.9l12.8,37.5h14.5l-13.1-37.1c7.8-1.8,11-7,11-15.8V102c0-11.5-5.1-18.3-18.9-18.3h-20v81.8h13.8
        L530.2,127.9z M530.2,94.9h4.6c4.7,0,6.8,2.2,6.8,6.6v12c0,4.4-2,6.8-6.8,6.8h-4.6V94.9z"
        />
        <polygon
          points="318.3,274.1 299.3,274.1 299.3,249.3 312.9,249.3 312.9,238.2 299.3,238.2 299.3,214.8 318.3,214.8 
        318.3,203.6 285.5,203.6 285.5,285.3 318.3,285.3 "
        />
        <path
          d="M342.5,285.3v5.6l25.9,4.8v-10.2l-10.1-1.9c7-3.4,10.1-10.4,10.1-19.3v-39.6c0-12.8-6.3-22.1-20.9-22.1
        s-20.7,9.3-20.7,22.1v39.6C326.8,275.3,331.5,283.4,342.5,285.3 M340.5,222.5c0-4.9,2.2-8.4,7-8.4s7.1,3.5,7.1,8.4v44.6
        c0,4.8-2.2,8.4-7.1,8.4s-7-3.6-7-8.4V222.5z"
        />
        <path
          d="M377.3,203.6v61.9c0,12.7,6,20.9,20.5,20.9c14,0,19.4-8.2,19.4-20.9v-61.9h-12.6v63.2c0,4.8-1.9,8.1-6.8,8.1
        s-6.8-3.2-6.8-8.1v-63.2H377.3z"
        />
        <path
          d="M439.4,270.4H454l2.5,15h14.1l-15.5-81.8h-15.7L424,285.3h13L439.4,270.4z M446.6,226.6h0.1l5.4,32.8h-11
        L446.6,226.6z"
        />
        <polygon points="477.4,203.6 477.4,285.3 507.5,285.3 507.5,274.1 491.1,274.1 491.1,203.6 " />
        <rect x="514.8" y="203.6" width="13.8" height="81.8" />
        <polygon points="561.3,285.3 561.3,214.8 572.6,214.8 572.6,203.6 536.1,203.6 536.1,214.8 547.4,214.8 547.4,285.3 " />
        <polygon
          points="593.1,285.3 606.8,285.3 606.8,254.2 622,203.6 608.9,203.6 600.6,234.5 600.4,234.5 592.1,203.6 
        577.8,203.6 593.1,254.2 "
        />
        <path
          d="M159.4,147.6c-13.4,0-23.2,4.8-28.6,14h-0.3v-50.3h58.3V83.7H99.7v113.6h30.9v-4.5c0-11.9,5.4-18.4,14.9-18.4
        c10.4,0,14.6,7.1,14.6,18.2v48.8c0,10.7-3.9,18.1-14.3,18.1c-11.6,0-15.8-7.7-15.8-19.6v-25.3H99.1v22.9c0,30.6,12.2,50.3,46.7,50.3
        c34.2,0,48.2-18.1,48.2-46.1v-49.4C193.9,160.4,177.6,147.6,159.4,147.6"
        />

        {!quantitative && (
          <g>
            <path
              d="M728.3,378.4H604.1c-0.9,0-1.6,0.7-1.6,1.6v41.3c0,0.9,0.7,1.6,1.6,1.6h49.5l-55,55
          c-28.6-22.5-63.9-34.8-100.4-34.8c-89.8,0-162.8,73-162.8,162.8c0,82.6,61.9,151,141.8,161.4v47.6h-49c-0.9,0-1.6,0.7-1.6,1.5
          c0,0,0,0,0,0v44.3c0,0.9,0.7,1.6,1.6,1.6c0,0,0,0,0,0h49V909c0,0.9,0.7,1.6,1.6,1.6c0,0,0,0,0,0h44.2c0.9,0,1.6-0.7,1.6-1.6v0
          v-46.8h49c0.9,0,1.6-0.7,1.6-1.6c0,0,0,0,0,0v-44.3c0-0.9-0.7-1.6-1.6-1.6l0,0h-49v-48.4C601.9,753.8,661,686.6,661,605.8
          c0-33.5-10.4-66.2-29.7-93.6l54.2-54.2v46.2c0,0.9,0.7,1.6,1.6,1.6h41.3c0.9,0,1.6-0.7,1.6-1.6V380
          C730,379.1,729.2,378.4,728.3,378.4C728.3,378.4,728.3,378.4,728.3,378.4 M498.2,725.7c-66.2,0-119.8-53.6-119.8-119.8
          c0-66.2,53.6-119.8,119.8-119.8c66.2,0,119.8,53.6,119.8,119.8C618,672,564.4,725.6,498.2,725.7"
            />
            <path
              d="M572.7,556.7H427.3c-0.8,0-1.5,0.6-1.6,1.4v35.2c0,0.8,0.7,1.5,1.6,1.4c0,0,0,0,0,0h145.3
          c0.8,0.1,1.6-0.6,1.6-1.4c0,0,0,0,0,0v-35.2C574.2,557.2,573.5,556.6,572.7,556.7"
            />
            <path
              d="M572.7,619.5H427.3c-0.8,0-1.5,0.6-1.6,1.5v35.2c0,0.8,0.7,1.5,1.6,1.4c0,0,0,0,0,0h145.3
          c0.8,0.1,1.6-0.6,1.6-1.4c0,0,0,0,0,0v-35.2C574.2,620.1,573.5,619.4,572.7,619.5"
            />
          </g>
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)" fill="currentColor">
          {!quantitative && (
            <>
              <path
                d="m0 0c-47.746 0-86.58 38.847-86.58 86.589 0 47.748 38.834 86.591 86.58 86.591 47.75 0 86.593-38.843 86.593-86.591 0-47.742-38.843-86.589-86.593-86.589m166.292 250.967h-89.817c-.614 0-1.14-.509-1.14-1.145v-29.846c0-.64.526-1.149 1.14-1.149h35.765l-39.711-39.72c-20.004 15.715-45.172 25.121-72.529 25.121-64.859 0-117.64-52.772-117.64-117.639 0-59.723 44.747-109.147 102.456-116.624v-34.392h-35.426c-.658 0-1.158-.508-1.158-1.135v-31.991c0-.636.5-1.143 1.158-1.143h35.426v-33.845c0-.632.51-1.141 1.141-1.141h31.975c.636 0 1.158.509 1.158 1.141v33.845h35.422c.632 0 1.14.507 1.14 1.143v31.991c0 .627-.508 1.135-1.14 1.135h-35.422v34.951c55.815 9.155 98.544 57.699 98.544 116.065 0 25.177-7.969 48.511-21.485 67.662l39.146 39.153v-33.405c0-.632.526-1.14 1.157-1.14h29.84c.64 0 1.166.508 1.166 1.14v89.823c0 .636-.526 1.145-1.166 1.145"
                transform="translate(367.4475 205.5664)"
              />
              <path
                d="m0 0h-105.025c-.632 0-1.141-.467-1.141-1.024v-25.426c0-.596.509-1.043 1.141-1.043h105.025c.653 0 1.163.447 1.163 1.043v25.426c0 .557-.51 1.024-1.163 1.024"
                transform="translate(420.3371 327.6981)"
              />
              <path
                d="m0 0h-105.025c-.632 0-1.141-.48-1.141-1.059v-25.425c0-.571.509-1.027 1.141-1.027h105.025c.653 0 1.163.456 1.163 1.027v25.425c0 .579-.51 1.059-1.163 1.059"
                transform="translate(420.3371 282.2984)"
              />
            </>
          )}
          <path
            d="m0 0c-9.666 0-16.762-3.434-20.63-10.1h-.219v36.322h42.128v19.985h-64.468v-82.103h22.34v3.237c0 8.595 3.876 13.323 10.744 13.323 7.526 0 10.543-5.166 10.543-13.121v-35.243c0-7.74-2.797-13.108-10.323-13.108-8.385 0-11.385 5.586-11.385 14.178v18.27h-22.367v-16.546c0-22.135 8.816-36.322 33.752-36.322 24.717 0 34.813 13.108 34.813 33.313v35.677c0 22.998-11.815 32.238-24.928 32.238"
            transform="translate(127.323 623.2906)"
          />
          <path
            d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.434-4.341h24.602v-8.411h-14.292v-17.545h10.221v-8.32h-10.221v-18.628h14.292v-8.412h-24.602z"
            transform="translate(237.4632 672.9184)"
          />
          <path
            d="m0 0h14.654v-32.736h-7.416v6.691c-1.361-4.611-4.255-7.413-9.858-7.413-8.867 0-12.937 7.053-12.937 16.549v29.661c0 9.585 4.617 16.55 15.468 16.55 11.391 0 14.743-6.332 14.743-15.373v-5.428h-9.407v6.242c0 3.797-1.45 5.969-5.158 5.969s-5.337-2.623-5.337-6.332v-32.917c0-3.708 1.54-6.331 5.07-6.331 3.345 0 5.063 1.898 5.063 5.879v10.851h-4.885z"
            transform="translate(260.812 639.9975)"
          />
          <path
            d="m0 0h8.23l-4.07 24.599h-.089zm-12.93-19.443 11.575 61.316h11.754l11.665-61.316h-10.577l-1.902 11.213h-10.94l-1.812-11.213z"
            transform="translate(292.6641 626.7046)"
          />
          <path
            d="m0 0h10.31v-52.905h12.301v-8.411h-22.611z"
            transform="translate(318.9894 668.5775)"
          />
          <path d="m346.313 668.578h10.31v-61.316h-10.31z" />
          <path
            d="m0 0h27.401v-8.411h-8.504v-52.905h-10.4v52.905h-8.497z"
            transform="translate(361.425 668.5775)"
          />
          <path
            d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.434-4.341h24.601v-8.411h-14.291v-17.545h10.221v-8.32h-10.221v-18.628h14.291v-8.412h-24.601z"
            transform="translate(415.0616 672.9184)"
          />
          <path
            d="m0 0h24.602v-8.411h-14.292v-17.545h10.221v-8.32h-10.221v-18.629h14.292v-8.411h-24.602z"
            transform="translate(439.2581 668.5775)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.316h10.132l11.124-35.182v35.182h8.593v-61.316h-9.044z"
            transform="translate(478.0686 645.7855)"
          />
          <path
            d="m0 0h27.401v-8.411h-8.504v-52.905h-10.4v52.905h-8.497z"
            transform="translate(503.9549 668.5775)"
          />
          <path
            d="m0 0v-19.081h3.441c3.523 0 5.062 1.807 5.062 5.063v9.044c0 3.346-1.539 4.974-5.062 4.974zm0-24.78v-28.125h-10.31v61.316h15.016c10.399 0 14.196-5.155 14.196-13.747v-7.868c0-6.602-2.353-10.491-8.229-11.846l9.858-27.855h-10.851z"
            transform="translate(546.4674 660.1661)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.32h-10.221v-18.629h14.291v-8.411h-24.601z"
            transform="translate(570.9925 668.5775)"
          />
          <path
            d="m0 0h10.31v-52.904h12.301v-8.412h-22.611z"
            transform="translate(216.0291 582.6244)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.319h-10.221v-18.629h14.291v-8.412h-24.601z"
            transform="translate(243.3469 582.6244)"
          />
          <path
            d="m0 0v8.23h9.585v-8.411c0-3.438 1.539-5.425 5.069-5.425 3.25 0 4.701 2.168 4.701 5.425v2.35c0 3.527-1.451 5.699-4.612 8.682l-6.061 6.061c-5.877 5.788-8.593 9.315-8.593 16.368v2.08c0 7.597 4.433 13.475 14.469 13.475 10.31 0 14.381-5.063 14.381-13.926v-4.974h-9.407v5.336c0 3.527-1.628 5.244-4.878 5.244-2.894 0-4.885-1.628-4.885-5.066v-1.265c0-3.435 1.896-5.425 4.885-8.32l6.602-6.513c5.603-5.695 8.319-9.133 8.319-15.913v-2.986c0-8.411-4.522-14.377-15.017-14.377-10.487 0-14.558 5.876-14.558 13.925"
            transform="translate(272.4897 534.5121)"
          />
          <path
            d="m0 0v8.23h9.585v-8.411c0-3.438 1.54-5.425 5.069-5.425 3.251 0 4.7 2.168 4.7 5.425v2.35c0 3.527-1.449 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.315-8.593 16.368v2.08c0 7.597 4.434 13.475 14.47 13.475 10.31 0 14.381-5.063 14.381-13.926v-4.974h-9.407v5.336c0 3.527-1.628 5.244-4.879 5.244-2.894 0-4.885-1.628-4.885-5.066v-1.265c0-3.435 1.896-5.425 4.885-8.32l6.602-6.513c5.604-5.695 8.32-9.133 8.32-15.913v-2.986c0-8.411-4.523-14.377-15.017-14.377-10.488 0-14.559 5.876-14.559 13.925"
            transform="translate(322.4579 534.5121)"
          />
          <path
            d="m0 0h24.602v-8.411h-14.292v-17.545h10.221v-8.319h-10.221v-18.629h14.292v-8.412h-24.602z"
            transform="translate(357.4649 582.6244)"
          />
          <path
            d="m0 0-9.044 28.85h10.761l5.699-20.257 5.877 20.257h9.769l-9.044-29.302 10.036-32.014h-10.761l-6.78 23.24-6.513-23.24h-9.769z"
            transform="translate(396.0975 553.7748)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.319h-10.221v-18.629h14.291v-8.412h-24.601z"
            transform="translate(424.7825 582.6244)"
          />
          <path
            d="m0 0v8.23h9.585v-8.411c0-3.438 1.539-5.425 5.069-5.425 3.25 0 4.7 2.168 4.7 5.425v2.35c0 3.527-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.315-8.593 16.368v2.08c0 7.597 4.434 13.475 14.47 13.475 10.31 0 14.381-5.063 14.381-13.926v-4.974h-9.408v5.336c0 3.527-1.628 5.244-4.878 5.244-2.894 0-4.885-1.628-4.885-5.066v-1.265c0-3.435 1.896-5.425 4.885-8.32l6.602-6.513c5.603-5.695 8.319-9.133 8.319-15.913v-2.986c0-8.411-4.522-14.377-15.016-14.377-10.488 0-14.559 5.876-14.559 13.925"
            transform="translate(453.9187 534.5121)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg6 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M151.3,288.1c36,0,49.9-19.6,49.9-50.9v-29.7c0-33-13.1-49.7-37.5-49.7c-14.3,0-22.9,6.6-27.9,16.4h-0.3v-43.4
        c0-12.2,3.9-20.8,16.1-20.8s15.8,7.1,15.8,19.6V143h30.9v-10.8c0-29.7-9.8-50.6-47.3-50.6c-35.7,0-49.1,22.9-49.1,54.4v98.1
        C101.9,265.5,115.6,288.1,151.3,288.1 M135.5,203.3c0.6-11.3,5.4-18.4,16.1-18.4c11.6,0,16.1,7.1,16.1,20.2v35.1
        c0,12.8-4.7,20.2-16.3,20.2c-11.3,0-15.8-7.7-15.8-20.2V203.3z"
        />
        <path
          d="M306.5,165.7c14.6,0,19.4-8.7,19.4-20.4v-14.1h-12.5v15.1c0,4.8-1.7,8-6.6,8s-7-3.5-7-8.4V102
        c0-4.9,2.1-8.4,7-8.4s6.6,2.9,6.6,8v10.7h12.5v-9.7c0-12.1-4.2-20.5-19.4-20.5C292,82,286,91.3,286,104.1v39.6
        C286,156.3,292,165.7,306.5,165.7"
        />
        <polygon points="364.7,153.6 348.3,153.6 348.3,83 334.6,83 334.6,164.8 364.7,164.8 " />
        <polygon
          points="405,153.6 385.9,153.6 385.9,128.7 399.6,128.7 399.6,117.6 385.9,117.6 385.9,94.2 405,94.2 405,83 
        372.2,83 372.2,164.8 405,164.8 "
        />
        <path d="M426.8,149.8h14.6l2.5,15H458L442.5,83h-15.6l-15.4,81.8h13L426.8,149.8z M434,106h0.1l5.4,32.8h-11L434,106z" />
        <polygon
          points="476.5,113.4 492.6,164.8 504.7,164.8 504.7,83 493.2,83 493.2,129.9 478.4,83 464.9,83 464.9,164.8 
        476.5,164.8 "
        />
        <polygon
          points="555.8,164.8 563.5,114.2 563.6,114.2 571.7,164.8 584.7,164.8 595.3,83 583.7,83 577.5,134.9 
        577.3,134.9 569.8,83 558.5,83 551.7,134.9 551.5,134.9 545.2,83 531.9,83 542.9,164.8 "
        />
        <path
          d="M610.9,149.8h14.6l2.5,15h14.1L626.6,83h-15.7l-15.4,81.8h13L610.9,149.8z M618.2,106h0.1l5.4,32.8h-11
        L618.2,106z"
        />
        <polygon points="651.8,164.8 665.6,164.8 665.6,94.2 677,94.2 677,83 640.4,83 640.4,94.2 651.8,94.2 " />
        <polygon
          points="716.2,153.6 697.2,153.6 697.2,128.7 710.8,128.7 710.8,117.6 697.2,117.6 697.2,94.2 716.2,94.2 
        716.2,83 683.4,83 683.4,164.8 716.2,164.8 "
        />
        <path
          d="M737.4,127.2l12.9,37.5h14.5l-13.2-37.2c7.8-1.8,11-7,11-15.8v-10.5c0-11.5-5.1-18.3-18.9-18.3h-20v81.8h13.7
        L737.4,127.2z M737.4,94.2h4.6c4.7,0,6.7,2.2,6.7,6.6v12c0,4.3-2.1,6.8-6.7,6.8h-4.6V94.2z"
        />
        <path
          d="M299.8,270.4h14.6l2.5,15H331l-15.6-81.8h-15.6l-15.4,81.8h13L299.8,270.4z M307.1,226.6h0.1l5.4,32.8h-11
        L307.1,226.6z"
        />
        <polygon
          points="336.7,203.6 336.7,285.3 348.3,285.3 348.3,234 364.4,285.3 376.5,285.3 376.5,203.6 365,203.6 
        365,250.5 350.2,203.6 "
        />
        <path
          d="M386.5,285.3h21.2c14.7,0,19.9-9.4,19.9-22v-37.9c0-12.6-5.2-21.9-19.9-21.9h-21.2L386.5,285.3z M400.2,214.8
        h5.8c5.7,0,7.8,3.4,7.8,8.2v42.8c0,4.9-2.1,8.3-7.8,8.3h-5.8L400.2,214.8z"
        />
        <path
          d="M458.1,256.8v11c0,10.7,5.4,18.6,19.4,18.6s20-8,20-19.2v-4c0-9-3.6-13.6-11.1-21.2l-8.8-8.7
        c-4-3.9-6.5-6.5-6.5-11.1v-1.7c0-4.6,2.6-6.7,6.5-6.7c4.3,0,6.5,2.3,6.5,7v7.1h12.5v-6.6c0-11.8-5.4-18.6-19.2-18.6
        c-13.4,0-19.3,7.8-19.3,18v2.8c0,9.4,3.6,14.1,11.5,21.8l8.1,8.1c4.2,4,6.1,6.9,6.1,11.6v3.1c0,4.3-1.9,7.2-6.3,7.2
        c-4.7,0-6.7-2.6-6.7-7.2v-11.2H458.1z"
        />
        <path
          d="M514.5,285.3l2.4-15h14.6l2.5,15h14.1l-15.6-81.8h-15.7l-15.4,81.8H514.5z M524.2,226.6h0.1l5.4,32.8h-11
        L524.2,226.6z"
        />
        <polygon
          points="583.2,250.5 568.4,203.6 554.9,203.6 554.9,285.3 566.5,285.3 566.5,234 582.6,285.3 594.7,285.3 
        594.7,203.6 583.2,203.6 "
        />
        <rect x="605.8" y="203.6" width="13.8" height="81.8" />
        <polygon points="651,285.3 651,214.8 662.4,214.8 662.4,203.6 625.8,203.6 625.8,214.8 637.2,214.8 637.2,285.3 " />
        <path
          d="M690.3,203.6h-15.7l-15.4,81.8h13l2.4-15h14.6l2.5,15h14.1L690.3,203.6z M676.5,259.4l5.4-32.8h0.1l5.4,32.8
        H676.5z"
        />
        <polygon points="738,203.6 701.5,203.6 701.5,214.8 712.8,214.8 712.8,285.3 726.7,285.3 726.7,214.8 738,214.8 " />
        <rect x="745.5" y="203.6" width="13.7" height="81.8" />
        <path
          d="M788.9,286.3c14.6,0,20.8-9.4,20.8-22.1v-39.6c0-12.8-6.2-22.1-20.8-22.1s-20.8,9.3-20.8,22.1v39.6
        C768.2,276.9,774.4,286.3,788.9,286.3 M781.9,222.5c0-4.9,2.2-8.4,7-8.4s7.1,3.5,7.1,8.4v43.9c0,4.9-2.2,8.4-7.1,8.4s-7-3.5-7-8.4
        V222.5z"
        />
        <polygon
          points="858.5,285.3 858.5,203.6 847,203.6 847,250.5 832.2,203.6 818.7,203.6 818.7,285.3 830.3,285.3 
        830.3,234 846.4,285.3 "
        />

        {!quantitative && (
          <path
            d="M684.7,404.4c-0.8-0.9-2-1.4-3.3-1.4H318.6c-2.3-0.1-4.2,1.7-4.2,3.9c0,0.3,0,0.6,0.1,0.9l61,368.6
        c0.3,2,2.1,3.5,4.2,3.5h74.8l5.1,60H428l73.2,73.2l73.4-73.4h-31.5l5.1-59.8h76.1c2.1,0,3.9-1.5,4.2-3.6l57-368.6
        C685.8,406.6,685.4,405.3,684.7,404.4z M544.4,699.5c-11.8,10.7-27.4,16.2-43.3,15.1c-15.9,1.1-31.6-4.3-43.3-15.1
        c-27.2-27.2-17.5-60.9-8-78.4c5.8-10.9,47.6-73.6,51.2-79v-0.4l0.2,0.2l0.1-0.2v0.4c3.5,5.3,45.3,68,51.2,79
        C561.9,638.5,571.6,672.3,544.4,699.5z M659.5,481.9c-9.8-4.3-22.3-2.8-34.3,2.1c-45,18.2-75.7,24.8-123,10
        c-29.8-9.3-57.7-28.9-90.7-17c-21.9,7.9-42.3,15.4-67,15.2l-14.3-73.3h339.5L659.5,481.9z"
          />
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <path
              d="m0 0c-7.105 3.13-16.113 2.002-24.762-1.502-32.532-13.185-54.67-17.928-88.887-7.214-21.546 6.745-41.706 20.87-65.537 12.269-15.815-5.689-30.55-11.116-48.431-10.977l-10.328 52.947h245.37zm-83.168-157.227s-11.912-12.24-31.287-10.913c-19.42-1.327-31.318 10.913-31.318 10.913-19.642 19.623-12.635 44.038-5.797 56.653 4.223 7.902 34.4 53.223 36.996 57.078v.305s.045-.059.119-.147l.105.147v-.305c2.526-3.855 32.751-49.176 36.975-57.078 6.846-12.615 13.832-37.03-5.793-56.653m101.328 213.277c-.614.667-1.438 1.037-2.372 1.037h-262.179c-.908 0-1.741-.37-2.355-1.037-.575-.732-.803-1.636-.658-2.48l44.049-266.407c.241-1.473 1.53-2.568 3.022-2.568h54.061l3.697-43.39-22.748-.026 52.934-52.932 53.061 53.052-22.744-.024 3.693 43.32h55.012c1.518 0 2.785 1.095 3.009 2.615l41.211 266.36c.141.915-.127 1.789-.693 2.48"
              transform="translate(483.5776 381.7085)"
            />
          )}
          <path
            d="m0 0c.429 8.161 3.867 13.319 11.604 13.319 8.376 0 11.604-5.158 11.604-14.618v-25.362c0-9.236-3.43-14.612-11.814-14.612-8.175 0-11.394 5.587-11.394 14.612zm11.394-61.263c25.997 0 36.101 14.192 36.101 36.761v21.493c0 23.854-9.455 35.887-27.085 35.887-10.315 0-16.543-4.736-20.2-11.824h-.21v31.38c0 8.819 2.797 15.046 11.604 15.046 8.806 0 11.394-5.166 11.394-14.187v-9.67h22.349v7.736c0 21.498-7.096 36.532-34.173 36.532-25.787 0-35.461-16.542-35.461-39.321v-70.924c0-22.572 9.884-38.909 35.681-38.909"
            transform="translate(105.2598 583.0512)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.32h-10.221v-18.629h14.291v-8.411h-24.601z"
            transform="translate(208.7339 668.5775)"
          />
          <path
            d="m0 0h8.23l-4.071 24.599h-.088zm-12.931-19.443 11.576 61.316h11.753l11.666-61.316h-10.578l-1.902 11.213h-10.939l-1.813-11.213z"
            transform="translate(250.1712 626.7046)"
          />
          <path
            d="m0 0v-46.395c0-9.496-4.071-15.643-14.558-15.643-10.857 0-15.38 6.147-15.38 15.643v46.395h10.31v-47.391c0-3.615 1.45-6.057 5.07-6.057 3.612 0 5.062 2.442 5.062 6.057v47.391z"
            transform="translate(305.0855 668.5775)"
          />
          <path
            d="m0 0v-24.147h3.803c3.524 0 5.063 1.718 5.063 5.066v14.107c0 3.346-1.539 4.974-5.063 4.974zm-10.31 8.411h15.284c10.405 0 14.202-5.155 14.202-13.747v-12.931c0-8.592-3.797-13.837-14.202-13.837h-4.974v-20.801h-10.31z"
            transform="translate(336.7875 660.1661)"
          />
          <path
            d="m0 0v-19.081h3.441c3.523 0 5.062 1.807 5.062 5.063v9.044c0 3.346-1.539 4.974-5.062 4.974zm0-24.78v-28.125h-10.311v61.316h15.017c10.399 0 14.196-5.155 14.196-13.747v-7.868c0-6.602-2.353-10.491-8.23-11.846l9.859-27.855h-10.851z"
            transform="translate(371.6167 660.1661)"
          />
          <path
            d="m0 0v32.918c0 3.708-1.628 6.332-5.336 6.332-3.619 0-5.247-2.624-5.247-6.332v-32.918c0-3.708 1.628-6.331 5.247-6.331 3.708 0 5.336 2.623 5.336 6.331m-20.893 1.628v29.661c0 9.586 4.707 16.55 15.557 16.55 10.946 0 15.646-6.964 15.646-16.55v-29.661c0-9.496-4.7-16.549-15.646-16.549-10.85 0-15.557 7.053-15.557 16.549"
            transform="translate(417.0287 621.4604)"
          />
          <path
            d="m0 0v-24.147h3.804c3.523 0 5.062 1.718 5.062 5.066v14.107c0 3.346-1.539 4.974-5.062 4.974zm-10.31 8.411h15.284c10.405 0 14.202-5.155 14.202-13.747v-12.931c0-8.592-3.797-13.837-14.202-13.837h-4.974v-20.801h-10.31z"
            transform="translate(443.5448 660.1661)"
          />
          <path
            d="m0 0v-19.081h3.441c3.523 0 5.062 1.807 5.062 5.063v9.044c0 3.346-1.539 4.974-5.062 4.974zm0-24.78v-28.125h-10.311v61.316h15.017c10.399 0 14.196-5.155 14.196-13.747v-7.868c0-6.602-2.353-10.491-8.23-11.846l9.859-27.855h-10.851z"
            transform="translate(478.374 660.1661)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.32h-10.221v-18.629h14.291v-8.411h-24.601z"
            transform="translate(502.8926 668.5775)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.32h-10.221v-18.629h14.291v-8.411h-24.601z"
            transform="translate(548.5238 668.5775)"
          />
          <path
            d="m0 0h27.4v-8.411h-8.504v-52.905h-10.399v52.905h-8.497z"
            transform="translate(577.4882 668.5775)"
          />
          <path
            d="m0 0h8.23l-4.07 24.599h-.089zm-12.931-19.443 11.576 61.316h11.754l11.665-61.316h-10.577l-1.902 11.213h-10.94l-1.812-11.213z"
            transform="translate(220.0424 540.7515)"
          />
          <path
            d="m0 0v8.23h9.585v-8.411c0-3.438 1.539-5.425 5.069-5.425 3.25 0 4.701 2.168 4.701 5.425v2.35c0 3.527-1.451 5.699-4.611 8.682l-6.062 6.061c-5.877 5.788-8.593 9.315-8.593 16.368v2.08c0 7.597 4.433 13.475 14.47 13.475 10.31 0 14.381-5.063 14.381-13.926v-4.974h-9.408v5.336c0 3.527-1.628 5.244-4.878 5.244-2.893 0-4.885-1.628-4.885-5.066v-1.265c0-3.435 1.896-5.425 4.885-8.32l6.602-6.513c5.603-5.695 8.319-9.133 8.319-15.913v-2.986c0-8.411-4.522-14.377-15.016-14.377-10.488 0-14.559 5.876-14.559 13.925"
            transform="translate(244.9236 534.5121)"
          />
          <path
            d="m0 0v8.23h9.585v-8.411c0-3.438 1.539-5.425 5.069-5.425 3.251 0 4.7 2.168 4.7 5.425v2.35c0 3.527-1.449 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.315-8.593 16.368v2.08c0 7.597 4.434 13.475 14.47 13.475 10.31 0 14.38-5.063 14.38-13.926v-4.974h-9.406v5.336c0 3.527-1.628 5.244-4.879 5.244-2.894 0-4.885-1.628-4.885-5.066v-1.265c0-3.435 1.896-5.425 4.885-8.32l6.602-6.513c5.604-5.695 8.32-9.133 8.32-15.913v-2.986c0-8.411-4.523-14.377-15.017-14.377-10.488 0-14.559 5.876-14.559 13.925"
            transform="translate(278.9446 534.5121)"
          />
          <path
            d="m0 0h8.23l-4.07 24.599h-.089zm-12.931-19.443 11.576 61.316h11.754l11.665-61.316h-10.577l-1.902 11.213h-10.94l-1.812-11.213z"
            transform="translate(324.3573 540.7515)"
          />
          <path d="m350.689 582.624h10.31v-61.316h-10.31z" />
          <path
            d="m0 0v-38.524h-8.682v61.316h10.132l11.124-35.182v35.182h8.593v-61.316h-9.045z"
            transform="translate(375.6531 559.8324)"
          />
          <path d="m402.703 582.624h10.31v-61.316h-10.31z" />
          <path
            d="m0 0v8.23h9.584v-8.411c0-3.438 1.54-5.425 5.07-5.425 3.25 0 4.7 2.168 4.7 5.425v2.35c0 3.527-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.315-8.593 16.368v2.08c0 7.597 4.433 13.475 14.469 13.475 10.31 0 14.381-5.063 14.381-13.926v-4.974h-9.407v5.336c0 3.527-1.628 5.244-4.878 5.244-2.894 0-4.885-1.628-4.885-5.066v-1.265c0-3.435 1.896-5.425 4.885-8.32l6.602-6.513c5.603-5.695 8.319-9.133 8.319-15.913v-2.986c0-8.411-4.522-14.377-15.017-14.377-10.487 0-14.558 5.876-14.558 13.925"
            transform="translate(418.4515 534.5121)"
          />
          <path
            d="m0 0v8.23h9.585v-8.411c0-3.438 1.539-5.425 5.069-5.425 3.25 0 4.7 2.168 4.7 5.425v2.35c0 3.527-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.315-8.593 16.368v2.08c0 7.597 4.434 13.475 14.47 13.475 10.31 0 14.381-5.063 14.381-13.926v-4.974h-9.408v5.336c0 3.527-1.628 5.244-4.878 5.244-2.894 0-4.885-1.628-4.885-5.066v-1.265c0-3.435 1.896-5.425 4.885-8.32l6.602-6.513c5.603-5.695 8.319-9.133 8.319-15.913v-2.986c0-8.411-4.522-14.377-15.016-14.377-10.488 0-14.559 5.876-14.559 13.925"
            transform="translate(452.4659 534.5121)"
          />
          <path
            d="m0 0h24.602v-8.411h-14.292v-17.545h10.221v-8.319h-10.221v-18.629h14.292v-8.412h-24.602z"
            transform="translate(487.4729 582.6244)"
          />
          <path
            d="m0 0h-.274l-6.957-39.793h-4.796l-7.69 39.793h-.178v-39.793h-8.503v61.316h12.033l6.691-34.549h.089l5.966 34.549h13.026v-61.316h-9.407z"
            transform="translate(546.0066 561.1018)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.545h10.221v-8.319h-10.221v-18.629h14.291v-8.412h-24.601z"
            transform="translate(561.3035 582.6244)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.316h10.132l11.125-35.182v35.182h8.592v-61.316h-9.045z"
            transform="translate(600.1199 559.8324)"
          />
          <path
            d="m0 0h27.4v-8.411h-8.504v-52.905h-10.399v52.905h-8.497z"
            transform="translate(625.9998 582.6244)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg7 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          id="_Path_2"
          points="102.6,111.4 154.9,111.4 109.7,285.4 143.3,285.4 187.6,115 187.6,83.8 102.6,83.8 "
        />
        {!quantitative && (
          <g>
            <path
              id="_Compound_Path_"
              d="M500,484.5c-81,0-146.6,65.6-146.6,146.5c0,81,65.6,146.6,146.5,146.6
          s146.6-65.6,146.6-146.5c0,0,0,0,0-0.1C646.5,550.1,580.9,484.5,500,484.5 M489.1,542.4c0-4.9,4.9-10.2,10.9-10.2
          s10.9,5.4,10.9,10.2v50.3c0,4.8-4.9,10.2-10.9,10.2s-10.9-5.3-10.9-10.2V542.4z M500,706.2c-42.1-0.1-76.2-34.3-76.1-76.4
          c0.1-33.3,21.7-62.7,53.5-72.6v28.4c-24.5,12.5-34.3,42.6-21.8,67.1c12.5,24.5,42.6,34.3,67.1,21.8c24.5-12.5,34.3-42.6,21.8-67.1
          c-4.8-9.4-12.5-17.1-21.9-21.9v-28.4c40.2,12.5,62.7,55.2,50.3,95.4C562.9,684.4,533.4,706.2,500,706.2"
            />
            <path
              id="_Path_3"
              d="M331.7,629.8c0-6.7-5.9-12-11.3-12h-64.2c-5.4,0-11.4,5.4-11.4,12s5.9,12.1,11.4,12.1h64.2
          C325.8,641.9,331.7,636.4,331.7,629.8"
            />
            <path
              id="_Path_4"
              d="M755.1,629.8c0-6.7-5.9-12-11.3-12h-64.2c-5.4,0-11.3,5.4-11.3,12s5.9,12.1,11.3,12.1h64.2
          C749.2,641.9,755.1,636.4,755.1,629.8"
            />
            <path
              id="_Path_5"
              d="M500,461.5c6.6,0,12-5.9,12-11.3v-64.2c0-5.4-5.4-11.4-12-11.4s-12.1,5.9-12.1,11.4v64.2
          C487.9,455.6,493.3,461.5,500,461.5"
            />
            <path
              id="_Path_6"
              d="M500,884.9c6.6,0,12-5.9,12-11.3v-64.2c0-5.4-5.4-11.3-12-11.3s-12.1,6-12.1,11.3v64.2
          C487.9,879,493.3,884.9,500,884.9"
            />
            <path
              id="_Path_7"
              d="M354,546.2c3.3-5.8,0.9-13.4-3.8-16l-55.7-31.9c-4.7-2.7-12.5-1-15.8,4.8s-0.8,13.4,3.9,16.1
          l55.7,31.9C342.9,553.8,350.7,552,354,546.2"
            />
            <path
              id="_Path_8"
              d="M721.4,756.5c3.3-5.8,0.9-13.4-3.8-16l-55.7-31.9c-4.7-2.7-12.5-1-15.8,4.8s-0.8,13.4,3.8,16.1
          l55.7,31.9C710.3,764.1,718.1,762.3,721.4,756.5"
            />
            <path
              id="_Path_9"
              d="M583.6,483.8c5.8,3.3,13.3,0.9,16-3.8l31.9-55.7c2.7-4.7,1-12.5-4.8-15.8s-13.4-0.8-16.1,3.9
          L578.7,468C576,472.7,577.8,480.5,583.6,483.8"
            />
            <path
              id="_Path_10"
              d="M373.3,851.2c5.8,3.3,13.4,0.9,16-3.8l31.9-55.7c2.7-4.7,1-12.5-4.8-15.8s-13.4-0.8-16.1,3.9
          l-31.9,55.7C365.8,840.1,367.5,847.9,373.3,851.2"
            />
            <path
              id="_Path_11"
              d="M416.1,483.9c5.8-3.3,7.5-11.1,4.8-15.8l-32-55.6c-2.7-4.7-10.3-7.1-16.1-3.8
          s-7.5,11.2-4.8,15.9l32,55.6C402.8,484.8,410.4,487.2,416.1,483.9"
            />
            <path
              id="_Path_12"
              d="M627.2,850.9c5.8-3.3,7.5-11.1,4.8-15.8l-32-55.6c-2.7-4.7-10.3-7.2-16.1-3.8
          s-7.5,11.2-4.8,15.9l32,55.6C613.8,851.8,621.4,854.2,627.2,850.9"
            />
            <path
              id="_Path_13"
              d="M645.9,545.9c3.3,5.8,11.1,7.5,15.8,4.8l55.6-32c4.7-2.7,7.2-10.3,3.9-16.1s-11.2-7.5-15.9-4.8
          l-55.6,32C645,532.5,642.6,540.2,645.9,545.9"
            />
            <path
              id="_Path_14"
              d="M278.9,757c3.3,5.8,11.1,7.5,15.8,4.8l55.6-32c4.7-2.7,7.2-10.3,3.8-16.1s-11.2-7.5-15.9-4.8
          l-55.6,32C278,743.6,275.6,751.2,278.9,757"
            />
          </g>
        )}
        <g id="_Group_">
          <path
            id="_Compound_Path_2"
            d="M283.5,165.4l15.4-81.7h15.7l15.5,81.7H316l-2.5-14.9h-14.6l-2.4,14.9H283.5z
           M300.7,139.5h11l-5.4-32.8h-0.1L300.7,139.5z"
          />
          <path
            id="_Compound_Path_3"
            d="M335.2,83.7h32.2v11.2h-18.5v23.4h13.8v11.1h-13.8v36h-13.7V83.7z"
          />
          <path
            id="_Compound_Path_4"
            d="M372.8,83.7H405v11.2h-18.5v23.4h13.8v11.1h-13.8v36h-13.7V83.7z"
          />
          <path
            id="_Compound_Path_5"
            d="M409.2,144.3v-39.5c0-12.8,6.3-22.1,20.8-22.1s20.9,9.3,20.9,22.1v39.6
          c0,12.7-6.3,22.1-20.9,22.1S409.2,157,409.2,144.3z M437.1,146.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
          c0,4.9,2.2,8.4,7,8.4S437.1,151.4,437.1,146.5z"
          />
          <path
            id="_Compound_Path_6"
            d="M471.8,127.9v37.5H458V83.7h20c13.9,0,19,6.9,19,18.3v10.5c0,8.8-3.1,14-11,15.8
          l13.1,37.1h-14.5L471.8,127.9z M471.8,94.9v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12c0-4.5-2-6.6-6.8-6.6L471.8,94.9z"
          />
          <path
            id="_Compound_Path_7"
            d="M545,105.6v37.8c0,12.5-5.2,21.9-19.9,21.9h-21.3V83.7h21.2
          C539.8,83.7,545,93,545,105.6z M523.4,154.2c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3L523.4,154.2z"
          />
          <path
            id="_Compound_Path_8"
            d="M548.2,165.4l15.4-81.7h15.7l15.5,81.7h-14.1l-2.5-14.9h-14.6l-2.4,14.9H548.2z
           M565.5,139.5h11l-5.5-32.8h-0.1L565.5,139.5z"
          />
          <path
            id="_Compound_Path_9"
            d="M599.9,83.7h19.9c13.8,0,18.3,6.4,18.3,18v8.3c0,6.9-2.5,11.2-8.2,13
          c6.9,1.6,10.2,6.1,10.2,13.6v10.9c0,11.6-5.2,18-18.9,18h-21.3V83.7z M613.7,118.1h4.8c4.5,0,6.5-2.3,6.5-6.6v-10
          c0-4.5-2-6.6-6.6-6.6h-4.7V118.1z M613.7,128.6v25.6h6c4.6,0,6.8-2.3,6.8-6.6v-12.3c0-4.3-2-6.6-6.9-6.6L613.7,128.6z"
          />
          <path
            id="_Compound_Path_10"
            d="M646.5,83.7h13.8v70.5h16.4v11.2h-30.1V83.7z"
          />
          <path
            id="_Compound_Path_11"
            d="M682.3,83.7h32.8v11.2H696v23.4h13.6v11.1H696v24.8h19v11.2h-32.8L682.3,83.7z"
          />
          <path
            id="_Compound_Path_12"
            d="M731.7,165.4l15.4-81.7h15.7l15.6,81.7h-14.1l-2.5-14.9h-14.6l-2.4,14.9H731.7z
           M748.9,139.5h11l-5.4-32.8h-0.1L748.9,139.5z"
          />
          <path
            id="_Compound_Path_13"
            d="M795,114v51.3h-11.6V83.7h13.5l14.8,46.9V83.7h11.5v81.7h-12L795,114z"
          />
          <path
            id="_Compound_Path_14"
            d="M871.5,105.6v37.8c0,12.5-5.2,21.9-19.9,21.9h-21.2V83.7h21.2
          C866.3,83.7,871.5,93,871.5,105.6z M850,154.2c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3L850,154.2z"
          />
        </g>
        <g id="_Group_2">
          <path
            id="_Compound_Path_15"
            d="M285.5,264.3V225c0-12.7,6-22,20.4-22c15.1,0,19.3,8.4,19.3,20.4v9.6h-12.5v-10.6
          c0-5-1.7-7.9-6.6-7.9s-7,3.5-7,8.4v43.7c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-7.9v-15h12.5v14c0,11.6-4.8,20.3-19.3,20.3
          S285.5,276.9,285.5,264.3z"
          />
          <path
            id="_Compound_Path_16"
            d="M333.9,204h13.7v70.2h16.3v11.2h-30L333.9,204z"
          />
          <path
            id="_Compound_Path_17"
            d="M371.3,204h32.6v11.2H385v23.3h13.5v11H385v24.7h19v11.2h-32.7V204z"
          />
          <path
            id="_Compound_Path_18"
            d="M410.3,285.3l15.4-81.3h15.6l15.5,81.3h-14l-2.5-14.9h-14.5l-2.4,14.9H410.3z
           M427.4,259.5h10.9l-5.4-32.6h-0.1L427.4,259.5z"
          />
          <path
            id="_Compound_Path_19"
            d="M475,234.2v51.1h-11.5V204H477l14.8,46.7V204h11.4v81.3h-12L475,234.2z"
          />
          <path
            id="_Compound_Path_20"
            d="M539.7,204h32.6v11.2h-18.9v23.3h13.5v11h-13.5v24.7h19v11.2h-32.6V204z"
          />
          <path
            id="_Compound_Path_21"
            d="M592,234.2v51.1h-11.5V204h13.4l14.8,46.7V204H620v81.3h-12L592,234.2z"
          />
          <path
            id="_Compound_Path_22"
            d="M628.9,204h32.6v11.2h-19v23.3h13.5v11h-13.5v24.7h19v11.2h-32.6V204z"
          />
          <path
            id="_Compound_Path_23"
            d="M683.5,248v37.3h-13.7V204h19.9c13.8,0,18.8,6.8,18.8,18.2v10.4
          c0,8.8-3.1,13.9-10.9,15.7l13.1,36.9h-14.4L683.5,248z M683.5,215.1v25.3h4.5c4.7,0,6.7-2.4,6.7-6.7v-12c0-4.4-2-6.6-6.7-6.6H683.5
          z"
          />
          <path
            id="_Compound_Path_24"
            d="M737.8,241.9h19.4v43.4h-9.8v-8.9c-1.8,6.1-5.6,9.8-13.1,9.8c-11.8,0-17.2-9.4-17.2-22
          V225c0-12.7,6.1-22,20.5-22c15.1,0,19.5,8.4,19.5,20.4v7.2h-12.5v-8.3c0-5-1.9-7.9-6.8-7.9s-7.1,3.5-7.1,8.4v43.7
          c0,4.9,2,8.4,6.7,8.4c4.4,0,6.7-2.5,6.7-7.8v-14.3h-6.5V241.9z"
          />
          <path
            id="_Compound_Path_25"
            d="M792.6,254.4v31h-13.7v-31L763.7,204H778l8.3,30.8h0.1l8.2-30.8h13.1L792.6,254.4z"
          />
        </g>
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <>
              <path
                d="m0 0c-25.403 0-45.998 20.591-45.998 45.998 0 20.65 13.593 38.114 32.328 43.937v-17.127c-9.752-4.981-16.442-15.102-16.442-26.81 0-16.633 13.476-30.112 30.112-30.112s30.113 13.479 30.113 30.112c0 11.741-6.724 21.88-16.52 26.85v17.109c18.772-5.797 32.413-23.279 32.413-43.959 0-25.407-20.595-45.998-46.006-45.998m-6.562 98.823c0 2.943 2.955 6.185 6.584 6.185 3.622 0 6.551-3.242 6.551-6.185v-30.366c0-2.929-2.929-6.137-6.551-6.137-3.629 0-6.584 3.208-6.584 6.137zm6.547 34.938c-48.84 0-88.433-39.596-88.433-88.44 0-48.866 39.593-88.452 88.433-88.452s88.434 39.586 88.434 88.452c0 48.844-39.594 88.44-88.434 88.44"
                transform="translate(368.9215 198.3449)"
              />
              <path
                d="m0 0c0 4.01-3.552 7.258-6.796 7.258h-38.73c-3.267 0-6.851-3.248-6.851-7.258 0-4.021 3.584-7.287 6.851-7.287h38.73c3.244 0 6.796 3.266 6.796 7.287"
                transform="translate(267.3858 244.4385)"
              />
              <path
                d="m0 0c0 4.01-3.552 7.258-6.797 7.258h-38.729c-3.263 0-6.848-3.248-6.848-7.258 0-4.021 3.585-7.287 6.848-7.287h38.729c3.245 0 6.797 3.266 6.797 7.287"
                transform="translate(522.8457 244.4385)"
              />
              <path
                d="m0 0c4.003 0 7.254 3.552 7.254 6.797v38.725c0 3.263-3.251 6.852-7.254 6.852-4.017 0-7.292-3.589-7.292-6.852v-38.725c0-3.245 3.275-6.797 7.292-6.797"
                transform="translate(368.9438 90.5106)"
              />
              <path
                d="m0 0c1.988 3.475.52 8.063-2.292 9.675l-33.613 19.236c-2.835 1.622-7.563.582-9.551-2.9-1.996-3.483-.509-8.104 2.325-9.723l33.614-19.236c2.815-1.612 7.517-.542 9.517 2.948"
                transform="translate(502.5216 167.9839)"
              />
              <path
                d="m0 0c3.476-1.988 8.06-.52 9.672 2.296l19.236 33.61c1.622 2.834.582 7.565-2.897 9.554-3.482 1.996-8.107.505-9.726-2.325l-19.236-33.614c-1.612-2.812-.539-7.525 2.951-9.521"
                transform="translate(292.4886 110.8309)"
              />
              <path
                d="m0 0c3.476 1.999 4.522 6.698 2.908 9.506l-19.306 33.577c-1.634 2.831-6.233 4.317-9.712 2.318-3.486-1.999-4.529-6.738-2.893-9.572l19.303-33.573c1.614-2.809 6.214-4.259 9.7-2.256"
                transform="translate(445.6655 111.0033)"
              />
              <path
                d="m0 0c1.995-3.472 6.693-4.519 9.506-2.901l33.57 19.306c2.834 1.626 4.328 6.229 2.321 9.704-1.995 3.487-6.737 4.53-9.564 2.904l-33.574-19.306c-2.812-1.614-4.262-6.221-2.259-9.707"
                transform="translate(235.5085 167.6837)"
              />
              <path
                d="m0 0c4.003 0 7.254 3.552 7.254 6.793v38.733c0 3.266-3.251 6.848-7.254 6.848-4.017 0-7.292-3.582-7.292-6.848v-38.733c0-3.241 3.275-6.793 7.292-6.793"
                transform="translate(368.9438 345.9666)"
              />
              <path
                d="m0 0c1.996 3.483.527 8.064-2.292 9.675l-33.613 19.237c-2.835 1.625-7.559.585-9.551-2.894-1.996-3.489-.505-8.103 2.329-9.729l33.613-19.237c2.813-1.611 7.519-.542 9.514 2.948"
                transform="translate(280.8033 294.8747)"
              />
              <path
                d="m0 0c3.479-1.988 8.056-.52 9.672 2.292l19.236 33.614c1.626 2.838.586 7.562-2.893 9.554-3.486 2-8.108.505-9.73-2.329l-19.236-33.61c-1.612-2.819-.543-7.525 2.951-9.521"
                transform="translate(419.3799 332.5454)"
              />
              <path
                d="m0 0c3.475 2 4.522 6.698 2.904 9.51l-19.306 33.577c-1.634 2.83-6.23 4.314-9.708 2.314-3.49-1.999-4.53-6.738-2.897-9.569l19.302-33.569c1.623-2.812 6.215-4.266 9.705-2.263"
                transform="translate(318.3206 332.4578)"
              />
              <path
                d="m0 0c1.996-3.472 6.695-4.519 9.507-2.904l33.569 19.306c2.834 1.629 4.329 6.232 2.329 9.708-2.007 3.482-6.737 4.529-9.572 2.9l-33.573-19.306c-2.812-1.615-4.266-6.222-2.26-9.704"
                transform="translate(456.9625 295.0324)"
              />
            </>
          )}
          <path
            d="m0 0h37.83l-32.677-125.722h24.296l32.024 123.144v22.572h-61.473z"
            transform="translate(81.428 649.4313)"
          />
          <path
            d="m0 0-16.19-2.08v5.788l16.19 3.435zm-21.434-4.341h24.598v-8.411h-14.288v-17.546h10.217v-8.319h-10.217v-18.632h14.288v-8.409h-24.598z"
            transform="translate(222.9174 672.1638)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.317h10.129l11.124-35.182v35.182h8.59v-61.317h-9.042z"
            transform="translate(240.2939 645.0309)"
          />
          <path
            d="m0 0h24.598v-8.411h-14.288v-17.546h10.217v-8.319h-10.217v-18.632h14.288v-8.409h-24.598z"
            transform="translate(267.3506 667.8229)"
          />
          <path
            d="m0 0v-19.081h3.434c3.527 0 5.066 1.806 5.066 5.063v9.044c0 3.346-1.539 4.974-5.066 4.974zm0-24.78v-28.125h-10.311v61.316h15.014c10.399 0 14.196-5.154 14.196-13.748v-7.867c0-6.602-2.35-10.491-8.23-11.846l9.858-27.855h-10.85z"
            transform="translate(307.7861 659.4114)"
          />
          <path
            d="m0 0h14.651v-32.737h-7.416v6.692c-1.355-4.611-4.249-7.416-9.859-7.416-8.86 0-12.93 7.053-12.93 16.549v29.664c0 9.585 4.611 16.55 15.465 16.55 11.394 0 14.74-6.329 14.74-15.373v-5.425h-9.404v6.239c0 3.797-1.447 5.97-5.155 5.97s-5.336-2.625-5.336-6.332v-32.921c0-3.708 1.536-6.329 5.062-6.329 3.346 0 5.067 1.895 5.067 5.877v10.854h-4.885z"
            transform="translate(347.8621 639.2428)"
          />
          <path d="m368.409 667.823h10.31v-61.317h-10.31z" />
          <path
            d="m0 0h24.598v-8.411h-14.288v-17.546h10.217v-8.319h-10.217v-18.632h14.288v-8.409h-24.598z"
            transform="translate(384.6947 667.8229)"
          />
          <path
            d="m0 0v-24.147h3.798c3.526 0 5.065 1.717 5.065 5.066v14.107c0 3.346-1.539 4.974-5.065 4.974zm-10.31 8.411h15.284c10.399 0 14.199-5.154 14.199-13.748v-12.93c0-8.593-3.8-13.836-14.199-13.836h-4.974v-20.802h-10.31z"
            transform="translate(440.6287 659.4114)"
          />
          <path
            d="m0 0v-19.081h3.434c3.53 0 5.067 1.806 5.067 5.063v9.044c0 3.346-1.537 4.974-5.067 4.974zm0-24.78v-28.125h-10.31v61.316h15.014c10.398 0 14.195-5.154 14.195-13.748v-7.867c0-6.602-2.35-10.491-8.23-11.846l9.858-27.855h-10.85z"
            transform="translate(475.4611 659.4114)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.332-5.336 6.332-3.616 0-5.244-2.624-5.244-6.332v-32.921c0-3.708 1.628-6.329 5.244-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.89 1.628v29.665c0 9.585 4.703 16.549 15.554 16.549 10.943 0 15.647-6.964 15.647-16.549v-29.665c0-9.496-4.704-16.549-15.647-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(520.8731 620.7025)"
          />
          <path
            d="m0 0v-24.147h3.798c3.526 0 5.065 1.717 5.065 5.066v14.107c0 3.346-1.539 4.974-5.065 4.974zm-10.31 8.411h15.284c10.399 0 14.199-5.154 14.199-13.748v-12.93c0-8.593-3.8-13.836-14.199-13.836h-4.974v-20.802h-10.31z"
            transform="translate(547.386 659.4114)"
          />
          <path
            d="m0 0v-19.081h3.434c3.53 0 5.067 1.806 5.067 5.063v9.044c0 3.346-1.537 4.974-5.067 4.974zm0-24.78v-28.125h-10.31v61.316h15.014c10.398 0 14.195-5.154 14.195-13.748v-7.867c0-6.602-2.35-10.491-8.23-11.846l9.859-27.855h-10.851z"
            transform="translate(582.2184 659.4114)"
          />
          <path
            d="m0 0h24.599v-8.411h-14.289v-17.546h10.218v-8.319h-10.218v-18.632h14.289v-8.409h-24.599z"
            transform="translate(606.7403 667.8229)"
          />
          <path
            d="m0 0h24.598v-8.409h-14.288v-17.548h10.217v-8.319h-10.217v-18.629h14.288v-8.408h-24.598z"
            transform="translate(201.4834 586.3891)"
          />
          <path
            d="m0 0h27.403v-8.409h-8.5v-52.904h-10.402v52.904h-8.501z"
            transform="translate(230.4353 586.3891)"
          />
          <path
            d="m0 0c4.249 0 5.877 2.531 5.877 6.239v32.107c0 3.619-1.628 6.15-5.877 6.15h-4.341v-44.496zm16.187 36.444v-28.392c0-9.407-3.889-16.46-14.921-16.46h-15.917v61.313h15.917c11.032 0 14.921-6.965 14.921-16.461"
            transform="translate(292.7904 533.484)"
          />
          <path
            d="m0 0-3.708-12.931h-5.699l.544 13.745h8.863z"
            transform="translate(322.8332 585.575)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.562-15.646-10.851 0-15.373 6.15-15.373 15.646v46.392h10.31v-47.391c0-3.612 1.447-6.055 5.063-6.055 3.619 0 5.066 2.443 5.066 6.055v47.391z"
            transform="translate(357.4781 586.3891)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.313h10.129l11.124-35.178v35.178h8.59v-61.313h-9.041z"
            transform="translate(372.0553 563.5997)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.523 16.55 15.373 16.55 11.394 0 14.562-6.329 14.562-15.373v-7.238h-9.407v8.052c0 3.797-1.265 5.966-4.974 5.966-3.708 0-5.244-2.621-5.244-6.328v-32.921c0-3.709 1.536-6.329 5.244-6.329 3.709 0 4.974 2.347 4.974 5.966v11.308h9.407v-10.583c0-8.77-3.619-15.283-14.562-15.283-10.85 0-15.373 7.053-15.373 16.549"
            transform="translate(412.6079 540.9002)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.328-5.336 6.328-3.616 0-5.244-2.62-5.244-6.328v-32.921c0-3.708 1.628-6.329 5.244-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.89 1.628v29.665c0 9.584 4.703 16.549 15.554 16.549 10.943 0 15.646-6.965 15.646-16.549v-29.665c0-9.496-4.703-16.549-15.646-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(469.0554 539.272)"
          />
          <path
            d="m0 0v4.974l6.51 4.789h4.522l6.512-4.789v-4.974l-8.681 2.621zm23.514-2.264v-46.392c0-9.496-4.071-15.646-14.562-15.646-10.851 0-15.373 6.15-15.373 15.646v46.392h10.31v-47.391c0-3.612 1.447-6.055 5.063-6.055 3.619 0 5.066 2.443 5.066 6.055v47.391z"
            transform="translate(491.6826 588.653)"
          />
          <path
            d="m0 0h27.404v-8.409h-8.501v-52.904h-10.402v52.904h-8.501z"
            transform="translate(519.909 586.3891)"
          />
          <path
            d="m0 0h8.227l-4.067 24.602h-.093zm-12.933-19.443 11.575 61.319h11.757l11.665-61.319h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
            transform="translate(212.7885 463.0883)"
          />
          <path
            d="m0 0v-19.169h4.522c3.435 0 5.063 1.716 5.063 4.973v9.222c0 3.257-1.536 4.974-5.155 4.974zm0 7.868h3.616c3.345 0 4.885 1.717 4.885 4.974v7.504c0 3.346-1.54 4.974-4.974 4.974h-3.527zm-10.31 25.867h14.921c10.31 0 13.748-4.795 13.748-13.477v-6.24c0-5.158-1.902-8.408-6.151-9.769 5.155-1.177 7.687-4.612 7.687-10.215v-8.141c0-8.682-3.89-13.477-14.2-13.477h-16.005z"
            transform="translate(249.4303 471.2295)"
          />
          <path
            d="m0 0v32.914c0 3.709-1.628 6.335-5.336 6.335-3.616 0-5.244-2.626-5.244-6.335v-32.914c0-3.708 1.628-6.335 5.244-6.335 3.708 0 5.336 2.627 5.336 6.335m-20.89 1.628v29.658c0 9.585 4.703 16.55 15.554 16.55 10.943 0 15.647-6.965 15.647-16.55v-29.658c0-9.496-4.704-16.549-15.647-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(295.3862 457.8474)"
          />
          <path
            d="m0 0v-19.081h3.435c3.527 0 5.066 1.807 5.066 5.063v9.044c0 3.346-1.539 4.974-5.066 4.974zm0-24.78v-28.125h-10.31v61.32h15.014c10.399 0 14.196-5.159 14.196-13.751v-7.868c0-6.602-2.35-10.488-8.231-11.843l9.859-27.858h-10.851z"
            transform="translate(321.899 496.5498)"
          />
          <path
            d="m0 0c4.248 0 5.877 2.531 5.877 6.239v32.101c0 3.618-1.629 6.15-5.877 6.15h-4.341v-44.49zm16.187 36.444v-28.399c0-9.406-3.889-16.46-14.921-16.46h-15.917v61.32h15.917c11.032 0 14.921-6.965 14.921-16.461"
            transform="translate(361.0723 452.06)"
          />
          <path
            d="m0 0h8.227l-4.068 24.602h-.092zm-12.934-19.443 11.576 61.319h11.756l11.666-61.319h-10.58l-1.9 11.213h-10.942l-1.81-11.213z"
            transform="translate(393.1029 463.0883)"
          />
          <path
            d="m0 0v-19.169h4.523c3.434 0 5.062 1.716 5.062 4.973v9.222c0 3.257-1.536 4.974-5.155 4.974zm0 7.868h3.616c3.346 0 4.885 1.717 4.885 4.974v7.504c0 3.346-1.539 4.974-4.974 4.974h-3.527zm-10.31 25.867h14.922c10.31 0 13.747-4.795 13.747-13.477v-6.24c0-5.158-1.902-8.408-6.15-9.769 5.155-1.177 7.686-4.612 7.686-10.215v-8.141c0-8.682-3.889-13.477-14.199-13.477h-16.006z"
            transform="translate(429.744 471.2295)"
          />
          <path
            d="m0 0h10.31v-52.905h12.298v-8.414h-22.608z"
            transform="translate(454.807 504.9645)"
          />
          <path
            d="m0 0h24.599v-8.415h-14.289v-17.542h10.218v-8.319h-10.218v-18.629h14.289v-8.414h-24.599z"
            transform="translate(482.1307 504.9645)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg8 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="_Compound_Path_ "
          d="M194.3,236.1v-22c0-19.3-6.8-33.3-22.6-40.4c13.4-6.5,19.6-18.4,19.6-35.1v-8.3
        c0-31.5-16.4-48.5-47.6-48.5c-30.9,0-47,17-47,48.5v8.3c0,16.4,6,28.6,19,35.1c-15.8,7.1-22.3,21.1-22.3,40.4v22
        c0,30.6,14.6,52,50.3,52C179.7,288.1,194.3,266.7,194.3,236.1 M128.5,128.1c0-12.2,4.2-19.3,15.2-19.3c11.3,0,15.5,7.1,15.5,19.3
        v13.7c0,12.2-4.2,19.4-15.5,19.4c-11,0-15.2-7.2-15.2-19.4V128.1z M160.4,239.6c0,12.2-4.5,20.8-16.6,20.8
        c-11.9,0-16.4-8.6-16.4-20.8v-32.7c0-12.2,4.5-20.8,16.4-20.8c12.2,0,16.6,8.6,16.6,20.8V239.6z"
        />
        {!quantitative && (
          <g>
            <path
              id="_Path_2"
              d="M694.2,492l-101.6,96.7c-3.8,3.8-5.8,6.6-5.8,14.5v271c0,3.2,2.6,5.8,5.8,5.8h105
          c3.2,0,5.8-2.6,5.8-5.8V494.4C703.3,491.2,700.8,485.4,694.2,492"
            />
            <path
              id="_Path_3"
              d="M401.3,618l-101.6,96.6c-3.8,3.8-5.8,6.6-5.8,14.5v145c0,3.2,2.6,5.8,5.8,5.8h105
          c3.2,0,5.8-2.6,5.8-5.8V620.4C410.5,617.2,408,611.3,401.3,618"
            />
            <path
              id="_Path_4"
              d="M740.4,374.7c0-0.8-0.3-1.6-0.9-2.2c-0.5-0.5-1.2-0.8-1.9-0.8h-0.6h-0.8l-77.8,17.6l-1.4,0.1
          c-0.6,0.1-1.1,0.4-1.5,0.8c-1.1,1.2-1.1,3,0,4.2l0.9,0.9l17.8,17.8L497.8,589.5L416.3,508c-0.9-0.9-2.4-0.9-3.3,0c0,0,0,0,0,0
          l-22.1,22.1l0,0L260.3,660.7c-0.9,0.9-0.9,2.4,0,3.3l22.1,22.1c0.9,0.9,2.4,0.9,3.3,0c0,0,0,0,0,0l129-128.9l59.1,59.1
          c0.1,0.1,0.1,0.2,0.2,0.3l22.1,22.1c0.9,0.9,2.4,0.9,3.3,0c0,0,0,0,0,0l200.1-200.2l18.7,18.6c1.1,1.1,3,1.2,4.1,0c0,0,0,0,0,0
          c0.5-0.5,0.8-1.2,0.8-1.9V455l17.1-79.4L740.4,374.7z"
            />
            <path
              id="_Path_5"
              d="M548.3,634.9l-49.2,49.6c-0.9,0.8-2.3,0.7-3.2-0.1L451.4,639c-8.2-8.1-9.9-1.5-9.9,1.7v233.5
          c0,3.2,2.6,5.8,5.8,5.8c0,0,0,0,0,0h105c3.2,0,5.8-2.6,5.8-5.8V636.8C558,633.6,555.5,627.7,548.3,634.9"
            />
          </g>
        )}
        <g id="_Group_2">
          <path
            id="_Compound_Path_2"
            d="M309.8,105.6v37.8c0,12.5-5.2,21.9-19.9,21.9h-21.2V83.7h21.2
          C304.6,83.7,309.8,93,309.8,105.6z M288.2,154.2c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3H288.2z"
          />
          <path
            id="_Compound_Path_3"
            d="M318.5,83.7h32.8v11.2h-19v23.4h13.6v11.1h-13.7v24.8h19v11.2h-32.7V83.7z"
          />
          <path
            id="_Compound_Path_4"
            d="M358.3,144.3v-39.5c0-12.8,6-22.1,20.5-22.1c15.2,0,19.4,8.4,19.4,20.5v9.6h-12.5v-10.7
          c0-5.1-1.7-8-6.6-8s-7,3.5-7,8.4v43.9c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-8v-15h12.5V146c0,11.7-4.8,20.4-19.4,20.4
          S358.3,157,358.3,144.3z"
          />
          <path
            id="_Compound_Path_5"
            d="M406.5,83.7h32.8v11.2h-19v23.4h13.6v11.1h-13.7v24.8h19v11.2h-32.7V83.7z"
          />
          <path
            id="_Compound_Path_6"
            d="M459,114v51.3h-11.5V83.7H461l14.8,46.9V83.7h11.5v81.7h-12.1L459,114z"
          />
          <path
            id="_Compound_Path_7"
            d="M494.4,83.7h36.5v11.2h-11.3v70.5h-13.9V94.9h-11.3V83.7z"
          />
          <path
            id="_Compound_Path_8"
            d="M581.3,114.9l-7.7,50.5h-12.9l-11-81.7H563l6.4,51.8h0.1l6.9-51.8h11.2l7.6,51.8h0.1
          l6.3-51.8h11.6l-10.7,81.7h-13l-8.1-50.5H581.3z"
          />
          <path
            id="_Compound_Path_9"
            d="M618.7,144.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.8,9.3,20.8,22.1v39.5
          c0,12.7-6.3,22.1-20.8,22.1S618.7,157,618.7,144.3z M646.5,146.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
          c0,4.9,2.2,8.4,7,8.4S646.5,151.4,646.5,146.5z"
          />
          <path
            id="_Compound_Path_10"
            d="M682.7,127.9v37.5h-13.7V83.7h20c13.9,0,18.9,6.9,18.9,18.3v10.5c0,8.8-3.1,14-11,15.8
          l13.2,37.1h-14.4L682.7,127.9z M682.7,94.9v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12c0-4.5-2-6.6-6.8-6.6L682.7,94.9z"
          />
          <path
            id="_Compound_Path_11"
            d="M729.9,125.6v39.8h-13.7V83.7h13.7v35.9l15-35.9h13.5l-15.9,36.8l16.3,45h-14.5
          L729.9,125.6z"
          />
          <path
            id="_Compound_Path_12"
            d="M777.9,165.4l15.4-81.7H809l15.6,81.7h-14.1l-2.5-14.9h-14.6l-2.4,14.9H777.9z
           M795.1,139.5h11l-5.4-32.8h-0.1L795.1,139.5z"
          />
          <path
            id="_Compound_Path_13"
            d="M840.7,114v51.3h-11.6V83.7h13.5l14.8,46.9V83.7h11.5v81.7h-12.1L840.7,114z"
          />
          <path
            id="_Compound_Path_14"
            d="M919.1,105.6v37.8c0,12.5-5.2,21.9-19.9,21.9H878V83.7h21.2
          C913.9,83.7,919.1,93,919.1,105.6z M897.5,154.2c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3H897.5z"
          />
        </g>
        <g id="_Group_3">
          <path
            id="_Compound_Path_15"
            d="M268.7,203.7h32.8v11.2h-19.1v23.4h13.6v11.1h-13.6v24.8h19v11.2h-32.8V203.7z"
          />
          <path
            id="_Compound_Path_16"
            d="M307.5,264.3v-39.5c0-12.8,6-22.1,20.5-22.1c15.2,0,19.4,8.4,19.4,20.5v9.6h-12.5
          v-10.7c0-5.1-1.7-8-6.6-8s-7,3.5-7,8.4v43.9c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-8v-15h12.5V266c0,11.7-4.8,20.4-19.4,20.4
          S307.5,277,307.5,264.3z"
          />
          <path
            id="_Compound_Path_17"
            d="M354.9,264.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
          c0,12.7-6.3,22.1-20.9,22.1S354.9,277,354.9,264.3z M382.7,266.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
          c0,4.9,2.2,8.4,7,8.4S382.7,271.5,382.7,266.5L382.7,266.5z"
          />
          <path
            id="_Compound_Path_18"
            d="M415.9,234.1v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7H432L415.9,234.1z"
          />
          <path
            id="_Compound_Path_19"
            d="M451.9,264.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
          c0,12.7-6.3,22.1-20.9,22.1S451.9,277,451.9,264.3z M479.8,266.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
          c0,4.9,2.2,8.4,7,8.4S479.8,271.5,479.8,266.5L479.8,266.5z"
          />
          <path
            id="_Compound_Path_20"
            d="M539.2,232.4h-0.4l-9.3,53h-6.4l-10.2-53h-0.2v53h-11.3v-81.7h16l8.9,46h0.1l8-46h17.4
          v81.7h-12.5V232.4z"
          />
          <path
            id="_Compound_Path_21"
            d="M559.6,203.7h13.7v81.7h-13.7V203.7z"
          />
          <path
            id="_Compound_Path_22"
            d="M581,264.3v-39.5c0-12.8,6-22.1,20.5-22.1c15.2,0,19.4,8.4,19.4,20.5v9.6h-12.5v-10.7
          c0-5.1-1.7-8-6.6-8s-7,3.5-7,8.4v43.9c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-8v-15h12.5V266c0,11.7-4.8,20.4-19.4,20.4S581,277,581,264.3z
          "
          />
          <path
            id="_Compound_Path_23"
            d="M665.1,241.8h19.5v43.6h-9.9v-8.9c-1.8,6.1-5.7,9.9-13.1,9.9
          c-11.8,0-17.2-9.4-17.2-22.1v-39.5c0-12.8,6.1-22.1,20.6-22.1c15.2,0,19.7,8.4,19.7,20.5v7.2H672v-8.3c0-5.1-1.9-8-6.9-8
          s-7.1,3.5-7.1,8.4v43.9c0,4.9,2,8.4,6.8,8.4c4.5,0,6.8-2.5,6.8-7.8v-14.4h-6.5V241.8z"
          />
          <path
            id="_Compound_Path_24"
            d="M706.2,248v37.5h-13.8v-81.8h20c13.9,0,18.9,6.9,18.9,18.3v10.5c0,8.8-3.1,14-11,15.8
          l13.2,37.1h-14.4L706.2,248z M706.2,215v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12.1c0-4.5-2-6.6-6.8-6.6L706.2,215z"
          />
          <path
            id="_Compound_Path_25"
            d="M737.6,264.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.8,9.3,20.8,22.1v39.5
          c0,12.7-6.3,22.1-20.8,22.1S737.6,277,737.6,264.3z M765.5,266.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
          c0,4.9,2.2,8.4,7,8.4S765.5,271.5,765.5,266.5L765.5,266.5z"
          />
          <path
            id="_Compound_Path_26"
            d="M814.4,234.9l-7.7,50.5h-12.9l-11-81.7h13.3l6.4,51.8h0.1l6.9-51.8h11.2l7.6,51.8h0.1
          l6.3-51.8h11.6l-10.6,81.7h-13l-8.1-50.5L814.4,234.9z"
          />
          <path
            id="_Compound_Path_27"
            d="M850.5,203.7H887v11.2h-11.3v70.5h-13.9v-70.5h-11.3V203.7z"
          />
          <path
            id="_Compound_Path_28"
            d="M918.2,249.4H905v36h-13.8v-81.7H905v34.6h13.3v-34.6h13.9v81.7h-13.9V249.4z"
          />
        </g>
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)" fill="currentColor">
          {!quantitative && (
            <>
              <path
                d="m0 0-60.471-57.525c-2.282-2.272-3.452-3.943-3.452-8.64v-161.226c0-1.891 1.545-3.44 3.452-3.44h62.464c1.903 0 3.441 1.549 3.441 3.44v225.94c0 1.902-1.488 5.376-5.434 1.451"
                transform="translate(480.4389 324.8813)"
              />
              <path
                d="m0 0-60.479-57.518c-2.275-2.274-3.448-3.942-3.448-8.632v-86.294c0-1.885 1.549-3.434 3.448-3.434h62.468c1.907 0 3.445 1.549 3.445 3.434v151c0 1.906-1.502 5.387-5.434 1.444"
                transform="translate(306.2271 249.9349)"
              />
              <path
                d="m0 0c.022.458-.141.949-.513 1.31-.317.311-.725.455-1.119.492l-.332-.022-.495-.029-46.304-10.445-.841-.087c-.332-.065-.646-.231-.903-.473-.682-.689-.682-1.801 0-2.491l.524-.524 10.575-10.571-104.923-104.923-48.461 48.463c-.548.552-1.418.552-1.971 0l-13.149-13.153c-.011 0-.011-.015-.011-.015l-77.683-77.668c-.537-.549-.537-1.437 0-1.975l13.168-13.16c.538-.545 1.415-.545 1.957 0l76.715 76.697 35.166-35.169c.036-.055.054-.112.111-.166l13.154-13.139c.545-.553 1.422-.553 1.971 0l119.08 119.08 11.106-11.098c.682-.69 1.794-.69 2.469 0 .325.324.484.722.506 1.14l.007.149 10.171 47.268z"
                transform="translate(507.9257 394.6428)"
              />
              <path
                d="m0 0-29.259-29.501c-.557-.458-1.368-.444-1.885.072l-26.508 27.021c-4.852 4.834-5.9.914-5.9-.985v-138.949c0-1.892 1.524-3.441 3.423-3.441h62.483c1.892 0 3.437 1.549 3.437 3.441v141.252c0 1.899-1.498 5.386-5.791 1.09"
                transform="translate(393.6762 239.8402)"
              />
            </>
          )}
          <path
            d="m0 0c0-8.815-3.223-15.047-12.029-15.047-8.605 0-11.824 6.232-11.824 15.047v23.643c0 8.806 3.219 15.042 11.824 15.042 8.806 0 12.029-6.236 12.029-15.042zm-22.998 80.586c0 8.823 3.018 13.98 10.969 13.98 8.156 0 11.174-5.157 11.174-13.98v-9.877c0-8.811-3.018-13.981-11.174-13.981-7.951 0-10.969 5.17-10.969 13.981zm47.5-78.007v15.907c0 13.963-4.938 24.067-16.332 29.23 9.662 4.718 14.184 13.314 14.184 25.352v6.026c0 22.779-11.819 35.027-34.383 35.027-22.349 0-33.963-12.248-33.963-35.027v-6.026c0-11.823 4.307-20.634 13.754-25.352-11.389-5.163-16.122-15.267-16.122-29.23v-15.907c0-22.134 10.539-37.611 36.331-37.611 25.997 0 36.531 15.477 36.531 37.611"
            transform="translate(122.6936 556.7855)"
          />
          <path
            d="m0 0h27.403v-8.411h-8.501v-52.906h-10.402v52.906h-8.5z"
            transform="translate(199.1632 667.8229)"
          />
          <path
            d="m0 0v-19.081h3.434c3.53 0 5.067 1.806 5.067 5.063v9.044c0 3.346-1.537 4.974-5.067 4.974zm0-24.78v-28.125h-10.31v61.316h15.014c10.398 0 14.195-5.154 14.195-13.748v-7.867c0-6.602-2.35-10.491-8.23-11.846l9.859-27.855h-10.851z"
            transform="translate(241.6815 659.4114)"
          />
          <path
            d="m0 0h8.227l-4.068 24.598h-.092zm-12.934-19.444 11.576 61.317h11.757l11.665-61.317h-10.58l-1.899 11.214h-10.943l-1.81-11.214z"
            transform="translate(277.5091 625.95)"
          />
          <path
            d="m0 0-11.668-61.317h-11.213l-11.668 61.317h10.492l7.053-42.776h.092l7.235 42.776z"
            transform="translate(331.4186 667.8229)"
          />
          <path
            d="m0 0h8.227l-4.067 24.598h-.092zm-12.933-19.444 11.575 61.317h11.757l11.665-61.317h-10.58l-1.899 11.214h-10.943l-1.809-11.214z"
            transform="translate(341.5599 625.95)"
          />
          <path d="m367.892 667.823h10.31v-61.317h-10.31z" />
          <path
            d="m0 0h10.31v-52.908h12.298v-8.409h-22.608z"
            transform="translate(384.1772 667.8229)"
          />
          <path
            d="m0 0c4.249 0 5.877 2.531 5.877 6.239v32.107c0 3.619-1.628 6.151-5.877 6.151h-4.341v-44.497zm16.187 36.448v-28.396c0-9.407-3.889-16.46-14.921-16.46h-15.917v61.316h15.917c11.032 0 14.921-6.965 14.921-16.46"
            transform="translate(441.6476 614.9145)"
          />
          <path
            d="m0 0-16.19-2.08v5.788l16.19 3.435zm-21.434-4.341h24.598v-8.411h-14.288v-17.545h10.217v-8.319h-10.217v-18.633h14.288v-8.408h-24.598z"
            transform="translate(485.165 672.1637)"
          />
          <path
            d="m0 0v29.664c0 9.586 4.522 16.55 15.372 16.55 11.395 0 14.563-6.329 14.563-15.373v-7.235h-9.408v8.05c0 3.797-1.265 5.969-4.974 5.969-3.707 0-5.243-2.625-5.243-6.332v-32.921c0-3.708 1.536-6.329 5.243-6.329 3.709 0 4.974 2.347 4.974 5.966v11.309h9.408v-10.583c0-8.771-3.62-15.284-14.563-15.284-10.85 0-15.372 7.053-15.372 16.549"
            transform="translate(492.9565 622.3307)"
          />
          <path
            d="m0 0h24.599v-8.411h-14.288v-17.546h10.217v-8.319h-10.217v-18.632h14.288v-8.409h-24.599z"
            transform="translate(528.5099 667.8229)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.317h10.129l11.124-35.182v35.182h8.59v-61.317h-9.041z"
            transform="translate(567.3204 645.0309)"
          />
          <path
            d="m0 0h27.403v-8.411h-8.501v-52.906h-10.402v52.906h-8.5z"
            transform="translate(593.2009 667.8229)"
          />
          <path
            d="m0 0h24.599v-8.409h-14.289v-17.548h10.218v-8.319h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(200.3394 586.3891)"
          />
          <path
            d="m0 0h27.404v-8.409h-8.501v-52.904h-10.402v52.904h-8.501z"
            transform="translate(229.2913 586.3891)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.373 16.55 11.394 0 14.562-6.329 14.562-15.373v-7.238h-9.407v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.244-2.621-5.244-6.328v-32.921c0-3.709 1.536-6.329 5.244-6.329s4.974 2.347 4.974 5.966v11.308h9.407v-10.583c0-8.77-3.619-15.283-14.562-15.283-10.851 0-15.373 7.053-15.373 16.549"
            transform="translate(276.9962 540.9002)"
          />
          <path
            d="m0 0v-19.081h3.435c3.527 0 5.066 1.807 5.066 5.063v9.045c0 3.345-1.539 4.973-5.066 4.973zm0-24.78v-28.124h-10.31v61.313h15.014c10.399 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.35-10.494-8.231-11.849l9.859-27.851h-10.851z"
            transform="translate(322.8629 577.9803)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.328-5.336 6.328-3.616 0-5.244-2.62-5.244-6.328v-32.921c0-3.708 1.628-6.329 5.244-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.89 1.628v29.665c0 9.584 4.703 16.549 15.554 16.549 10.942 0 15.646-6.965 15.646-16.549v-29.665c0-9.496-4.704-16.549-15.646-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(368.2788 539.272)"
          />
          <path d="m384.485 586.389h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v8.23h9.588v-8.414c0-3.435 1.536-5.426 5.063-5.426 3.256 0 4.704 2.169 4.704 5.426v2.353c0 3.524-1.448 5.699-4.612 8.682l-6.061 6.061c-5.877 5.788-8.59 9.312-8.59 16.365v2.08c0 7.6 4.43 13.478 14.47 13.478 10.31 0 14.377-5.064 14.377-13.93v-4.974h-9.403v5.337c0 3.53-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.069v-1.266c0-3.434 1.899-5.425 4.882-8.319l6.602-6.507c5.606-5.698 8.319-9.139 8.319-15.919v-2.983c0-8.415-4.522-14.381-15.01-14.381-10.491 0-14.562 5.877-14.562 13.929"
            transform="translate(400.2234 538.2794)"
          />
          <path
            d="m0 0v8.23h9.588v-8.414c0-3.435 1.536-5.426 5.063-5.426 3.256 0 4.703 2.169 4.703 5.426v2.353c0 3.524-1.447 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.59 9.312-8.59 16.365v2.08c0 7.6 4.43 13.478 14.47 13.478 10.31 0 14.378-5.064 14.378-13.93v-4.974h-9.404v5.337c0 3.53-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.069v-1.266c0-3.434 1.899-5.425 4.882-8.319l6.602-6.507c5.606-5.698 8.319-9.139 8.319-15.919v-2.983c0-8.415-4.522-14.381-15.01-14.381-10.491 0-14.562 5.877-14.562 13.929"
            transform="translate(434.2444 538.2794)"
          />
          <path
            d="m0 0h8.227l-4.067 24.595h-.092zm-12.933-19.443 11.575 61.313h11.757l11.665-61.313h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
            transform="translate(479.6629 544.5188)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.313h10.129l11.124-35.178v35.178h8.59v-61.313h-9.041z"
            transform="translate(514.6764 563.5997)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.523 16.55 15.373 16.55 11.395 0 14.562-6.329 14.562-15.373v-7.238h-9.407v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.244-2.621-5.244-6.328v-32.921c0-3.709 1.536-6.329 5.244-6.329s4.974 2.347 4.974 5.966v11.308h9.407v-10.583c0-8.77-3.619-15.283-14.562-15.283-10.85 0-15.373 7.053-15.373 16.549"
            transform="translate(541.7298 540.9002)"
          />
          <path
            d="m0 0h24.599v-8.409h-14.289v-17.548h10.218v-8.319h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(577.2872 586.3891)"
          />
          <path
            d="m0 0-16.19-2.08v5.789l16.19 3.434zm-21.435-4.338h24.599v-8.414h-14.289v-17.542h10.218v-8.319h-10.218v-18.629h14.289v-8.415h-24.599z"
            transform="translate(221.7741 509.3021)"
          />
          <path
            d="m0 0v29.658c0 9.585 4.523 16.55 15.373 16.55 11.394 0 14.562-6.329 14.562-15.373v-7.232h-9.407v8.046c0 3.797-1.265 5.972-4.974 5.972-3.708 0-5.244-2.626-5.244-6.335v-32.914c0-3.708 1.536-6.335 5.244-6.335 3.709 0 4.974 2.353 4.974 5.973v11.302h9.407v-10.584c0-8.771-3.619-15.277-14.562-15.277-10.85 0-15.373 7.053-15.373 16.549"
            transform="translate(229.5649 459.4756)"
          />
          <path
            d="m0 0v32.914c0 3.709-1.628 6.335-5.336 6.335-3.616 0-5.244-2.626-5.244-6.335v-32.914c0-3.708 1.628-6.335 5.244-6.335 3.708 0 5.336 2.627 5.336 6.335m-20.89 1.628v29.658c0 9.585 4.703 16.55 15.554 16.55 10.943 0 15.646-6.965 15.646-16.55v-29.658c0-9.496-4.703-16.549-15.646-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(286.0124 457.8474)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.319h10.129l11.124-35.184v35.184h8.59v-61.319h-9.041z"
            transform="translate(310.897 482.1692)"
          />
          <path
            d="m0 0v32.914c0 3.709-1.628 6.335-5.336 6.335-3.616 0-5.244-2.626-5.244-6.335v-32.914c0-3.708 1.628-6.335 5.244-6.335 3.708 0 5.336 2.627 5.336 6.335m-20.89 1.628v29.658c0 9.585 4.703 16.55 15.554 16.55 10.943 0 15.647-6.965 15.647-16.55v-29.658c0-9.496-4.704-16.549-15.647-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(358.8439 457.8474)"
          />
          <path
            d="m0 0h-.27l-6.964-39.796h-4.793l-7.687 39.796h-.181v-39.796h-8.501v61.319h12.028l6.691-34.549h.092l5.969 34.549h13.023v-61.319h-9.407z"
            transform="translate(403.4457 483.4412)"
          />
          <path d="m418.749 504.965h10.31v-61.319h-10.31z" />
          <path
            d="m0 0v33.461c0 3.709-1.628 6.336-5.336 6.336-3.616 0-5.244-2.627-5.244-6.336v-33.461c0-3.612 1.628-6.328 5.244-6.328 3.708 0 5.336 2.716 5.336 6.328m-9.133-17.815v4.16c-8.23 1.45-11.757 7.505-11.757 15.83v29.658c0 9.585 4.704 16.55 15.554 16.55 10.943 0 15.646-6.965 15.646-16.55v-29.658c0-6.697-2.353-11.938-7.597-14.469l7.597-1.45v-7.69z"
            transform="translate(455.921 457.3003)"
          />
          <path
            d="m0 0v-46.398c0-9.496-4.071-15.64-14.562-15.64-10.851 0-15.373 6.144-15.373 15.64v46.398h10.31v-47.391c0-3.618 1.447-6.061 5.063-6.061 3.619 0 5.066 2.443 5.066 6.061v47.391z"
            transform="translate(502.0619 504.9645)"
          />
          <path
            d="m0 0h24.598v-8.415h-14.288v-17.542h10.217v-8.319h-10.217v-18.629h14.288v-8.414h-24.598z"
            transform="translate(507.9548 504.9645)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg9 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="_Compound_Path_"
          d="M183.1,134.5c0-31.2-13.7-53.8-49.3-53.8c-36,0-49.9,19.6-49.9,50.8v29.7
        c0,33,13.1,49.6,37.5,49.6c14.3,0,22.9-6.6,27.9-16.3h0.3V238c0,12.2-4.8,20.8-16.9,20.8s-16.6-7.2-16.6-19.7v-13.4H85.1v10.7
        c0,29.7,10.7,50.5,48.2,50.5c35.6,0,49.9-22.9,49.9-54.4V134.5z M149.5,165.4c-0.6,11.3-5.3,18.4-16,18.4c-11.6,0-16-7.1-16-20.2
        v-35.1c0-12.8,4.7-20.2,16.4-20.2c11.3,0,15.7,7.7,15.7,20.2L149.5,165.4z"
        />
        {!quantitative && (
          <path
            id="_Compound_Path_2"
            d="M749.9,657.3L631,588.7V451.4c0-2.9-1.5-5.5-4-7l-122.9-71c-2.5-1.5-5.6-1.5-8.1,0
        l-123,71c-2.5,1.5-4,4.1-4,7v137.3l-118.9,68.6c-2.5,1.4-4.1,4.1-4.1,7v142c0,2.9,1.6,5.6,4.1,7l122.9,71c2.5,1.4,5.6,1.4,8.1,0
        L500,815.6l118.8,68.6c2.5,1.4,5.6,1.4,8.1,0l122.9-71c2.5-1.4,4-4.1,4.1-7v-142C753.9,661.4,752.4,658.7,749.9,657.3z M491.9,792.2
        l-98.6-56.9l98.6-56.9L491.9,792.2z M606.7,593.4l-98.6,56.9V536.4L606.7,593.4z M491.9,650.3l-98.6-56.9l98.6-56.9L491.9,650.3z
         M516.2,664.3l106.7-61.5l106.7,61.6l-106.7,61.6L516.2,664.3z M614.8,579.3l-98.6-56.9l98.6-56.9V579.3z M483.8,522.3l-98.6,56.9
        V465.5L483.8,522.3z M369,863.2l-106.7-61.6V678.3L369,740V863.2z M385.2,863.2V749.3l98.6,56.9L385.2,863.2z M737.7,801.6
        L631,863.2V740l106.7-61.6L737.7,801.6z"
          />
        )}
        <g id="_Group_">
          <path id="_Compound_Path_3" d="M236.1,85.4h13.1v78h-13.1V85.4z" />
          <path
            id="_Compound_Path_4"
            d="M266.1,114.3v49H255v-78h12.9l14.1,44.7V85.4h11v78h-11.5L266.1,114.3z"
          />
          <path
            id="_Compound_Path_5"
            d="M337.9,106.3v36.1c0,12-4.9,20.9-19,20.9h-20.2v-78H319
          C333,85.4,337.9,94.2,337.9,106.3z M317.3,152.6c5.4,0,7.5-3.2,7.5-7.9v-40.8c0-4.6-2.1-7.8-7.5-7.8h-5.5v56.6H317.3z"
          />
          <path
            id="_Compound_Path_6"
            d="M381.7,85.4v59c0,12.1-5.2,19.9-18.5,19.9c-13.8,0-19.5-7.8-19.5-19.9v-59h13.1v60.2
          c0,4.6,1.8,7.7,6.4,7.7s6.4-3.1,6.4-7.7V85.4H381.7z"
          />
          <path
            id="_Compound_Path_7"
            d="M386.8,146.5v-10.5H399v10.7c0,4.4,2,6.9,6.4,6.9c4.1,0,6-2.8,6-6.9v-3
          c0-4.5-1.8-7.2-5.9-11l-7.7-7.7c-7.5-7.3-10.9-11.8-10.9-20.8v-2.7c0-9.7,5.6-17.1,18.4-17.1c13.1,0,18.3,6.4,18.3,17.7v6.3h-12
          v-6.8c0-4.5-2.1-6.7-6.2-6.7c-3.7,0-6.2,2.1-6.2,6.4v1.6c0,4.4,2.4,6.9,6.2,10.6l8.4,8.3c7.1,7.2,10.6,11.6,10.6,20.2v3.8
          c0,10.7-5.8,18.3-19.1,18.3S386.8,156.8,386.8,146.5z"
          />
          <path
            id="_Compound_Path_8"
            d="M425.2,85.4H460v10.7h-10.8v67.2H436V96.1h-10.8L425.2,85.4z"
          />
          <path
            id="_Compound_Path_9"
            d="M477.5,127.6v35.8h-13.1v-78h19.1c13.2,0,18,6.6,18,17.5v10c0,8.4-3,13.3-10.5,15.1
          l12.5,35.4h-13.8L477.5,127.6z M477.5,96.1v24.2h4.4c4.5,0,6.4-2.3,6.4-6.4v-11.5c0-4.3-2-6.3-6.4-6.3H477.5z"
          />
          <path
            id="_Compound_Path_10"
            d="M529.6,133.7v29.7h-13.1v-29.7l-14.6-48.3h13.7l7.9,29.5h0.1l7.9-29.6H544L529.6,133.7
          z"
          />
          <path
            id="_Compound_Path_11"
            d="M555.3,151.8l-6.7,17.6h-7.3l1.6-18.6h12.4V151.8z"
          />
          <path id="_Compound_Path_12" d="M571.4,85.4h13.1v78h-13.1V85.4z" />
          <path
            id="_Compound_Path_13"
            d="M601.4,114.3v49h-11v-78h12.9l14.1,44.7V85.4h10.9v78h-11.5L601.4,114.3z"
          />
          <path
            id="_Compound_Path_14"
            d="M645.1,114.3v49h-11v-78H647l14.1,44.7V85.4H672v78h-11.5L645.1,114.3z"
          />
          <path
            id="_Compound_Path_15"
            d="M677.7,143.2v-37.7c0-12.2,6-21,19.8-21s19.9,8.9,19.9,21v37.7c0,12.1-6,21-19.9,21
          S677.7,155.3,677.7,143.2z M704.3,145.3v-41.9c0-4.7-2.1-8-6.8-8s-6.7,3.3-6.7,8v41.8c0,4.7,2.1,8.1,6.7,8.1S704.3,150,704.3,145.3
          L704.3,145.3z"
          />
          <path
            id="_Compound_Path_16"
            d="M765.1,85.4l-14.8,78H736l-14.8-78h13.3l9,54.4h0.1l9.2-54.4L765.1,85.4z"
          />
          <path
            id="_Compound_Path_17"
            d="M761,163.3l14.7-78h15l14.8,78H792l-2.4-14.3h-13.9l-2.3,14.3H761z M777.4,138.6h10.5
          l-5.2-31.3h-0.1L777.4,138.6z"
          />
          <path
            id="_Compound_Path_18"
            d="M801.9,85.4h34.8v10.7h-10.8v67.2h-13.2V96.1h-10.8V85.4z"
          />
          <path id="_Compound_Path_19" d="M841.1,85.4h13.1v78h-13.1V85.4z" />
          <path
            id="_Compound_Path_20"
            d="M860.1,143.2v-37.7c0-12.2,6-21,19.8-21s19.9,8.9,19.9,21v37.7c0,12.1-6,21-19.9,21
          S860.1,155.3,860.1,143.2z M886.6,145.3v-41.9c0-4.7-2.1-8-6.8-8s-6.7,3.3-6.7,8v41.8c0,4.7,2.1,8.1,6.7,8.1S886.6,150,886.6,145.3
          L886.6,145.3z"
          />
          <path
            id="_Compound_Path_21"
            d="M916.5,114.3v49h-11v-78h12.9l14.1,44.7V85.4h10.9v78H932L916.5,114.3z"
          />
        </g>
        <g id="_Group_2">
          <path
            id="_Compound_Path_22"
            d="M234,283.4l14.7-77.9h14.9l14.8,77.9H265l-2.4-14.2h-13.9l-2.3,14.2H234z M250.4,258.7
          h10.5l-5.2-31.3h-0.1L250.4,258.7z"
          />
          <path
            id="_Compound_Path_23"
            d="M294.3,234.5v49h-11v-78h12.9l14.1,44.7v-44.7h10.9v77.9h-11.5L294.3,234.5z"
          />
          <path
            id="_Compound_Path_24"
            d="M367.3,226.4v36.1c0,12-5,20.9-19,20.9h-20.2v-77.9h20.2
          C362.4,205.5,367.3,214.3,367.3,226.4z M346.7,272.7c5.4,0,7.5-3.2,7.5-7.9V224c0-4.6-2.1-7.8-7.5-7.8h-5.5v56.6L346.7,272.7z"
          />
          <path
            id="_Compound_Path_25"
            d="M385.7,205.5h13.1v77.9h-13.1V205.5z"
          />
          <path
            id="_Compound_Path_26"
            d="M416.8,234.5v49h-11v-78h12.9l14.1,44.7v-44.7h10.9v77.9h-11.5L416.8,234.5z"
          />
          <path
            id="_Compound_Path_27"
            d="M450.6,205.5h30.7v10.7h-17.6v22.3h13.1v10.6h-13.1v34.4h-13.1V205.5z"
          />
          <path
            id="_Compound_Path_28"
            d="M499.6,247.7v35.8h-13.1v-77.9h19.1c13.2,0,18,6.6,18,17.5v10c0,8.4-3,13.3-10.5,15.1
          l12.5,35.4h-13.8L499.6,247.7z M499.6,216.2v24.3h4.4c4.5,0,6.4-2.3,6.4-6.4v-11.5c0-4.3-2-6.3-6.4-6.3H499.6z"
          />
          <path
            id="_Compound_Path_29"
            d="M528.1,283.4l14.7-77.9h14.9l14.8,77.9h-13.5l-2.4-14.2h-13.9l-2.3,14.2H528.1z
           M544.6,258.7H555l-5.2-31.3h-0.1L544.6,258.7z"
          />
          <path
            id="_Compound_Path_30"
            d="M575.6,266.7v-10.5h12.2v10.7c0,4.4,2,6.9,6.4,6.9c4.1,0,6-2.8,6-6.9v-3
          c0-4.5-1.8-7.2-5.9-11l-7.7-7.7c-7.5-7.4-10.9-11.8-10.9-20.8v-2.6c0-9.7,5.6-17.1,18.4-17.1c13.1,0,18.3,6.4,18.3,17.7v6.3h-12
          v-6.8c0-4.5-2.1-6.7-6.2-6.7c-3.7,0-6.2,2.1-6.2,6.4v1.6c0,4.4,2.4,6.9,6.2,10.6l8.4,8.3c7.1,7.2,10.6,11.6,10.6,20.2v3.8
          c0,10.7-5.8,18.3-19.1,18.3S575.6,276.9,575.6,266.7z"
          />
          <path
            id="_Compound_Path_31"
            d="M616.3,205.5h34.8v10.7h-10.8v67.2h-13.2v-67.2h-10.8V205.5z"
          />
          <path
            id="_Compound_Path_32"
            d="M669.8,247.7v35.8h-13.1v-77.9h19.1c13.2,0,18,6.6,18,17.5v10c0,8.4-3,13.3-10.5,15.1
          l12.5,35.4H682L669.8,247.7z M669.8,216.2v24.3h4.4c4.5,0,6.4-2.3,6.4-6.4v-11.5c0-4.3-2-6.3-6.4-6.3H669.8z"
          />
          <path
            id="_Compound_Path_33"
            d="M738.4,205.5v59c0,12.1-5.2,19.9-18.5,19.9c-13.8,0-19.5-7.8-19.5-19.9v-59h13.1v60.2
          c0,4.6,1.8,7.7,6.4,7.7s6.4-3.1,6.4-7.7v-60.2H738.4z"
          />
          <path
            id="_Compound_Path_34"
            d="M745.3,263.3v-37.7c0-12.2,5.8-21,19.5-21c14.5,0,18.5,8,18.5,19.5v9.2h-12v-10.3
          c0-4.8-1.6-7.6-6.3-7.6s-6.7,3.3-6.7,8.1v41.8c0,4.7,2,8,6.7,8s6.3-3,6.3-7.6v-14.3h12v13.4c0,11.1-4.6,19.4-18.5,19.4
          S745.3,275.4,745.3,263.3z"
          />
          <path
            id="_Compound_Path_35"
            d="M785.5,205.5h34.8v10.7h-10.8v67.2h-13.2v-67.2h-10.8V205.5z"
          />
          <path
            id="_Compound_Path_36"
            d="M863.9,205.5v59c0,12.1-5.2,19.9-18.5,19.9c-13.8,0-19.5-7.8-19.5-19.9v-59H839v60.2
          c0,4.6,1.8,7.7,6.4,7.7s6.4-3.1,6.4-7.7v-60.2H863.9z"
          />
          <path
            id="_Compound_Path_37"
            d="M883.9,247.7v35.8h-13.1v-77.9h19.1c13.2,0,18,6.6,18,17.5v10c0,8.4-3,13.3-10.5,15.1
          l12.5,35.4h-13.8L883.9,247.7z M883.9,216.2v24.3h4.4c4.5,0,6.4-2.3,6.4-6.4v-11.5c0-4.3-2-6.3-6.4-6.3H883.9z"
          />
          <path
            id="_Compound_Path_38"
            d="M914.5,205.5h31.3v10.7h-18.2v22.3h13v10.6h-13v23.7h18.2v10.7h-31.3V205.5z"
          />
        </g>
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)" fill="currentColor">
          {!quantitative && (
            <path
              d="m0 0-64.27-37.092v74.194l64.27 37.108zm-212.314-37.092v68.557l59.373-34.285zm-9.765 0-64.261 37.092v74.21l64.261-37.108zm69.138 205.233-59.373-34.286v68.564zm78.905-34.284-59.366 34.284 59.366 34.278zm-59.366-51.19 64.249 37.09 64.267-37.088-64.267-37.106zm-14.652 8.459-59.373 34.272 59.373 34.285zm69.131 34.27-59.366-34.268v68.555zm-69.131-119.757-59.377 34.285 59.377 34.286zm155.379 81.26-71.595 41.319v82.66c0 1.745-.929 3.357-2.442 4.231l-74.018 42.735c-1.513.87-3.37.87-4.883 0l-74.026-42.735c-1.512-.874-2.44-2.486-2.44-4.231v-82.66l-71.585-41.319c-1.513-.873-2.441-2.485-2.441-4.23v-85.489c0-1.745.928-3.357 2.441-4.23l74.025-42.729c.758-.435 1.598-.655 2.442-.655s1.685.22 2.442.655l71.584 41.32 71.576-41.32c.757-.435 1.597-.655 2.442-.655.844 0 1.685.218 2.441.655l74.037 42.729c1.513.872 2.441 2.485 2.441 4.23v85.489c0 1.745-.928 3.359-2.441 4.23"
              transform="translate(520.7837 140.6263)"
            />
          )}
          <path
            d="m0 0c-.43-8.157-3.863-13.312-11.596-13.312-8.367 0-11.599 5.155-11.599 14.611v25.343c0 9.237 3.429 14.602 11.814 14.602 8.162 0 11.381-5.58 11.381-14.602zm24.283 22.341c0 22.561-9.889 38.88-35.664 38.88-25.997 0-36.084-14.17-36.084-36.727v-21.483c0-23.847 9.442-35.872 27.068-35.872 10.31 0 16.534 4.732 20.187 11.808h.21v-31.352c0-8.807-3.438-15.04-12.24-15.04-8.811 0-12.03 5.157-12.03 14.18v9.662h-22.344v-7.736c0-21.477 7.74-36.513 34.808-36.513 25.765 0 36.089 16.541 36.089 39.312z"
            transform="translate(126.8446 610.4169)"
          />
          <path d="m209.412 668.202h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v-38.521h-8.682v61.313h10.129l11.124-35.182v35.182h8.589v-61.313h-9.04z"
            transform="translate(234.3795 645.4102)"
          />
          <path
            d="m0 0c4.249 0 5.877 2.532 5.877 6.239v32.104c0 3.619-1.628 6.15-5.877 6.15h-4.341v-44.493zm16.187 36.444v-28.392c0-9.407-3.889-16.46-14.921-16.46h-15.917v61.312h15.917c11.032 0 14.921-6.964 14.921-16.46"
            transform="translate(276.087 615.2977)"
          />
          <path
            d="m0 0v-46.392c0-9.495-4.071-15.646-14.562-15.646-10.851 0-15.373 6.151-15.373 15.646v46.392h10.31v-47.39c0-3.613 1.447-6.055 5.063-6.055 3.619 0 5.066 2.442 5.066 6.055v47.39z"
            transform="translate(328.1019 668.2022)"
          />
          <path
            d="m0 0v8.227h9.588v-8.411c0-3.434 1.536-5.425 5.064-5.425 3.256 0 4.703 2.175 4.703 5.425v2.353c0 3.523-1.447 5.695-4.612 8.678l-6.061 6.062c-5.877 5.788-8.59 9.315-8.59 16.368v2.08c0 7.597 4.431 13.474 14.47 13.474 10.31 0 14.378-5.063 14.378-13.926v-4.973h-9.404v5.333c0 3.53-1.628 5.247-4.884 5.247-2.895 0-4.883-1.628-4.883-5.066v-1.265c0-3.435 1.899-5.426 4.883-8.32l6.601-6.51c5.607-5.699 8.32-9.136 8.32-15.916v-2.983c0-8.409-4.523-14.381-15.011-14.381-10.491 0-14.562 5.877-14.562 13.929"
            transform="translate(333.4503 620.0931)"
          />
          <path
            d="m0 0h27.404v-8.411h-8.501v-52.902h-10.402v52.902h-8.501z"
            transform="translate(365.9322 668.2022)"
          />
          <path
            d="m0 0v-19.081h3.434c3.527 0 5.066 1.807 5.066 5.063v9.045c0 3.345-1.539 4.973-5.066 4.973zm0-24.78v-28.121h-10.31v61.312h15.013c10.399 0 14.196-5.155 14.196-13.747v-7.868c0-6.602-2.35-10.491-8.23-11.846l9.858-27.851h-10.85z"
            transform="translate(408.4513 659.7908)"
          />
          <path d="m432.97 668.202h10.31v-61.313h-10.31z" />
          <path
            d="m0 0h24.599v-8.411h-14.289v-17.545h10.218v-8.32h-10.218v-18.628h14.289v-8.409h-24.599z"
            transform="translate(449.2554 668.2022)"
          />
          <path
            d="m0 0-5.244-13.84h-5.788l1.266 14.654h9.766z"
            transform="translate(489.9645 615.9333)"
          />
          <path d="m209.412 586.778h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.129l11.124-35.179v35.179h8.589v-61.314h-9.04z"
            transform="translate(234.3795 563.9895)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.129l11.124-35.179v35.179h8.59v-61.314h-9.041z"
            transform="translate(270.1179 563.9895)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.329-5.336 6.329-3.616 0-5.244-2.621-5.244-6.329v-32.921c0-3.708 1.628-6.329 5.244-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.89 1.628v29.665c0 9.585 4.703 16.549 15.554 16.549 10.943 0 15.647-6.964 15.647-16.549v-29.665c0-9.496-4.704-16.549-15.647-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(318.0616 539.6611)"
          />
          <path
            d="m0 0-11.668-61.313h-11.213l-11.665 61.313h10.488l7.053-42.773h.093l7.234 42.773z"
            transform="translate(365.4685 586.7782)"
          />
          <path
            d="m0 0h8.227l-4.067 24.601h-.093zm-12.934-19.444 11.576 61.314h11.757l11.665-61.314h-10.58l-1.899 11.214h-10.943l-1.809-11.214z"
            transform="translate(375.6098 544.9085)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.501v-52.905h-10.402v52.905h-8.5z"
            transform="translate(396.2428 586.7782)"
          />
          <path d="m428.448 586.778h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.329-5.336 6.329-3.616 0-5.244-2.621-5.244-6.329v-32.921c0-3.708 1.628-6.329 5.244-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.89 1.628v29.665c0 9.585 4.703 16.549 15.554 16.549 10.942 0 15.646-6.964 15.646-16.549v-29.665c0-9.496-4.704-16.549-15.646-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(465.6237 539.6611)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.129l11.124-35.179v35.179h8.589v-61.314h-9.041z"
            transform="translate(490.5115 563.9895)"
          />
          <path
            d="m0 0h24.598v-8.408h-14.288v-17.542h10.217v-8.326h-10.217v-18.629h14.288v-8.408h-24.598z"
            transform="translate(533.0641 586.7782)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.501v-52.905h-10.401v52.905h-8.501z"
            transform="translate(562.016 586.7782)"
          />
          <path d="m209.412 505.348h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v-38.524h-8.682v61.313h10.129l11.124-35.178v35.178h8.589v-61.313h-9.04z"
            transform="translate(234.3795 482.5583)"
          />
          <path
            d="m0 0h24.147v-8.409h-13.837v-17.541h10.31v-8.326h-10.31v-27.037h-10.31z"
            transform="translate(261.4362 505.3477)"
          />
          <path
            d="m0 0v-19.08h3.435c3.53 0 5.066 1.806 5.066 5.062v9.045c0 3.345-1.536 4.973-5.066 4.973zm0-24.779v-28.126h-10.31v61.314h15.014c10.399 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.35-10.488-8.231-11.849l9.859-27.852h-10.85z"
            transform="translate(300.4245 496.9389)"
          />
          <path
            d="m0 0h8.227l-4.067 24.602h-.093zm-12.933-19.443 11.575 61.313h11.757l11.665-61.313h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
            transform="translate(336.2555 463.4774)"
          />
          <path
            d="m0 0v8.23h9.588v-8.408c0-3.441 1.536-5.432 5.063-5.432 3.256 0 4.703 2.176 4.703 5.432v2.347c0 3.53-1.447 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.589 9.312-8.589 16.365v2.08c0 7.6 4.429 13.478 14.469 13.478 10.31 0 14.378-5.064 14.378-13.93v-4.974h-9.404v5.337c0 3.53-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.265c0-3.441 1.899-5.425 4.882-8.326l6.602-6.507c5.606-5.698 8.319-9.133 8.319-15.919v-2.983c0-8.408-4.519-14.38-15.01-14.38s-14.562 5.876-14.562 13.928"
            transform="translate(361.14 457.238)"
          />
          <path
            d="m0 0h27.403v-8.409h-8.5v-52.904h-10.402v52.904h-8.501z"
            transform="translate(393.622 505.3477)"
          />
          <path
            d="m0 0v-19.08h3.435c3.527 0 5.066 1.806 5.066 5.062v9.045c0 3.345-1.539 4.973-5.066 4.973zm0-24.779v-28.126h-10.31v61.314h15.014c10.399 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.35-10.488-8.231-11.849l9.859-27.852h-10.85z"
            transform="translate(436.1371 496.9389)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.562-15.646-10.851 0-15.373 6.15-15.373 15.646v46.392h10.31v-47.384c0-3.619 1.447-6.062 5.063-6.062 3.619 0 5.066 2.443 5.066 6.062v47.384z"
            transform="translate(490.5943 505.3477)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.373 16.55 11.394 0 14.562-6.329 14.562-15.373v-7.238h-9.407v8.052c0 3.797-1.265 5.966-4.974 5.966-3.708 0-5.243-2.62-5.243-6.328v-32.921c0-3.709 1.535-6.329 5.243-6.329 3.709 0 4.974 2.353 4.974 5.966v11.308h9.407v-10.583c0-8.77-3.619-15.283-14.562-15.283-10.851 0-15.373 7.053-15.373 16.549"
            transform="translate(496.4898 459.8588)"
          />
          <path
            d="m0 0h27.403v-8.409h-8.501v-52.904h-10.401v52.904h-8.501z"
            transform="translate(529.9675 505.3477)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.562-15.646-10.851 0-15.373 6.15-15.373 15.646v46.392h10.31v-47.384c0-3.619 1.447-6.062 5.063-6.062 3.619 0 5.066 2.443 5.066 6.062v47.384z"
            transform="translate(592.1074 505.3477)"
          />
          <path
            d="m0 0v-19.08h3.434c3.527 0 5.067 1.806 5.067 5.062v9.045c0 3.345-1.54 4.973-5.067 4.973zm0-24.779v-28.126h-10.31v61.314h15.014c10.398 0 14.195-5.153 14.195-13.745v-7.868c0-6.602-2.35-10.488-8.23-11.849l9.859-27.852h-10.851z"
            transform="translate(608.3102 496.9389)"
          />
          <path
            d="m0 0h24.599v-8.409h-14.289v-17.541h10.218v-8.326h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(632.8321 505.3477)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg10 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M333.1,128.5l13.1,38.1H361l-13.3-37.7c8-1.8,11.1-7.1,11.1-16v-10.7c0-11.6-5.1-18.6-19.2-18.6h-20.4v83h14
        L333.1,128.5z M333.1,95h4.6c4.8,0,6.9,2.2,6.9,6.8V114c0,4.4-2.1,6.9-6.9,6.9h-4.6V95z"
        />
        <polygon
          points="400.9,155.2 381.5,155.2 381.5,130 395.4,130 395.4,118.7 381.5,118.7 381.5,95 400.9,95 400.9,83.6 
        367.6,83.6 367.6,166.6 400.9,166.6 "
        />
        <path
          d="M431.1,83.6h-21.5v83h21.5c14.9,0,20.2-9.6,20.2-22.3v-38.4C451.3,93,446.1,83.6,431.1,83.6 M437.4,146.8
        c0,5-2.2,8.4-8,8.4h-5.9V95h5.9c5.8,0,8,3.4,8,8.3V146.8z"
        />
        <path
          d="M474.5,83.6h-14v62.8c0,12.9,6.1,21.2,20.8,21.2c14.2,0,19.7-8.3,19.7-21.2V83.6h-12.8v64.2
        c0,4.9-2,8.2-6.9,8.2s-6.9-3.3-6.9-8.2V83.6z"
        />
        <path
          d="M510.3,105v40.2c0,12.9,6.1,22.4,20.8,22.4s19.7-8.8,19.7-20.7v-14.3h-12.7v15.3c0,4.9-1.7,8.1-6.7,8.1
        s-7.1-3.5-7.1-8.6v-44.6c0-5,2.1-8.6,7.1-8.6s6.7,2.9,6.7,8.1v10.9h12.7v-9.8c0-12.3-4.3-20.8-19.7-20.8
        C516.4,82.6,510.3,92,510.3,105"
        />
        <polygon
          points="559.6,166.6 592.9,166.6 592.9,155.2 573.6,155.2 573.6,130 587.4,130 587.4,118.7 573.6,118.7 
        573.6,95 592.9,95 592.9,83.6 559.6,83.6 "
        />
        <path
          d="M601.6,83.6v83h21.6c14.9,0,20.2-9.6,20.2-22.3v-38.4c0-12.9-5.3-22.3-20.2-22.3L601.6,83.6z M629.4,103.3v43.5
        c0,5-2.2,8.4-8,8.4h-5.9V95h5.9C627.2,95,629.4,98.4,629.4,103.3"
        />
        <rect x="319.2" y="202.4" width="14" height="83" />
        <polygon
          points="382.6,202.4 371,202.4 371,250 355.9,202.4 342.2,202.4 342.2,285.4 354,285.4 354,233.2 370.4,285.4 
        382.6,285.4 "
        />
        <polygon
          points="423.8,213.8 423.8,202.4 390.5,202.4 390.5,285.4 423.8,285.4 423.8,274 404.5,274 404.5,248.8 
        418.3,248.8 418.3,237.5 404.5,237.5 404.5,213.8 "
        />
        <path
          d="M450,201.4c-14.7,0-21.1,9.4-21.1,22.4V264c0,11.3,4.8,19.5,15.9,21.4v5.6l26.3,4.9v-10.4l-10.3-2
        c7.1-3.4,10.3-10.5,10.3-19.6v-40.1C471.2,210.8,464.8,201.4,450,201.4 M457.2,266.9c0,4.9-2.2,8.6-7.2,8.6s-7.1-3.7-7.1-8.6v-45.3
        c0-5,2.2-8.6,7.1-8.6s7.2,3.6,7.2,8.6V266.9z"
        />
        <path
          d="M479,202.4v62.8c0,12.9,6.1,21.2,20.8,21.2c14.2,0,19.7-8.3,19.7-21.2v-62.8h-12.9v64.2c0,4.9-2,8.2-6.9,8.2
        s-6.9-3.3-6.9-8.2v-64.2H479z"
        />
        <path
          d="M539.7,202.4l-15.7,83h13.2l2.4-15.2h14.8l2.6,15.2h14.3l-15.8-83H539.7z M541.6,259.1l5.5-33.3h0.1l5.5,33.3
        H541.6z"
        />
        <polygon points="577.1,202.4 577.1,285.4 607.7,285.4 607.7,274 591.1,274 591.1,202.4 " />
        <rect x="614" y="202.4" width="14" height="83" />
        <polygon points="659.9,285.4 659.9,213.8 671.4,213.8 671.4,202.4 634.3,202.4 634.3,213.8 645.8,213.8 645.8,285.4 " />
        <rect x="677.8" y="202.4" width="14" height="83" />
        <polygon
          points="733,274 713.7,274 713.7,248.8 727.5,248.8 727.5,237.5 713.7,237.5 713.7,213.8 733,213.8 733,202.4 
        699.7,202.4 699.7,285.4 733,285.4 "
        />
        <path
          d="M738.5,256.4v11.1c0,10.9,5.5,18.9,19.7,18.9s20.3-8.1,20.3-19.5v-4c0-9.2-3.7-13.8-11.3-21.6l-9-8.8
        c-4-3.9-6.6-6.6-6.6-11.3v-1.7c0-4.7,2.7-6.9,6.6-6.9c4.4,0,6.6,2.3,6.6,7.1v7.2h12.8v-6.8c0-12-5.5-18.9-19.5-18.9
        c-13.6,0-19.6,8-19.6,18.2v2.8c0,9.6,3.7,14.3,11.6,22.2l8.2,8.2c4.3,4,6.2,7,6.2,11.8v3.2c0,4.4-2,7.4-6.4,7.4
        c-4.8,0-6.9-2.7-6.9-7.4v-11.4H738.5z"
        />
        <polygon points="96.5,131 96.5,285.5 130.4,285.5 130.4,83.7 103.3,83.7 72.1,120.3 72.1,155.7 72.4,155.7 96.2,131 " />
        <path
          d="M254.2,233.4v-97.6c0-31.6-15.8-54.5-50.3-54.5c-34.2,0-50,22.9-50,54.5v97.6c0,31.2,15.8,54.5,50,54.5
        C238.5,287.9,254.2,264.7,254.2,233.4 M187.9,238.8V130.4c0-12.2,4.5-20.8,16.1-20.8c11.9,0,16.4,8.6,16.4,20.8v108.4
        c0,12.2-4.5,20.8-16.4,20.8C192.3,259.6,187.9,251,187.9,238.8"
        />
        {!quantitative && (
          <g>
            <g>
              <path
                d="M592.3,657.5H407.7c-1.2,0.1-2.1,1.1-2,2.2v55.5c-0.1,1.2,0.8,2.2,2,2.2h184.6c1.2-0.1,2.1-1.1,2-2.2v-55.5
            C594.4,658.6,593.5,657.6,592.3,657.5"
              />
              <path
                d="M592.3,539.5H407.7c-1.2,0.1-2.1,1.1-2,2.2v55.5c-0.1,1.2,0.8,2.2,2,2.2h184.6c1.2-0.1,2.1-1.1,2-2.2v-55.5
            C594.4,540.6,593.5,539.6,592.3,539.5"
              />
            </g>
            <g>
              <path
                d="M589.7,455.6L501.1,367c-0.6-0.6-1.6-0.6-2.2,0l-88.6,88.6c-0.6,0.6-0.6,1.6,0,2.2c0.3,0.3,0.7,0.4,1.1,0.4
            h177.2c0.8,0,1.5-0.7,1.5-1.5C590.1,456.3,590,455.9,589.7,455.6z"
              />
              <path
                d="M672.9,718.2l88.6-88.6c0.6-0.6,0.6-1.6,0-2.2c0,0,0,0,0,0l-88.6-88.6c-0.6-0.6-1.6-0.6-2.2,0
            c-0.3,0.3-0.4,0.7-0.4,1.1v177.2c0,0.8,0.7,1.5,1.5,1.5C672.2,718.7,672.6,718.5,672.9,718.2z"
              />
              <path
                d="M410.3,801.4l88.6,88.6c0.6,0.6,1.6,0.6,2.1,0c0,0,0,0,0,0l88.6-88.6c0.6-0.6,0.6-1.6,0-2.2
            c-0.3-0.3-0.7-0.5-1.1-0.5H411.4c-0.8,0-1.5,0.6-1.6,1.5C409.8,800.7,410,801.1,410.3,801.4z"
              />
              <path
                d="M327.1,538.8l-88.6,88.6c-0.6,0.6-0.6,1.6,0,2.2c0,0,0,0,0,0l88.6,88.6c0.6,0.6,1.6,0.6,2.2,0
            c0.3-0.3,0.4-0.7,0.4-1.1V539.9c0-0.8-0.7-1.5-1.5-1.5C327.8,538.4,327.4,538.5,327.1,538.8z"
              />
            </g>
          </g>
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g fill="currentColor">
          <path
            d="m0 0v-111.652h24.524v145.86h-19.582l-22.582-26.462v-25.608h.207l17.208 17.862z"
            transform="translate(76.759 635.296)"
          />
          <g clipPath="url(#a)">
            <path
              d="m0 0v78.315c0 8.82 3.224 15.06 11.617 15.06 8.605 0 11.828-6.24 11.828-15.06v-78.315c0-8.824-3.223-15.049-11.828-15.049-8.393 0-11.617 6.225-11.617 15.049m47.974 3.872v70.573c0 22.805-11.399 39.365-36.357 39.365-24.734 0-36.15-16.56-36.15-39.365v-70.573c0-22.581 11.416-39.365 36.15-39.365 24.958 0 36.357 16.784 36.357 39.365"
              transform="translate(142.801 557.4131)"
            />
            <path d="m246.594 670.823h10.311v-61.316h-10.311z" />
            <path
              d="m0 0v-38.524h-8.682v61.316h10.132l11.124-35.182v35.182h8.594v-61.316h-9.045z"
              transform="translate(271.5578 648.0308)"
            />
            <path
              d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.435-4.341h24.602v-8.411h-14.291v-17.545h10.221v-8.319h-10.221v-18.633h14.291v-8.408h-24.602z"
              transform="translate(320.049 675.1636)"
            />
            <path
              d="m0 0h14.654v-32.736h-7.416v6.691c-1.361-4.611-4.255-7.416-9.859-7.416-8.865 0-12.937 7.053-12.937 16.549v29.664c0 9.585 4.619 16.55 15.469 16.55 11.391 0 14.743-6.329 14.743-15.373v-5.425h-9.407v6.24c0 3.797-1.45 5.968-5.158 5.968s-5.336-2.624-5.336-6.331v-32.921c0-3.708 1.539-6.329 5.068-6.329 3.346 0 5.064 1.895 5.064 5.877v10.854h-4.885z"
              transform="translate(343.3976 642.2427)"
            />
            <path
              d="m0 0h8.229l-4.07 24.598h-.089zm-12.931-19.443 11.577 61.316h11.753l11.664-61.316h-10.577l-1.901 11.213h-10.939l-1.814-11.213z"
              transform="translate(375.2502 628.9498)"
            />
            <path
              d="m0 0h10.31v-52.908h12.3v-8.408h-22.61z"
              transform="translate(401.5754 670.8228)"
            />
            <path d="m428.893 670.823h10.31v-61.316h-10.31z" />
            <path
              d="m0 0h27.399v-8.412h-8.503v-52.904h-10.399v52.904h-8.497z"
              transform="translate(444.0109 670.8228)"
            />
            <path
              d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.434-4.341h24.602v-8.411h-14.292v-17.545h10.222v-8.319h-10.222v-18.633h14.292v-8.408h-24.602z"
              transform="translate(497.6467 675.1636)"
            />
            <path
              d="m0 0v8.23h9.584v-8.415c0-3.434 1.54-5.425 5.07-5.425 3.25 0 4.7 2.169 4.7 5.425v2.354c0 3.527-1.45 5.699-4.612 8.682l-6.06 6.061c-5.877 5.788-8.593 9.314-8.593 16.368v2.08c0 7.598 4.432 13.474 14.47 13.474 10.309 0 14.379-5.063 14.379-13.926v-4.973h-9.406v5.333c0 3.529-1.628 5.247-4.878 5.247-2.894 0-4.884-1.628-4.884-5.066v-1.266c0-3.434 1.895-5.425 4.884-8.319l6.602-6.51c5.603-5.699 8.319-9.136 8.319-15.92v-2.983c0-8.414-4.522-14.38-15.016-14.38-10.489 0-14.559 5.876-14.559 13.929"
              transform="translate(505.3498 622.7105)"
            />
            <path
              d="m0 0v-19.081h3.44c3.524 0 5.063 1.807 5.063 5.063v9.044c0 3.346-1.539 4.974-5.063 4.974zm0-24.78v-28.125h-10.311v61.313h15.017c10.399 0 14.196-5.152 14.196-13.744v-7.868c0-6.602-2.353-10.495-8.23-11.85l9.858-27.851h-10.85z"
              transform="translate(256.9045 576.4586)"
            />
            <path
              d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.434-4.344h24.602v-8.408h-14.292v-17.548h10.222v-8.32h-10.222v-18.629h14.292v-8.408h-24.602z"
              transform="translate(302.8566 589.2105)"
            />
            <path
              d="m0 0c4.248 0 5.877 2.531 5.877 6.239v32.107c0 3.619-1.629 6.151-5.877 6.151h-4.344v-44.497zm16.187 36.444v-28.392c0-9.406-3.886-16.46-14.921-16.46h-15.92v61.312h15.92c11.035 0 14.921-6.964 14.921-16.46"
              transform="translate(326.2121 531.962)"
            />
            <path
              d="m0 0v-46.391c0-9.496-4.071-15.647-14.559-15.647-10.857 0-15.379 6.151-15.379 15.647v46.391h10.31v-47.391c0-3.611 1.45-6.054 5.069-6.054 3.613 0 5.063 2.443 5.063 6.054v47.391z"
              transform="translate(378.2267 584.8663)"
            />
            <path d="m384.122 584.866h10.311v-61.313h-10.311z" />
            <path
              d="m0 0h27.399v-8.408h-8.503v-52.905h-10.399v52.905h-8.497z"
              transform="translate(399.2346 584.8663)"
            />
            <path
              d="m0 0h24.602v-8.408h-14.292v-17.548h10.221v-8.319h-10.221v-18.629h14.292v-8.409h-24.602z"
              transform="translate(431.4367 584.8663)"
            />
            <path
              d="m0 0v8.23h9.585v-8.414c0-3.435 1.539-5.425 5.069-5.425 3.25 0 4.7 2.168 4.7 5.425v2.353c0 3.523-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.312-8.593 16.365v2.08c0 7.601 4.433 13.477 14.47 13.477 10.31 0 14.38-5.063 14.38-13.929v-4.973h-9.406v5.336c0 3.529-1.629 5.247-4.879 5.247-2.894 0-4.884-1.628-4.884-5.069v-1.266c0-3.434 1.895-5.425 4.884-8.319l6.602-6.507c5.603-5.698 8.32-9.139 8.32-15.919v-2.984c0-8.414-4.523-14.38-15.017-14.38-10.489 0-14.559 5.877-14.559 13.929"
              transform="translate(460.5793 536.7574)"
            />
            {!quantitative && (
              <>
                <path
                  d="m0 0h-132.996c-.8 0-1.445-.726-1.445-1.614v-39.97c0-.907.645-1.624 1.445-1.624h132.996c.815 0 1.462.717 1.462 1.624v39.97c0 .888-.647 1.614-1.462 1.614"
                  transform="translate(435.6476 255.8419)"
                />
                <path
                  d="m0 0h-132.996c-.8 0-1.445-.726-1.445-1.614v-39.971c0-.906.645-1.623 1.445-1.623h132.996c.815 0 1.462.717 1.462 1.623v39.971c0 .888-.647 1.614-1.462 1.614"
                  transform="translate(435.6476 340.8907)"
                />
                <path
                  d="m0 0-63.839 63.838c-.431.432-1.129.432-1.559 0l-63.839-63.838c-.695-.695-.203-1.883.779-1.883h127.678c.983 0 1.474 1.188.78 1.883"
                  transform="translate(433.7766 401.3116)"
                />
                <path
                  d="m0 0 63.839 63.838c.431.431.431 1.129 0 1.559l-63.839 63.839c-.694.696-1.883.203-1.883-.779v-127.678c0-.982 1.189-1.474 1.883-.779"
                  transform="translate(493.7062 212.1446)"
                />
                <path
                  d="m0 0 63.839-63.839c.431-.431 1.129-.431 1.559 0l63.839 63.839c.695.694.203 1.883-.78 1.883h-127.678c-.982 0-1.473-1.189-.779-1.883"
                  transform="translate(304.5392 152.2139)"
                />
                <path
                  d="m0 0-63.838-63.839c-.432-.431-.432-1.129 0-1.559l63.838-63.838c.695-.696 1.883-.203 1.883.779v127.678c0 .982-1.188 1.474-1.883.779"
                  transform="translate(244.6086 341.381)"
                />
              </>
            )}
          </g>
        </g>
      </g>
    </svg>
  )
}

export const Sdg11 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M292.5,166.4c14,0,20-8,20-19.2v-4c0-9-3.6-13.6-11.1-21.2l-8.8-8.7c-4-3.9-6.5-6.5-6.5-11.1v-1.7
        c0-4.6,2.6-6.8,6.5-6.8c4.3,0,6.5,2.3,6.5,7v7.1h12.5v-6.6c0-11.8-5.4-18.6-19.2-18.6c-13.4,0-19.3,7.8-19.3,18v2.8
        c0,9.4,3.6,14.1,11.5,21.8l8.1,8.1c4.2,4,6.1,6.9,6.1,11.6v3.1c0,4.4-1.9,7.2-6.3,7.2c-4.7,0-6.8-2.6-6.8-7.2v-11.2h-12.8v11
        C273.2,158.6,278.6,166.5,292.5,166.4"
        />
        <path
          d="M358.5,145.5V83.7h-12.7v63.2c0,4.8-1.9,8.1-6.8,8.1s-6.7-3.2-6.7-8.1V83.7h-13.8v61.9c0,12.7,6,20.9,20.5,20.9
        C353,166.4,358.5,158.2,358.5,145.5"
        />
        <path
          d="M404.9,147.2v-4c0-9-3.6-13.6-11.1-21.2l-8.8-8.7c-4-3.8-6.5-6.5-6.5-11.1v-1.7c0-4.6,2.7-6.8,6.5-6.8
        c4.3,0,6.5,2.3,6.5,7v7.1H404v-6.6c0-11.8-5.4-18.6-19.2-18.6c-13.4,0-19.3,7.8-19.3,18v2.8c0,9.4,3.6,14.1,11.5,21.8l8.1,8.1
        c4.2,4,6.1,6.9,6.1,11.6v3.1c0,4.3-1.9,7.2-6.3,7.2c-4.7,0-6.8-2.7-6.8-7.2v-11.3h-12.7v11c0,10.7,5.4,18.6,19.4,18.6
        S404.9,158.4,404.9,147.2"
        />
        <polygon points="444.7,83.7 408.2,83.7 408.2,94.9 419.5,94.9 419.5,165.4 433.4,165.4 433.4,94.9 444.7,94.9 " />
        <path
          d="M473.2,83.7h-15.7l-15.4,81.8h13l2.4-14.9h14.6l2.5,14.9h14.1L473.2,83.7z M459.4,139.5l5.4-32.8h0.1l5.4,32.8
        H459.4z"
        />
        <rect x="494.3" y="83.7" width="13.7" height="81.8" />
        <polygon
          points="555.7,165.4 555.7,83.7 544.2,83.7 544.2,130.6 529.4,83.7 515.9,83.7 515.9,165.4 527.5,165.4 
        527.5,114.1 543.6,165.4 "
        />
        <path
          d="M575.6,150.5h14.6l2.5,15h14.1l-15.5-81.8h-15.7l-15.4,81.8h13L575.6,150.5z M582.8,106.7h0.1l5.4,32.8h-11
        L582.8,106.7z"
        />
        <path
          d="M649.4,110v-8.3c0-11.6-4.6-18-18.3-18h-19.9v81.8h21.3c13.8,0,18.9-6.4,18.9-18v-10.8
        c0-7.5-3.4-12.1-10.2-13.6C646.9,121.2,649.4,116.8,649.4,110 M625,94.9h4.7c4.6,0,6.6,2.2,6.6,6.6v10c0,4.3-2.1,6.6-6.5,6.6H625
        V94.9z M637.8,147.6c0,4.3-2.2,6.6-6.7,6.6h-6v-25.6h5.9c4.8,0,6.9,2.3,6.9,6.6L637.8,147.6z"
        />
        <polygon points="670.9,83.7 657.1,83.7 657.1,165.4 687.2,165.4 687.2,154.2 670.9,154.2 " />
        <polygon
          points="725.1,94.9 725.1,83.7 692.3,83.7 692.3,165.4 725.1,165.4 725.1,154.2 706,154.2 706,129.4 
        719.7,129.4 719.7,118.3 706,118.3 706,94.9 "
        />
        <path
          d="M768.7,166.4c14.6,0,19.4-8.7,19.4-20.4v-14.1h-12.5V147c0,4.8-1.7,7.9-6.6,7.9s-7-3.5-7-8.4v-43.9
        c0-5,2-8.4,7-8.4s6.6,2.9,6.6,8v10.7h12.5v-9.7c0-12.1-4.2-20.5-19.4-20.5c-14.5,0-20.5,9.3-20.5,22.1v39.6
        C748.2,157,754.2,166.4,768.7,166.4"
        />
        <rect x="794.6" y="83.7" width="13.7" height="81.8" />
        <polygon points="838.8,165.4 838.8,94.9 850.1,94.9 850.1,83.7 813.5,83.7 813.5,94.9 824.9,94.9 824.9,165.4 " />
        <rect x="855.4" y="83.7" width="13.7" height="81.8" />
        <polygon
          points="876.2,165.4 909,165.4 909,154.2 890,154.2 890,129.4 903.6,129.4 903.6,118.3 890,118.3 890,94.9 
        909,94.9 909,83.7 876.2,83.7 "
        />
        <path
          d="M932.3,113.3c-4-3.9-6.5-6.5-6.5-11.1v-1.7c0-4.6,2.6-6.8,6.5-6.8c4.4,0,6.5,2.3,6.5,7v7.1h12.5v-6.6
        c0-11.8-5.4-18.6-19.2-18.6c-13.4,0-19.3,7.8-19.3,18v2.8c0,9.4,3.6,14.1,11.4,21.8l8.1,8.1c4.2,4,6.2,6.9,6.2,11.6v3.1
        c0,4.4-1.9,7.2-6.3,7.2c-4.7,0-6.8-2.6-6.8-7.2v-11.2h-12.8v11c0,10.7,5.4,18.6,19.4,18.6s20-8,20-19.2v-4c0-9-3.7-13.6-11.1-21.2
        L932.3,113.3z"
        />
        <path
          d="M288.8,203.7l-15.4,81.8h13l2.4-15h14.6l2.5,15H320l-15.5-81.8H288.8z M290.6,259.5l5.4-32.8h0.1l5.4,32.8
        H290.6z"
        />
        <polygon
          points="355.2,250.6 340.4,203.7 326.9,203.7 326.9,285.4 338.5,285.4 338.5,234.1 354.6,285.4 366.7,285.4 
        366.7,203.7 355.2,203.7 "
        />
        <path
          d="M396.9,203.7h-21.2v81.8h21.2c14.7,0,19.9-9.4,19.9-22v-37.9C416.8,213,411.6,203.6,396.9,203.7 M403.1,265.9
        c0,4.9-2.2,8.3-7.8,8.3h-5.8v-59.3h5.8c5.7,0,7.8,3.4,7.8,8.2V265.9z"
        />
        <path
          d="M460.2,202.7c-14.5,0-20.5,9.3-20.5,22.1v39.6c0,12.6,6,22.1,20.5,22.1s19.4-8.7,19.4-20.4v-14.1h-12.5V267
        c0,4.8-1.7,8-6.6,8s-7-3.5-7-8.4v-43.9c0-4.9,2.1-8.4,7-8.4s6.6,2.9,6.6,8v10.7h12.5v-9.6C479.6,211.2,475.4,202.8,460.2,202.7"
        />
        <path
          d="M509.1,202.7c-14.5,0-20.7,9.3-20.7,22.1v39.6c0,12.6,6.3,22.1,20.7,22.1s20.8-9.4,20.8-22.1v-39.6
        C529.9,212,523.7,202.7,509.1,202.7 M516.2,266.5c0,5-2.2,8.4-7.1,8.4s-7-3.5-7-8.4v-43.9c0-4.9,2.1-8.4,7-8.4s7.1,3.5,7.1,8.4
        V266.5z"
        />
        <polygon
          points="564,249.7 563.9,249.7 555,203.7 539,203.7 539,285.4 550.3,285.4 550.3,232.4 550.5,232.4 
        560.8,285.4 567.2,285.4 576.5,232.4 576.8,232.4 576.8,285.4 589.3,285.4 589.3,203.7 572,203.7 "
        />
        <polygon
          points="623.5,249.7 623.4,249.7 614.4,203.7 598.4,203.7 598.4,285.4 609.7,285.4 609.7,232.4 610,232.4 
        620.2,285.4 626.6,285.4 635.9,232.4 636.2,232.4 636.2,285.4 648.8,285.4 648.8,203.7 631.4,203.7 "
        />
        <path
          d="M685.1,266.9c0,4.8-1.9,8.1-6.7,8.1s-6.8-3.3-6.8-8.1v-63.2h-13.8v61.8c0,12.7,6,20.9,20.5,20.9
        c14,0,19.4-8.2,19.4-20.9v-61.8h-12.7V266.9z"
        />
        <polygon
          points="735.1,250.6 720.3,203.7 706.8,203.7 706.8,285.4 718.4,285.4 718.4,234.1 734.5,285.4 746.6,285.4 
        746.6,203.7 735.1,203.7 "
        />
        <polygon points="71.7,120.4 71.7,155.8 71.9,155.8 95.7,131.1 96,131.1 96,285.4 129.9,285.4 129.9,83.8 102.9,83.8 " />
        <polygon
          points="149,120.4 149,155.8 149.3,155.8 173.1,131.1 173.4,131.1 173.4,285.4 207.3,285.4 207.3,83.8 
        180.2,83.8 "
        />
        <rect x="755.6" y="203.7" width="13.7" height="81.8" />
        <polygon points="776.9,214.9 788.2,214.9 788.2,285.4 802,285.4 802,214.9 813.4,214.9 813.4,203.7 776.9,203.7 " />
        <rect x="821" y="203.7" width="13.8" height="81.8" />
        <polygon
          points="843.9,285.4 876.7,285.4 876.7,274.2 857.6,274.2 857.6,249.4 871.3,249.4 871.3,238.3 857.6,238.3 
        857.6,214.9 876.7,214.9 876.7,203.7 843.9,203.7 "
        />
        <path
          d="M903.3,233.3c-4-3.9-6.5-6.5-6.5-11.1v-1.7c0-4.6,2.7-6.8,6.5-6.8c4.3,0,6.5,2.3,6.5,7v7.1h12.5v-6.6
        c0-11.8-5.4-18.6-19.2-18.6c-13.4,0-19.3,7.8-19.3,18v2.8c0,9.4,3.6,14.1,11.5,21.8l8.1,8.1c4.2,4,6.1,6.9,6.1,11.6v3.1
        c0,4.3-1.9,7.2-6.3,7.2c-4.7,0-6.8-2.6-6.8-7.2v-11.3h-12.8v11c0,10.7,5.4,18.6,19.4,18.6s20-8,20-19.2v-4c0-9-3.6-13.6-11.1-21.2
        L903.3,233.3z"
        />
        {!quantitative && (
          <g>
            <g>
              <path
                d="M165,761.3h150.4c2,0,3.7-1.6,3.7-3.6c0-0.9-0.3-1.8-1-2.5l-0.2-0.2l-74.8-96.8l-0.7-0.8
            c-0.7-0.8-1.7-1.2-2.7-1.2c-0.9,0-1.8,0.4-2.4,1l-0.4,0.5l-0.7,0.8l-73,95.8l-1.1,1.4c-0.4,0.6-0.6,1.3-0.6,2.1
            C161.3,759.6,162.9,761.3,165,761.3C165,761.3,165,761.3,165,761.3z"
              />
              <path
                d="M314.9,775H164.2c-2,0-3.7,1.7-3.7,3.7l0,0v117.9c0,2,1.6,3.7,3.7,3.7c0,0,0,0,0,0h48.5v-74.2
            c0-2,1.6-3.7,3.7-3.7c0,0,0,0,0,0h45c2,0,3.7,1.6,3.7,3.7c0,0,0,0,0,0v74.2h49.8c2,0,3.7-1.7,3.7-3.7v0V778.7
            C318.6,776.6,316.9,775,314.9,775z"
              />
            </g>
            <path
              d="M835.8,744.1H686.7c-2,0-3.6,1.5-3.6,3.5c0,0,0,0,0,0v150.6c0,2,1.7,3.6,3.7,3.5h149.2c2,0,3.6-1.6,3.7-3.5
          c0,0,0,0,0,0V747.6C839.5,745.6,837.8,744.1,835.8,744.1C835.9,744.1,835.8,744.1,835.8,744.1 M754.2,842.4c0,2-1.7,3.6-3.6,3.6
          c0,0,0,0,0,0H706c-2,0-3.6-1.6-3.7-3.6c0,0,0,0,0,0v-27.1c0-2,1.7-3.6,3.6-3.6c0,0,0,0,0,0h44.6c2,0,3.6,1.6,3.6,3.5c0,0,0,0,0,0
          V842.4z M754.2,792.4c0,2-1.7,3.6-3.6,3.6c0,0,0,0,0,0H706c-2,0-3.6-1.6-3.7-3.6c0,0,0,0,0,0v-27.1c0-2,1.7-3.6,3.7-3.5h44.6
          c2,0,3.6,1.6,3.6,3.5c0,0,0,0,0,0V792.4z M822.3,842.4c0,2-1.7,3.6-3.6,3.6c0,0,0,0,0,0h-44.6c-2,0-3.6-1.6-3.7-3.5c0,0,0,0,0,0
          v-27.1c0-2,1.7-3.6,3.6-3.6c0,0,0,0,0,0h44.5c2,0,3.6,1.6,3.7,3.5c0,0,0,0,0,0L822.3,842.4z M822.3,792.4c0,2-1.7,3.6-3.6,3.6
          c0,0,0,0,0,0h-44.6c-2,0-3.6-1.6-3.7-3.5c0,0,0,0,0,0v-27.1c0-2,1.7-3.6,3.7-3.5c0,0,0,0,0,0h44.5c2,0,3.6,1.6,3.7,3.5c0,0,0,0,0,0
          L822.3,792.4z"
            />
            <path
              d="M489.1,394.4h-146c-2,0-3.6,1.6-3.6,3.6l0,0v498.9c0,2,1.6,3.6,3.6,3.6h146c2,0,3.6-1.6,3.6-3.6V398
          C492.6,396,491,394.4,489.1,394.4 M402.2,843.7c0,1.1-0.9,1.9-1.9,1.9h-33.4c-1.1,0-1.9-0.9-1.9-1.9v-37.2c0-1.1,0.9-1.9,1.9-1.9
          c0,0,0,0,0,0h33.4c1.1,0,1.9,0.8,1.9,1.9c0,0,0,0,0,0V843.7z M402.2,758.1c0,1.1-0.9,1.9-1.9,1.9h0h-33.4c-1,0-1.9-0.9-1.9-1.9
          v-37.2c0-1.1,0.8-1.9,1.9-1.9c0,0,0,0,0,0h33.4c1.1,0,1.9,0.8,1.9,1.9c0,0,0,0,0,0V758.1z M402.2,672.6c0,1.1-0.9,1.9-1.9,1.9
          h-33.4c-1.1,0-1.9-0.9-1.9-1.9v-37.3c0-1.1,0.9-1.9,1.9-1.9h33.4c1.1,0,1.9,0.9,1.9,1.9V672.6z M402.2,587c0,1.1-0.9,1.9-1.9,1.9
          h-33.4c-1.1,0-1.9-0.9-1.9-1.9v-37.2c0-1,0.9-1.9,1.9-1.9c0,0,0,0,0,0h33.4c1,0,1.9,0.8,1.9,1.9c0,0,0,0,0,0V587z M402.2,501.5
          c0,1.1-0.9,1.9-1.9,1.9h-33.4c-1.1,0-1.9-0.9-1.9-1.9v-37.3c0-1.1,0.9-1.9,1.9-1.9h0h33.4c1.1,0,1.9,0.9,1.9,1.9v0V501.5z
           M467.8,843.7c0,1.1-0.9,1.9-1.9,1.9c0,0,0,0,0,0h-33.4c-1.1,0-1.9-0.8-1.9-1.9c0,0,0,0,0,0v-37.2c0-1.1,0.9-1.9,1.9-1.9
          c0,0,0,0,0,0h33.4c1.1,0,1.9,0.8,1.9,1.9c0,0,0,0,0,0L467.8,843.7z M467.8,758.1c0,1.1-0.8,1.9-1.9,1.9c0,0,0,0,0,0h-33.4
          c-1,0-1.9-0.8-1.9-1.9c0,0,0,0,0,0v-37.2c0-1,0.8-1.9,1.9-1.9c0,0,0,0,0,0h33.4c1.1,0,1.9,0.8,1.9,1.9c0,0,0,0,0,0L467.8,758.1z
           M467.8,672.6c0,1.1-0.9,1.9-1.9,1.9c0,0,0,0,0,0h-33.4c-1.1,0-1.9-0.8-1.9-1.9c0,0,0,0,0,0v-37.3c0-1.1,0.9-1.9,1.9-1.9
          c0,0,0,0,0,0h33.4c1.1,0,1.9,0.8,1.9,1.9l0,0L467.8,672.6z M467.8,587c0,1.1-0.9,1.9-1.9,1.9c0,0,0,0,0,0h-33.4
          c-1.1,0-1.9-0.8-1.9-1.9c0,0,0,0,0,0v-37.3c0-1,0.9-1.9,1.9-1.9c0,0,0,0,0,0h33.4c1,0,1.9,0.8,1.9,1.9c0,0,0,0,0,0L467.8,587z
           M467.8,501.5c0,1.1-0.9,1.9-1.9,1.9c0,0,0,0,0,0h-33.4c-1.1,0-1.9-0.8-1.9-1.9c0,0,0,0,0,0v-37.3c0-1.1,0.8-1.9,1.9-1.9
          c0,0,0,0,0,0h33.4c1.1,0,1.9,0.8,1.9,1.9c0,0,0,0,0,0L467.8,501.5z"
            />
            <path d="M839.3,728.9c0,1.7-1.3,3-3,3H686.2c-1.7,0-3-1.3-3-3v-30c0-1.7,1.3-3,3-3h150.2c1.7,0,3,1.3,3,3V728.9z" />
            <path
              d="M665.4,488.6c-0.5-1.6-2-2.8-3.7-2.8c-0.7,0-1.5,0.3-2.1,0.7l-0.3,0.2l-1.2,1.6l-143.5,182l-0.7,0.9
          c-0.8,0.7-1.2,1.8-1.2,2.8v223.6c0,2,1.6,3.6,3.6,3.6c0,0,0,0,0,0h145.8c2,0,3.6-1.6,3.6-3.5c0,0,0,0,0,0V490.1
          C665.7,489.6,665.6,489.1,665.4,488.6z M605,587.5l1-1.3c9.8-12.6,26.4-33,34.4-42.9l1.1-1.3c0.8-1,2-1.5,3.2-1.5
          c2,0,3.6,1.4,4,3.3V590c0,2.2-1.8,4-4,4.1c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0h-35.8c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0
          c-2.2-0.1-4-1.9-4-4.1C604.2,589.1,604.5,588.2,605,587.5z M582.3,842.4c0,2-1.6,3.6-3.5,3.6c0,0,0,0,0,0h-43.5
          c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-27.2c0-2,1.6-3.6,3.6-3.6c0,0,0,0,0,0h43.5c2,0,3.6,1.6,3.6,3.5c0,0,0,0,0,0L582.3,842.4z
           M582.3,792.1c0,2-1.6,3.6-3.5,3.6c0,0,0,0,0,0h-43.5c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-27.2c0-2,1.6-3.6,3.5-3.6c0,0,0,0,0,0
          h43.5c2,0,3.6,1.6,3.6,3.5c0,0,0,0,0,0L582.3,792.1z M582.3,741.8c0,2-1.6,3.6-3.6,3.6c0,0,0,0,0,0h-43.5c-2,0-3.6-1.6-3.6-3.5
          c0,0,0,0,0,0v-27.2c0-2,1.6-3.6,3.5-3.6c0,0,0,0,0,0h43.5c2,0,3.6,1.6,3.6,3.5c0,0,0,0,0,0L582.3,741.8z M582.4,631.5v60
          c0,2-1.6,3.6-3.6,3.6h-43.5c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-7.5c0-0.5,0.1-0.9,0.3-1.3c0.1-0.1,0.1-0.3,0.2-0.4
          c0.1-0.2,0.2-0.3,0.3-0.5c0.1-0.2,0.3-0.4,0.4-0.6c5.6-8,30.7-38.9,41.2-51.8l1.1-1.3c0.8-1,2-1.5,3.2-1.5c2,0,3.6,1.4,4,3.3
          L582.4,631.5z M648.8,842.4c0,2-1.6,3.6-3.6,3.6l0,0h-43.5c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-27.2c0-2,1.6-3.6,3.6-3.6
          c0,0,0,0,0,0h43.5c2,0,3.6,1.6,3.6,3.6V842.4z M648.8,792.1c0,2-1.6,3.6-3.6,3.6l0,0h-43.5c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-27.2
          c0-2,1.6-3.6,3.5-3.6c0,0,0,0,0,0h43.5c2,0,3.6,1.6,3.6,3.6l0,0V792.1z M648.8,741.8c0,2-1.6,3.6-3.6,3.6h-43.5
          c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-27.2c0-2,1.6-3.6,3.6-3.6c0,0,0,0,0,0h43.5c2,0,3.6,1.6,3.6,3.6l0,0V741.8z M648.8,691.4
          c0,2-1.6,3.6-3.6,3.6h-43.5c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-27.2c0-2,1.6-3.6,3.6-3.6c0,0,0,0,0,0h43.5c2,0,3.6,1.6,3.6,3.6l0,0
          V691.4z M648.8,641.1c0,2-1.6,3.6-3.6,3.6l0,0h-43.5c-2,0-3.6-1.6-3.6-3.5c0,0,0,0,0,0v-27.2c0-2,1.6-3.6,3.6-3.6c0,0,0,0,0,0h43.5
          c2,0,3.6,1.6,3.6,3.6c0,0,0,0,0,0V641.1z"
            />
          </g>
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)" fill="currentColor">
          {!quantitative && (
            <>
              <path
                d="m0 0h.969 93.194c1.273 0 2.309 1.041 2.309 2.317 0 .593-.239 1.125-.607 1.535l-.129.137-46.848 60.615-.456.502c-.426.463-1.029.752-1.706.752-.581 0-1.102-.244-1.516-.593l-.281-.327-.44-.494-45.705-59.976-.702-.859c-.251-.364-.396-.813-.396-1.292 0-1.276 1.037-2.317 2.314-2.317"
                transform="translate(163.8705 166.2156)"
              />
              <path
                d="m0 0h-94.349c-1.277 0-2.31-1.034-2.31-2.31v-73.835c0-1.277 1.033-2.318 2.31-2.318h30.368v46.453c0 1.284 1.029 2.31 2.31 2.31h28.187c1.277 0 2.311-1.026 2.311-2.31v-46.453h31.173c1.273 0 2.31 1.041 2.31 2.318v73.835c0 1.276-1.037 2.31-2.31 2.31"
                transform="translate(257.7484 157.6686)"
              />
              <path
                d="m0 0c0-1.23-1.018-2.226-2.287-2.226h-27.892c-1.269 0-2.286.996-2.286 2.226v16.966c0 1.223 1.017 2.218 2.286 2.218h27.892c1.269 0 2.287-.995 2.287-2.218zm0-31.333c0-1.238-1.018-2.234-2.287-2.234h-27.892c-1.269 0-2.286.996-2.286 2.234v16.951c0 1.238 1.017 2.226 2.286 2.226h27.892c1.269 0 2.287-.988 2.287-2.226zm-42.639 31.333c0-1.23-1.018-2.226-2.279-2.226h-27.899c-1.269 0-2.295.996-2.295 2.226v16.966c0 1.223 1.026 2.218 2.295 2.218h27.899c1.261 0 2.279-.995 2.279-2.218zm0-31.333c0-1.238-1.018-2.234-2.279-2.234h-27.899c-1.269 0-2.295.996-2.295 2.234v16.951c0 1.238 1.026 2.226 2.295 2.226h27.899c1.261 0 2.279-.988 2.279-2.226zm51.095 61.557h-93.384c-1.261 0-2.279-.98-2.279-2.218v-94.296c0-1.224 1.018-2.219 2.279-2.219h93.384c1.269 0 2.287.995 2.287 2.219v94.296c0 1.238-1.018 2.218-2.287 2.218"
                transform="translate(575.3771 146.7729)"
              />
              <path
                d="m0 0c0-.653-.539-1.193-1.208-1.193h-20.916c-.669 0-1.201.54-1.201 1.193v23.325c0 .668.532 1.201 1.201 1.201h20.916c.669 0 1.208-.533 1.208-1.201zm0-53.541c0-.662-.539-1.201-1.208-1.201h-20.916c-.669 0-1.201.539-1.201 1.201v23.324c0 .662.532 1.186 1.201 1.186h20.916c.669 0 1.208-.524 1.208-1.186zm0-53.558c0-.66-.539-1.2-1.208-1.2h-20.916c-.669 0-1.201.54-1.201 1.2v23.326c0 .661.532 1.2 1.201 1.2h20.916c.669 0 1.208-.539 1.208-1.2zm0-53.541c0-.676-.539-1.2-1.208-1.2h-20.916c-.669 0-1.201.524-1.201 1.2v23.31c0 .677.532 1.201 1.201 1.201h20.916c.669 0 1.208-.524 1.208-1.201zm0-53.556c0-.662-.539-1.2-1.208-1.2h-20.916c-.669 0-1.201.538-1.201 1.2v23.317c0 .661.532 1.193 1.201 1.193h20.916c.669 0 1.208-.532 1.208-1.193zm-41.035 214.196c0-.653-.54-1.193-1.201-1.193h-20.924c-.661 0-1.2.54-1.2 1.193v23.325c0 .668.539 1.201 1.2 1.201h20.924c.661 0 1.201-.533 1.201-1.201zm0-53.541c0-.662-.54-1.201-1.201-1.201h-20.924c-.661 0-1.2.539-1.2 1.201v23.324c0 .662.539 1.186 1.2 1.186h20.924c.661 0 1.201-.524 1.201-1.186zm0-53.558c0-.66-.54-1.2-1.201-1.2h-20.924c-.661 0-1.2.54-1.2 1.2v23.326c0 .661.539 1.2 1.2 1.2h20.924c.661 0 1.201-.539 1.201-1.2zm0-53.541c0-.676-.54-1.2-1.201-1.2h-20.924c-.661 0-1.2.524-1.2 1.2v23.31c0 .677.539 1.201 1.2 1.201h20.924c.661 0 1.201-.524 1.201-1.201zm0-53.556c0-.662-.54-1.2-1.201-1.2h-20.924c-.661 0-1.2.538-1.2 1.2v23.317c0 .661.539 1.193 1.2 1.193h20.924c.661 0 1.201-.532 1.201-1.193zm54.362 281.212h-91.386c-1.224 0-2.234-.995-2.234-2.242v-312.317c0-1.231 1.01-2.234 2.234-2.234h91.386c1.223 0 2.248 1.003 2.248 2.234v312.317c0 1.247-1.025 2.242-2.248 2.242"
                transform="translate(353.4306 328.8612)"
              />
              <path
                d="m0 0c0-1.049-.836-1.884-1.876-1.884h-93.992c-1.034 0-1.877.835-1.877 1.884v18.797c0 1.033.843 1.876 1.877 1.876h93.992c1.04 0 1.876-.843 1.876-1.876z"
                transform="translate(586.0138 186.4866)"
              />
              <path
                d="m0 0c0-1.238-1.011-2.234-2.234-2.234h-27.231c-1.245 0-2.248.996-2.248 2.234v17.049c0 1.246 1.003 2.241 2.248 2.241h27.231c1.223 0 2.234-.995 2.234-2.241zm0-31.508c0-1.231-1.011-2.226-2.234-2.226h-27.231c-1.245 0-2.248.995-2.248 2.226v17.049c0 1.239 1.003 2.234 2.248 2.234h27.231c1.223 0 2.234-.995 2.234-2.234zm0-31.508c0-1.223-1.011-2.226-2.234-2.226h-27.231c-1.245 0-2.248 1.003-2.248 2.226v17.057c0 1.238 1.003 2.234 2.248 2.234h27.231c1.223 0 2.234-.996 2.234-2.234zm0-31.5c0-1.239-1.011-2.234-2.234-2.234h-27.231c-1.245 0-2.248.995-2.248 2.234v17.049c0 1.246 1.003 2.234 2.248 2.234h27.231c1.223 0 2.234-.988 2.234-2.234zm0-31.501c0-1.238-1.011-2.233-2.234-2.233h-27.231c-1.245 0-2.248.995-2.248 2.233v17.05c0 1.23 1.003 2.226 2.248 2.226h27.231c1.223 0 2.234-.996 2.234-2.226zm-41.56 132.034v-.82-36.735c0-1.239-1.011-2.234-2.234-2.234h-27.23c-1.246 0-2.25.995-2.25 2.234v4.535.19c.012.297.069.578.172.836.045.091.053.129.136.259.053.106.13.204.198.296.068.106.171.243.255.365 3.48 4.983 19.192 24.335 25.79 32.427l.661.797c.479.578 1.201.95 2.01.95 1.25 0 2.249-.911 2.492-2.089zm-.076-69.033c0-1.223-.996-2.226-2.234-2.226h-27.238c-1.238 0-2.233 1.003-2.233 2.226v17.057c0 1.238.995 2.234 2.233 2.234h27.238c1.238 0 2.234-.996 2.234-2.234zm0-31.5c0-1.239-.996-2.234-2.234-2.234h-27.238c-1.238 0-2.233.995-2.233 2.234v17.049c0 1.246.995 2.234 2.233 2.234h27.238c1.238 0 2.234-.988 2.234-2.234zm0-31.501c0-1.238-.996-2.233-2.234-2.233h-27.238c-1.238 0-2.233.995-2.233 2.233v17.05c0 1.23.995 2.226 2.233 2.226h27.238c1.238 0 2.234-.996 2.234-2.226zm14.211 159.568.642.806c6.147 7.886 16.503 20.635 21.552 26.828l.661.79c.478.577 1.2.95 2.009.95 1.251 0 2.249-.904 2.492-2.09v-1.01-.821-26.995c0-1.39-1.105-2.507-2.48-2.568-.042 0-.076-.023-.114-.023s-.072.023-.114.023h-21.331-1.113c-.042 0-.076-.023-.114-.023s-.072.023-.114.023c-1.375.061-2.481 1.178-2.481 2.568 0 .578.186 1.11.505 1.542m37.815 61.877c-.304 1.003-1.194 1.747-2.295 1.747-.493 0-.923-.182-1.306-.433-.057-.038-.115-.068-.171-.114l-.772-.972-89.817-113.937-.414-.554c-.463-.456-.76-1.079-.779-1.778v-.152-139.86c0-1.23 1.003-2.226 2.242-2.226h91.294c1.239 0 2.234.996 2.234 2.226v255.118c0 .334-.087.654-.216.935"
                transform="translate(466.7519 241.4717)"
              />
            </>
          )}
          <path
            d="m0 0v-25.569h.211l17.191 17.841h.219v-111.543h24.498v145.716h-19.56z"
            transform="translate(58.9369 642.9802)"
          />
          <path
            d="m0 0v-25.569h.219l17.192 17.841h.21v-111.543h24.507v145.716h-19.551z"
            transform="translate(114.8094 642.9802)"
          />
          <path
            d="m0 0-11.665-61.317h-11.213l-11.665 61.317h10.489l7.053-42.776h.089l7.238 42.776z"
            transform="translate(252.8346 668.8229)"
          />
          <path d="m257.096 668.823h10.31v-61.317h-10.31z" />
          <path
            d="m0 0h10.31v-52.908h12.301v-8.409h-22.611z"
            transform="translate(273.3848 668.8229)"
          />
          <path
            d="m0 0h10.31v-52.908h12.301v-8.409h-22.611z"
            transform="translate(300.702 668.8229)"
          />
          <path
            d="m0 0h24.602v-8.411h-14.292v-17.546h10.221v-8.319h-10.221v-18.632h14.292v-8.409h-24.602z"
            transform="translate(328.0257 668.8229)"
          />
          <path
            d="m0 0v8.23h9.585v-8.415c0-3.434 1.539-5.425 5.069-5.425 3.25 0 4.7 2.169 4.7 5.425v2.354c0 3.527-1.45 5.699-4.611 8.682l-6.061 6.06c-5.877 5.789-8.593 9.315-8.593 16.369v2.08c0 7.597 4.433 13.474 14.469 13.474 10.31 0 14.381-5.063 14.381-13.926v-4.973h-9.407v5.333c0 3.53-1.628 5.247-4.878 5.247-2.894 0-4.885-1.628-4.885-5.066v-1.266c0-3.434 1.896-5.425 4.885-8.319l6.602-6.51c5.603-5.699 8.319-9.136 8.319-15.92v-2.983c0-8.414-4.522-14.38-15.017-14.38-10.487 0-14.558 5.876-14.558 13.929"
            transform="translate(357.1626 620.7106)"
          />
          <path
            d="m0 0h24.601v-8.411h-14.291v-17.546h10.221v-8.319h-10.221v-18.632h14.291v-8.409h-24.601z"
            transform="translate(407.6719 668.8229)"
          />
          <path
            d="m0 0h27.401v-8.411h-8.504v-52.906h-10.4v52.906h-8.497z"
            transform="translate(436.6297 668.8229)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.379 16.55 11.391 0 14.558-6.329 14.558-15.373v-7.238h-9.406v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.247-2.621-5.247-6.328v-32.921c0-3.709 1.539-6.329 5.247-6.329s4.974 2.347 4.974 5.966v11.308h9.406v-10.583c0-8.77-3.618-15.283-14.558-15.283-10.857 0-15.379 7.053-15.379 16.549"
            transform="translate(219.8251 541.9002)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.328-5.336 6.328-3.619 0-5.247-2.62-5.247-6.328v-32.921c0-3.708 1.628-6.329 5.247-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.894 1.628v29.665c0 9.584 4.707 16.549 15.558 16.549 10.946 0 15.647-6.965 15.647-16.549v-29.665c0-9.496-4.701-16.549-15.647-16.549-10.851 0-15.558 7.053-15.558 16.549"
            transform="translate(276.272 540.272)"
          />
          <path
            d="m0 0h-.267l-6.965-39.79h-4.795l-7.69 39.79h-.178v-39.79h-8.504v61.313h12.034l6.691-34.543h.089l5.966 34.543h13.026v-61.313h-9.407z"
            transform="translate(320.8771 565.8658)"
          />
          <path
            d="m0 0h-.267l-6.965-39.79h-4.795l-7.69 39.79h-.178v-39.79h-8.504v61.313h12.034l6.691-34.543h.089l5.966 34.543h13.026v-61.313h-9.407z"
            transform="translate(364.5723 565.8658)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.559-15.646-10.857 0-15.379 6.15-15.379 15.646v46.392h10.31v-47.391c0-3.612 1.45-6.055 5.069-6.055 3.613 0 5.062 2.443 5.062 6.055v47.391z"
            transform="translate(409.8131 587.3891)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.313h10.132l11.124-35.178v35.178h8.593v-61.313h-9.044z"
            transform="translate(424.3845 564.5997)"
          />
          <path
            d="m0 0h8.23l-4.07 24.595h-.089zm-12.93-19.443 11.575 61.313h11.754l11.665-61.313h-10.577l-1.902 11.213h-10.94l-1.812-11.213z"
            transform="translate(462.743 545.5188)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.558-15.646-10.857 0-15.379 6.15-15.379 15.646v46.392h10.31v-47.391c0-3.612 1.449-6.055 5.069-6.055 3.612 0 5.062 2.443 5.062 6.055v47.391z"
            transform="translate(517.6574 587.3891)"
          />
          <path
            d="m0 0h27.4v-8.409h-8.504v-52.904h-10.399v52.904h-8.497z"
            transform="translate(522.3773 587.3891)"
          />
          <path
            d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.434-4.344h24.601v-8.408h-14.291v-17.548h10.221v-8.319h-10.221v-18.63h14.291v-8.408h-24.601z"
            transform="translate(576.0133 591.7326)"
          />
          <path
            d="m0 0v8.23h9.585v-8.414c0-3.435 1.539-5.426 5.069-5.426 3.25 0 4.7 2.169 4.7 5.426v2.353c0 3.524-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.312-8.593 16.365v2.08c0 7.6 4.433 13.478 14.47 13.478 10.31 0 14.381-5.064 14.381-13.93v-4.974h-9.408v5.337c0 3.53-1.628 5.247-4.878 5.247-2.894 0-4.885-1.628-4.885-5.069v-1.266c0-3.434 1.896-5.425 4.885-8.319l6.602-6.507c5.603-5.698 8.319-9.139 8.319-15.919v-2.983c0-8.415-4.522-14.381-15.016-14.381-10.488 0-14.559 5.877-14.559 13.929"
            transform="translate(583.722 539.2794)"
          />
          <path
            d="m0 0c4.248 0 5.877 2.531 5.877 6.239v32.101c0 3.618-1.629 6.15-5.877 6.15h-4.344v-44.49zm16.187 36.444v-28.399c0-9.406-3.887-16.46-14.921-16.46h-15.92v61.32h15.92c11.034 0 14.921-6.965 14.921-16.461"
            transform="translate(234.4792 453.06)"
          />
          <path
            d="m0 0v-46.398c0-9.496-4.071-15.64-14.559-15.64-10.857 0-15.379 6.144-15.379 15.64v46.398h10.31v-47.391c0-3.618 1.45-6.061 5.069-6.061 3.613 0 5.063 2.443 5.063 6.061v47.391z"
            transform="translate(286.4934 505.9645)"
          />
          <path
            d="m0 0v-19.081h3.441c3.523 0 5.062 1.807 5.062 5.063v9.044c0 3.346-1.539 4.974-5.062 4.974zm0-24.78v-28.125h-10.31v61.32h15.016c10.399 0 14.196-5.159 14.196-13.751v-7.868c0-6.602-2.353-10.488-8.23-11.843l9.859-27.858h-10.851z"
            transform="translate(302.6995 497.5498)"
          />
          <path
            d="m0 0h8.23l-4.07 24.602h-.089zm-12.93-19.443 11.575 61.319h11.754l11.665-61.319h-10.577l-1.902 11.213h-10.94l-1.812-11.213z"
            transform="translate(338.5266 464.0883)"
          />
          <path
            d="m0 0v-19.169h4.522c3.441 0 5.069 1.716 5.069 4.973v9.222c0 3.257-1.539 4.974-5.158 4.974zm0 7.868h3.619c3.346 0 4.885 1.717 4.885 4.974v7.504c0 3.346-1.539 4.974-4.974 4.974h-3.53zm-10.31 25.867h14.928c10.303 0 13.744-4.795 13.744-13.477v-6.24c0-5.158-1.901-8.408-6.15-9.769 5.151-1.177 7.689-4.612 7.689-10.215v-8.141c0-8.682-3.892-13.477-14.202-13.477h-16.009z"
            transform="translate(375.1683 472.2295)"
          />
          <path
            d="m0 0h10.311v-52.905h12.3v-8.414h-22.611z"
            transform="translate(400.2339 505.9645)"
          />
          <path
            d="m0 0h24.601v-8.415h-14.291v-17.542h10.221v-8.319h-10.221v-18.629h14.291v-8.414h-24.601z"
            transform="translate(427.5518 505.9645)"
          />
          <path
            d="m0 0v8.23h9.585v-8.408c0-3.441 1.539-5.425 5.069-5.425 3.25 0 4.7 2.169 4.7 5.425v2.347c0 3.53-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.317-8.593 16.372v2.079c0 7.594 4.433 13.472 14.469 13.472 10.311 0 14.382-5.064 14.382-13.923v-4.974h-9.408v5.336c0 3.523-1.628 5.241-4.878 5.241-2.894 0-4.885-1.628-4.885-5.063v-1.266c0-3.434 1.896-5.425 4.885-8.319l6.602-6.513c5.603-5.698 8.319-9.133 8.319-15.913v-2.99c0-8.408-4.522-14.374-15.017-14.374-10.487 0-14.558 5.878-14.558 13.923"
            transform="translate(456.6945 457.8489)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg12 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          id="_Path_2"
          points="99.8,131.4 100.1,131.4 100.1,285.7 134,285.7 134,84.1 106.9,84.1 75.7,120.7 
      75.7,156.1 76,156.1 "
        />
        <path
          id="_Path_3"
          d="M154.2,125.7v24.4h30.9v-25.3c0-12.2,6-15.8,13.1-15.8c6.6,0,12.2,2.7,12.2,15.2v16.6
      c0,16.7-1.5,23.2-12.5,34.8l-19,20.2c-18.4,19.6-25.3,32.7-25.3,52.6v37.2h88v-27.7h-55.6v-9.5c0-15.8,5.6-21.7,14.3-30.9l21.7-22.9
      c17.6-18.7,21.4-30.6,21.4-50.9v-19.6c0-28.9-14-42.5-44.3-42.5C169.4,81.7,154.2,97.5,154.2,125.7"
        />
        {!quantitative && (
          <path
            id="_Path_4"
            d="M778.5,535.7c-40.8-32.2-89.7-35.7-108.8-35.7c-10.1,0-19.4,0.9-26.3,2.5l-2.7,0.6
      c-25.8,6.1-69.1,16.3-119.4,78.8l-1.5,1.8c-0.8,1.1-1.2,2.4-1.3,3.8c0,1.2,0.3,2.3,0.9,3.3l1.1,1.9c8.3,13.9,15.2,26,20.7,36.2
      c1.7,3.3,5.7,4.6,9,2.9c0.7-0.3,1.3-0.8,1.8-1.4c0.3-0.5,0.7-1,1-1.3c43.4-60.1,77.5-68.1,100-73.4l2.8-0.7
      c4.5-0.9,9.2-1.3,13.8-1.2c10.5,0,46.9,1.7,75.3,24.2c25.3,20,38.1,51.8,38.1,94.8c0,71.9-34.8,100-64,110.8
      c-11.4,4.2-23.5,6.3-35.7,6.3c-18.5-0.1-36.8-4.3-53.6-12.2l-2.1-1c-25.1-10.9-62.6-33.6-98-104.8
      c-72.7-146-133.7-159.8-174.1-168.9l-2.1-0.5c-3.1-0.7-11.8-2.3-26-2.3c-23.4,0-68.4,4.6-107,35.4c-26.3,21-57.8,61.8-57.8,137
      c0,45.8,9.4,76,33.6,107.8c4.5,6.2,46.6,60.6,127.5,60.6c12.4,0,24.8-1.3,36.9-3.6c14.8-2.8,37.5-10.1,63-28.8l21.2,19.2
      c2.5,2.1,6.3,2,8.6-0.4c1-1.1,1.6-2.5,1.5-4L471.7,722v-1.2c0-1.7-0.7-3.3-2-4.4c-1.2-1.1-2.7-1.6-4.3-1.6l0,0L366.8,742l-1.9,0.3
      c-1.2,0.3-2.3,0.9-3.1,1.8c-2.3,2.5-2.1,6.3,0.4,8.6c0,0,0,0,0.1,0.1l20.4,18.5c-10.7,6.6-21.5,11-31.9,13
      c-8.6,1.7-17.4,2.5-26.2,2.6c-55.9,0-83.4-36.7-84.5-38.2l-0.6-0.8c-17-22.3-22.7-41.3-22.7-75.3c0-43.1,12.6-75,37.4-94.8
      c27.7-22.1,63.2-23.8,73.5-23.8c4.7-0.1,9.4,0.3,14,1.2l2.2,0.5c32.3,7.3,76.4,17.3,137.7,140.3c32.3,65,72.9,107.4,123.9,129.8
      c5.9,3,37.6,18.1,78.1,18.1c18.6,0.1,37.1-3.2,54.5-9.7c29.8-11.1,99.1-49.1,99.1-161.4C837.2,597.7,805.3,556.8,778.5,535.7z"
          />
        )}
        <g id="_Group_">
          <path
            id="_Compound_Path_"
            d="M332.8,127.9v37.5h-13.7V83.6h20c13.9,0,18.9,6.9,18.9,18.3v10.5c0,8.8-3.1,14-11,15.8
        l13.1,37.1h-14.4L332.8,127.9z M332.8,94.9v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12c0-4.5-2-6.6-6.8-6.6L332.8,94.9z"
          />
          <path
            id="_Compound_Path_2"
            d="M365.4,83.6h32.8v11.2h-19v23.4h13.6v11.1h-13.7v24.8h19v11.2h-32.8V83.6z"
          />
          <path
            id="_Compound_Path_3"
            d="M404.7,147.8v-11h12.8V148c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2v-3.1
        c0-4.7-1.9-7.6-6.1-11.6l-8.1-8.1c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.8,0,19.2,6.8,19.2,18.6v6.6h-12.5
        v-7.1c0-4.7-2.2-7-6.5-7c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4
        c0,11.2-6,19.2-20,19.2S404.7,158.5,404.7,147.8z"
          />
          <path
            id="_Compound_Path_4"
            d="M451,83.6h20.4c13.9,0,18.9,6.9,18.9,18.3v17.2c0,11.4-5.1,18.4-18.9,18.4h-6.6v27.7
        H451V83.6z M464.7,94.9V127h5.1c4.7,0,6.8-2.3,6.8-6.8v-18.8c0-4.5-2-6.6-6.8-6.6H464.7z"
          />
          <path
            id="_Compound_Path_5"
            d="M497.3,144.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
        c0,12.7-6.3,22.1-20.9,22.1S497.3,157,497.3,144.3z M525.1,146.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
        c0,4.9,2.2,8.4,7,8.4S525.1,151.4,525.1,146.5L525.1,146.5z"
          />
          <path
            id="_Compound_Path_6"
            d="M558.2,114v51.4h-11.6V83.6h13.5l14.8,46.9V83.6h11.5v81.7h-12.1L558.2,114z"
          />
          <path
            id="_Compound_Path_7"
            d="M593.5,147.8v-11h12.8V148c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2v-3.1
        c0-4.7-1.9-7.6-6.2-11.6l-8.1-8.1c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.7,0,19.2,6.8,19.2,18.6v6.6h-12.5
        v-7.1c0-4.7-2.2-7-6.5-7c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4
        c0,11.2-6,19.2-20,19.2S593.5,158.5,593.5,147.8z"
          />
          <path id="_Compound_Path_8" d="M639.8,83.6h13.8v81.7h-13.8V83.6z" />
          <path
            id="_Compound_Path_9"
            d="M661.3,83.6h19.9c13.7,0,18.3,6.4,18.3,18v8.3c0,6.9-2.5,11.2-8.2,13
        c6.9,1.6,10.2,6.1,10.2,13.6v10.9c0,11.6-5.2,18-18.9,18h-21.3V83.6z M675.1,118.1h4.8c4.5,0,6.5-2.3,6.5-6.6v-10
        c0-4.5-2-6.6-6.6-6.6h-4.7V118.1z M675.1,128.6v25.6h6c4.6,0,6.8-2.3,6.8-6.6v-12.3c0-4.3-2-6.6-6.9-6.6L675.1,128.6z"
          />
          <path
            id="_Compound_Path_10"
            d="M708.4,83.6h13.7v70.5h16.4v11.2h-30.1V83.6z"
          />
          <path
            id="_Compound_Path_11"
            d="M744.7,83.6h32.8v11.2h-19v23.4H772v11.1h-13.6v24.8h19v11.2h-32.8V83.6z"
          />
        </g>
        <g id="_Group_2">
          <path
            id="_Compound_Path_12"
            d="M319.1,264.3v-39.5c0-12.8,6-22.1,20.5-22.1c15.2,0,19.4,8.4,19.4,20.5v9.6h-12.5
        v-10.7c0-5.1-1.7-8-6.6-8s-7,3.5-7,8.4v43.9c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-8v-15H359V266c0,11.7-4.8,20.4-19.4,20.4
        S319.1,277,319.1,264.3z"
          />
          <path
            id="_Compound_Path_13"
            d="M367.7,264.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
        c0,12.7-6.3,22.1-20.9,22.1S367.7,277,367.7,264.3z M395.5,266.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
        c0,4.9,2.2,8.4,7,8.4S395.5,271.4,395.5,266.5z"
          />
          <path
            id="_Compound_Path_14"
            d="M429.9,234v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7H446L429.9,234z"
          />
          <path
            id="_Compound_Path_15"
            d="M466.4,267.8v-11h12.8V268c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2v-3.1
        c0-4.7-1.9-7.6-6.1-11.6l-8.1-8c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.7,0,19.2,6.8,19.2,18.6v6.6h-12.6
        v-7.1c0-4.7-2.2-7-6.5-7c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4
        c0,11.2-6,19.2-20,19.2S466.4,278.5,466.4,267.8z"
          />
          <path
            id="_Compound_Path_16"
            d="M554.2,203.7v61.8c0,12.7-5.4,20.9-19.4,20.9c-14.5,0-20.5-8.2-20.5-20.9v-61.8H528
        v63.2c0,4.8,1.9,8.1,6.8,8.1s6.8-3.2,6.8-8.1v-63.2H554.2z"
          />
          <path
            id="_Compound_Path_17"
            d="M601.1,232.4h-0.4l-9.3,53.1H585l-10.2-53.1h-0.2v53.1h-11.3v-81.7h16l8.9,46.1h0.1
        l8-46.1h17.4v81.7h-12.5V232.4z"
          />
          <path
            id="_Compound_Path_18"
            d="M622.7,203.7H643c13.9,0,18.9,6.9,18.9,18.3v17.2c0,11.4-5.1,18.4-18.9,18.4h-6.6v27.7
        h-13.7V203.7z M636.4,214.9v32.2h5.1c4.7,0,6.8-2.3,6.8-6.8v-18.8c0-4.5-2-6.6-6.8-6.6L636.4,214.9z"
          />
          <path
            id="_Compound_Path_19"
            d="M666.4,203.7H703v11.2h-11.4v70.5h-13.9v-70.5h-11.3V203.7z"
          />
          <path
            id="_Compound_Path_20"
            d="M709.5,203.7h13.7v81.7h-13.7V203.7z"
          />
          <path
            id="_Compound_Path_21"
            d="M731.2,264.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
        c0,12.7-6.3,22.1-20.9,22.1S731.2,277,731.2,264.3z M759,266.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9c0,4.9,2.2,8.4,7,8.4
        S759,271.4,759,266.5z"
          />
          <path
            id="_Compound_Path_22"
            d="M792.3,234v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12L792.3,234z"
          />
        </g>
        <g id="_Group_3">
          <path
            id="_Compound_Path_23"
            d="M316.9,405.4l15.4-81.7H348l15.6,81.7h-14.1l-2.5-15h-14.6l-2.4,15H316.9z
         M334.2,379.5h11l-5.4-32.8h-0.1L334.2,379.5z"
          />
          <path
            id="_Compound_Path_24"
            d="M381.2,354.1v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12.1L381.2,354.1z"
          />
          <path
            id="_Compound_Path_25"
            d="M458.7,345.6v37.9c0,12.5-5.2,22-19.9,22h-21.2v-81.7h21.2
        C453.5,323.7,458.7,333,458.7,345.6z M437.1,394.2c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3L437.1,394.2z"
          />
          <path
            id="_Compound_Path_26"
            d="M479.9,323.7h20.4c13.9,0,18.9,6.9,18.9,18.3v17.2c0,11.5-5.1,18.5-18.9,18.5h-6.6
        v27.7h-13.7V323.7z M493.7,334.9v32.2h5.1c4.7,0,6.8-2.3,6.8-6.8v-18.8c0-4.5-2-6.6-6.8-6.6H493.7z"
          />
          <path
            id="_Compound_Path_27"
            d="M540.4,367.9v37.5h-13.8v-81.7h20c13.9,0,18.9,6.9,18.9,18.3v10.5
        c0,8.8-3.1,14-11,15.8l13.1,37.1h-14.4L540.4,367.9z M540.4,334.9v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12c0-4.5-2-6.6-6.8-6.6
        L540.4,334.9z"
          />
          <path
            id="_Compound_Path_28"
            d="M573.5,384.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
        c0,12.7-6.3,22.1-20.9,22.1S573.5,397,573.5,384.3z M601.3,386.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
        c0,4.9,2.2,8.4,7,8.4S601.3,391.4,601.3,386.5L601.3,386.5z"
          />
          <path
            id="_Compound_Path_29"
            d="M664.4,345.6v37.9c0,12.5-5.2,22-19.9,22h-21.2v-81.7h21.2
        C659.2,323.7,664.4,333,664.4,345.6z M642.8,394.2c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2H637v59.3L642.8,394.2z"
          />
          <path
            id="_Compound_Path_30"
            d="M712.5,323.7v61.8c0,12.7-5.4,20.9-19.4,20.9c-14.5,0-20.5-8.2-20.5-20.9v-61.8h13.8
        v63.2c0,4.8,1.9,8.1,6.8,8.1s6.8-3.3,6.8-8.1v-63.2H712.5z"
          />
          <path
            id="_Compound_Path_31"
            d="M720.7,384.3v-39.5c0-12.8,6-22.1,20.5-22.1c15.2,0,19.4,8.4,19.4,20.5v9.6H748v-10.7
        c0-5.1-1.7-8-6.6-8s-7,3.5-7,8.4v43.9c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-8v-15h12.5V386c0,11.7-4.8,20.4-19.4,20.4
        S720.7,397,720.7,384.3z"
          />
          <path
            id="_Compound_Path_32"
            d="M766.8,323.7h36.5v11.2H792v70.5h-13.8v-70.5h-11.3V323.7z"
          />
          <path
            id="_Compound_Path_33"
            d="M809.9,323.7h13.7v81.7h-13.7V323.7z"
          />
          <path
            id="_Compound_Path_34"
            d="M831.6,384.3v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.9,9.3,20.9,22.1v39.5
        c0,12.7-6.3,22.1-20.9,22.1S831.6,397,831.6,384.3z M859.4,386.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9
        c0,4.9,2.2,8.4,7,8.4S859.4,391.4,859.4,386.5L859.4,386.5z"
          />
          <path
            id="_Compound_Path_35"
            d="M892.7,354.1v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12.1L892.7,354.1z"
          />
        </g>
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <path
              d="m0 0c-31.919 25.208-74.204 25.726-89.685 22.042l-1.798-.416c-17.885-4.224-46.295-11.214-79.546-52.478-.184-.228-.377-.465-.553-.702l-.421-.509c-.324-.461-.552-1-.552-1.605 0-.5.123-.956.36-1.381l.771-1.272c4.175-6.982 9.438-15.968 13.885-24.248.044-.088.088-.154.123-.255.474-.916 1.421-1.561 2.535-1.561.771 0 1.464.308 1.965.798.21.272.42.558.605.847 29.515 40.816 52.723 46.452 68.423 50.144l1.878.444c8.148 1.955 39.127 1.838 61.494-15.82 17.455-13.778 26.314-35.707 26.314-65.165 0-49.416-24.033-68.748-44.207-76.261-31.243-11.678-61.205 3.935-61.425 4.053l-1.342.653c-17.165 7.452-42.777 22.955-66.915 71.437-48.653 97.715-89.351 106.916-116.278 113.017l-1.44.319c-12.261 2.781-54.845 4.746-88.317-21.972-17.489-13.95-38.321-41.075-38.321-91.048 0-30.45 6.254-50.553 22.332-71.704 3.526-4.82 39.558-51.11 109.218-37.76 11.148 2.135 26.253 7.459 42.865 19.91l15.332-13.832c1-.908 2.596-.833 3.517.175.438.47.623 1.07.614 1.662v.207l11.06 68.038.009.754c-.009.662-.28 1.338-.824 1.811-.465.443-1.044.614-1.623.614l-.473-.044-.719-.074-65.17-18.244-1.184-.193c-.474-.101-.913-.347-1.245-.728-.948-1.035-.86-2.614.183-3.535l.764-.706 14.603-13.188c-9.429-6.104-17.647-8.907-23.918-10.121-50.4-9.613-75.284 23.397-76.231 24.69l-.35.483c-11.71 15.375-15.666 28.44-15.666 51.785 0 29.546 8.701 51.482 25.866 65.191 21.797 17.394 51.856 17.494 60.346 15.56l1.465-.328c22.068-4.996 52.302-11.832 93.947-95.488 21.631-43.431 48.724-71.827 82.818-86.803 4.342-2.215 25.042-12.03 51.907-12.03 11.237 0 23.542 1.714 36.164 6.407 19.762 7.377 65.731 32.576 65.731 107.293 0 49.943-21.147 77.125-38.891 91.137"
              transform="translate(552.0363 355.0182)"
            />
          )}
          <path
            d="m0 0h.219v-111.543h24.498v145.711h-19.577l-22.55-26.436v-25.573h.209z"
            transform="translate(79.4503 635.0292)"
          />
          <path
            d="m0 0v-17.617h22.348v18.27c0 8.806 4.307 11.386 9.456 11.386 4.737 0 8.815-1.93 8.815-10.964v-12.026c0-12.042-1.07-16.766-9.034-25.147l-13.745-14.617c-13.323-14.187-18.279-23.642-18.279-38.044v-26.867h63.626v19.994h-40.198v6.873c0 11.393 4.088 15.691 10.315 22.353l15.691 16.547c12.684 13.538 15.482 22.142 15.482 36.755v14.179c0 20.853-10.095 30.733-32.024 30.733-21.498 0-32.453-11.389-32.453-31.808"
            transform="translate(118.7715 639.1031)"
          />
          <path
            d="m0 0v29.664c0 9.586 4.522 16.55 15.379 16.55 11.391 0 14.559-6.329 14.559-15.373v-7.235h-9.407v8.05c0 3.797-1.266 5.969-4.973 5.969-3.709 0-5.248-2.625-5.248-6.332v-32.921c0-3.708 1.539-6.329 5.248-6.329 3.707 0 4.973 2.347 4.973 5.966v11.309h9.407v-10.583c0-8.771-3.619-15.284-14.559-15.284-10.857 0-15.379 7.053-15.379 16.549"
            transform="translate(244.3831 622.3307)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.332-5.336 6.332-3.619 0-5.247-2.624-5.247-6.332v-32.921c0-3.708 1.628-6.329 5.247-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.893 1.628v29.665c0 9.585 4.706 16.549 15.557 16.549 10.946 0 15.646-6.964 15.646-16.549v-29.665c0-9.496-4.7-16.549-15.646-16.549-10.851 0-15.557 7.053-15.557 16.549"
            transform="translate(300.8306 620.7025)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.317h10.132l11.124-35.182v35.182h8.593v-61.317h-9.045z"
            transform="translate(325.7185 645.0309)"
          />
          <path
            d="m0 0v8.23h9.585v-8.415c0-3.434 1.539-5.425 5.069-5.425 3.25 0 4.7 2.169 4.7 5.425v2.354c0 3.527-1.45 5.699-4.611 8.682l-6.061 6.06c-5.877 5.789-8.593 9.315-8.593 16.369v2.08c0 7.597 4.433 13.474 14.469 13.474 10.311 0 14.382-5.063 14.382-13.926v-4.973h-9.408v5.333c0 3.53-1.628 5.247-4.878 5.247-2.894 0-4.885-1.628-4.885-5.066v-1.266c0-3.434 1.896-5.425 4.885-8.319l6.602-6.51c5.603-5.699 8.319-9.136 8.319-15.92v-2.983c0-8.414-4.522-14.38-15.017-14.38-10.487 0-14.558 5.876-14.558 13.929"
            transform="translate(352.2281 619.7106)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.332-5.337 6.332-3.618 0-5.246-2.624-5.246-6.332v-32.921c0-3.708 1.628-6.329 5.246-6.329 3.709 0 5.337 2.621 5.337 6.329m-20.893 1.628v29.665c0 9.585 4.706 16.549 15.556 16.549 10.947 0 15.647-6.964 15.647-16.549v-29.665c0-9.496-4.7-16.549-15.647-16.549-10.85 0-15.556 7.053-15.556 16.549"
            transform="translate(408.135 620.7025)"
          />
          <path
            d="m0 0h-.267l-6.964-39.79h-4.796l-7.69 39.79h-.178v-39.79h-8.503v61.317h12.033l6.691-34.546h.089l5.966 34.546h13.026v-61.317h-9.407z"
            transform="translate(452.733 646.2963)"
          />
          <path
            d="m0 0h-.267l-6.964-39.79h-4.796l-7.69 39.79h-.178v-39.79h-8.503v61.317h12.033l6.691-34.546h.089l5.966 34.546h13.026v-61.317h-9.407z"
            transform="translate(496.4282 646.2963)"
          />
          <path
            d="m0 0h8.23l-4.071 24.598h-.088zm-12.931-19.444 11.576 61.317h11.754l11.664-61.317h-10.577l-1.901 11.214h-10.94l-1.813-11.214z"
            transform="translate(523.04 625.95)"
          />
          <path
            d="m0 0h27.401v-8.411h-8.504v-52.906h-10.4v52.906h-8.497z"
            transform="translate(543.6723 667.8229)"
          />
          <path d="m575.875 667.823h10.31v-61.317h-10.31z" />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.332-5.336 6.332-3.619 0-5.247-2.624-5.247-6.332v-32.921c0-3.708 1.628-6.329 5.247-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.893 1.628v29.665c0 9.585 4.706 16.549 15.557 16.549 10.946 0 15.647-6.964 15.647-16.549v-29.665c0-9.496-4.701-16.549-15.647-16.549-10.851 0-15.557 7.053-15.557 16.549"
            transform="translate(613.0565 620.7025)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.317h10.132l11.124-35.182v35.182h8.593v-61.317h-9.045z"
            transform="translate(637.9385 645.0309)"
          />
          <path
            d="m0 0h24.601v-8.409h-14.291v-17.548h10.221v-8.319h-10.221v-18.629h14.291v-8.408h-24.601z"
            transform="translate(244.3831 586.3891)"
          />
          <path
            d="m0 0h27.4v-8.409h-8.503v-52.904h-10.4v52.904h-8.497z"
            transform="translate(273.3415 586.3891)"
          />
          <path
            d="m0 0v-24.15h3.804c3.523 0 5.062 1.718 5.062 5.069v14.108c0 3.345-1.539 4.973-5.062 4.973zm-10.31 8.409h15.284c10.405 0 14.203-5.153 14.203-13.745v-12.931c0-8.592-3.798-13.84-14.203-13.84h-4.974v-20.797h-10.31z"
            transform="translate(334.3557 577.9803)"
          />
          <path
            d="m0 0v-19.081h3.441c3.524 0 5.063 1.807 5.063 5.063v9.045c0 3.345-1.539 4.973-5.063 4.973zm0-24.78v-28.124h-10.31v61.313h15.017c10.399 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.353-10.494-8.23-11.849l9.858-27.851h-10.85z"
            transform="translate(369.1908 577.9803)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.328-5.336 6.328-3.619 0-5.247-2.62-5.247-6.328v-32.921c0-3.708 1.628-6.329 5.247-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.893 1.628v29.665c0 9.584 4.706 16.549 15.557 16.549 10.946 0 15.646-6.965 15.646-16.549v-29.665c0-9.496-4.7-16.549-15.646-16.549-10.851 0-15.557 7.053-15.557 16.549"
            transform="translate(414.6035 539.272)"
          />
          <path
            d="m0 0c4.249 0 5.877 2.531 5.877 6.239v32.107c0 3.619-1.628 6.15-5.877 6.15h-4.344v-44.496zm16.187 36.444v-28.392c0-9.407-3.886-16.46-14.922-16.46h-15.919v61.313h15.919c11.036 0 14.922-6.965 14.922-16.461"
            transform="translate(445.4572 533.484)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.558-15.646-10.857 0-15.38 6.15-15.38 15.646v46.392h10.31v-47.391c0-3.612 1.45-6.055 5.07-6.055 3.612 0 5.062 2.443 5.062 6.055v47.391z"
            transform="translate(497.4779 586.3891)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.379 16.55 11.392 0 14.559-6.329 14.559-15.373v-7.238h-9.407v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.247-2.621-5.247-6.328v-32.921c0-3.709 1.539-6.329 5.247-6.329s4.974 2.347 4.974 5.966v11.308h9.407v-10.583c0-8.77-3.619-15.283-14.559-15.283-10.857 0-15.379 7.053-15.379 16.549"
            transform="translate(503.3675 540.9002)"
          />
          <path
            d="m0 0h27.401v-8.409h-8.504v-52.904h-10.4v52.904h-8.497z"
            transform="translate(536.8479 586.3891)"
          />
          <path d="m569.056 586.389h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.328-5.337 6.328-3.618 0-5.247-2.62-5.247-6.328v-32.921c0-3.708 1.629-6.329 5.247-6.329 3.709 0 5.337 2.621 5.337 6.329m-20.894 1.628v29.665c0 9.584 4.707 16.549 15.557 16.549 10.947 0 15.647-6.965 15.647-16.549v-29.665c0-9.496-4.7-16.549-15.647-16.549-10.85 0-15.557 7.053-15.557 16.549"
            transform="translate(606.2327 539.272)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.313h10.133l11.124-35.178v35.178h8.592v-61.313h-9.044z"
            transform="translate(631.1199 563.5997)"
          />
          <path
            d="m0 0v-19.081h3.441c3.523 0 5.063 1.807 5.063 5.063v9.044c0 3.346-1.54 4.974-5.063 4.974zm0-24.78v-28.125h-10.31v61.32h15.017c10.398 0 14.195-5.159 14.195-13.751v-7.868c0-6.602-2.353-10.488-8.229-11.843l9.858-27.858h-10.851z"
            transform="translate(254.693 496.5498)"
          />
          <path
            d="m0 0h24.601v-8.415h-14.291v-17.542h10.221v-8.319h-10.221v-18.629h14.291v-8.414h-24.601z"
            transform="translate(279.2124 504.9645)"
          />
          <path
            d="m0 0v8.23h9.584v-8.408c0-3.441 1.54-5.425 5.07-5.425 3.25 0 4.7 2.169 4.7 5.425v2.347c0 3.53-1.45 5.699-4.611 8.682l-6.061 6.061c-5.878 5.788-8.593 9.317-8.593 16.372v2.079c0 7.594 4.433 13.472 14.469 13.472 10.31 0 14.381-5.064 14.381-13.923v-4.974h-9.407v5.336c0 3.523-1.628 5.241-4.878 5.241-2.894 0-4.885-1.628-4.885-5.063v-1.266c0-3.434 1.896-5.425 4.885-8.319l6.602-6.513c5.603-5.698 8.319-9.133 8.319-15.913v-2.99c0-8.408-4.522-14.374-15.017-14.374-10.487 0-14.558 5.878-14.558 13.923"
            transform="translate(308.355 456.8489)"
          />
          <path
            d="m0 0v-24.143h3.803c3.524 0 5.063 1.716 5.063 5.062v14.107c0 3.346-1.539 4.974-5.063 4.974zm-10.31 8.415h15.283c10.406 0 14.203-5.159 14.203-13.751v-12.931c0-8.592-3.797-13.833-14.203-13.833h-4.973v-20.805h-10.31z"
            transform="translate(353.672 496.5498)"
          />
          <path
            d="m0 0v32.914c0 3.709-1.628 6.335-5.336 6.335-3.619 0-5.248-2.626-5.248-6.335v-32.914c0-3.708 1.629-6.335 5.248-6.335 3.708 0 5.336 2.627 5.336 6.335m-20.893 1.628v29.658c0 9.585 4.706 16.55 15.557 16.55 10.946 0 15.646-6.965 15.646-16.55v-29.658c0-9.496-4.7-16.549-15.646-16.549-10.851 0-15.557 7.053-15.557 16.549"
            transform="translate(399.0905 457.8474)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.319h10.132l11.124-35.184v35.184h8.593v-61.319h-9.045z"
            transform="translate(423.9719 482.1692)"
          />
          <path
            d="m0 0v8.23h9.585v-8.408c0-3.441 1.539-5.425 5.069-5.425 3.251 0 4.7 2.169 4.7 5.425v2.347c0 3.53-1.449 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.317-8.593 16.372v2.079c0 7.594 4.433 13.472 14.47 13.472 10.31 0 14.38-5.064 14.38-13.923v-4.974h-9.406v5.336c0 3.523-1.628 5.241-4.879 5.241-2.894 0-4.885-1.628-4.885-5.063v-1.266c0-3.434 1.896-5.425 4.885-8.319l6.602-6.513c5.604-5.698 8.319-9.133 8.319-15.913v-2.99c0-8.408-4.522-14.374-15.016-14.374-10.489 0-14.559 5.878-14.559 13.923"
            transform="translate(450.4815 456.8489)"
          />
          <path
            d="m0 0h8.23l-4.071 24.602h-.089zm-12.931-19.443 11.576 61.319h11.753l11.666-61.319h-10.578l-1.902 11.213h-10.939l-1.813-11.213z"
            transform="translate(495.9007 463.0883)"
          />
          <path
            d="m0 0v-19.169h4.522c3.441 0 5.069 1.716 5.069 4.973v9.222c0 3.257-1.539 4.974-5.158 4.974zm0 7.868h3.619c3.345 0 4.884 1.717 4.884 4.974v7.504c0 3.346-1.539 4.974-4.973 4.974h-3.53zm-10.31 25.867h14.927c10.311 0 13.745-4.795 13.745-13.477v-6.24c0-5.158-1.902-8.408-6.15-9.769 5.152-1.177 7.689-4.612 7.689-10.215v-8.141c0-8.682-3.892-13.477-14.202-13.477h-16.009z"
            transform="translate(532.5359 471.2295)"
          />
          <path
            d="m0 0h10.31v-52.905h12.301v-8.414h-22.611z"
            transform="translate(557.6015 504.9645)"
          />
          <path
            d="m0 0h24.602v-8.415h-14.292v-17.542h10.221v-8.319h-10.221v-18.629h14.292v-8.414h-24.602z"
            transform="translate(584.9252 504.9645)"
          />
          <path
            d="m0 0v8.23h9.585v-8.408c0-3.441 1.539-5.425 5.069-5.425 3.251 0 4.7 2.169 4.7 5.425v2.347c0 3.53-1.449 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.317-8.593 16.372v2.079c0 7.594 4.434 13.472 14.47 13.472 10.31 0 14.38-5.064 14.38-13.923v-4.974h-9.406v5.336c0 3.523-1.628 5.241-4.879 5.241-2.894 0-4.885-1.628-4.885-5.063v-1.266c0-3.434 1.896-5.425 4.885-8.319l6.602-6.513c5.604-5.698 8.32-9.133 8.32-15.913v-2.99c0-8.408-4.523-14.374-15.017-14.374-10.488 0-14.559 5.878-14.559 13.923"
            transform="translate(614.0616 456.8489)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg13 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="126.2,83.9 126.2,285.4 92.3,285.4 92.3,131.1 92,131.1 68.3,155.8 67.9,155.8 67.9,120.4 99.2,83.9
        "
        />
        <path
          d="M238,127.6v17.5c0,16.9-9.2,28.2-23.2,32.7c16.9,3.9,25,15.8,25,34.2v29.7c0,27.9-14.9,46.1-49.1,46.1
        c-34.5,0-46.7-19.6-46.7-50.2v-26.4H175V240c0,11.9,4.1,19.6,15.8,19.6c10.4,0,15.1-7.4,15.1-18.1v-33.3c0-10.7-4.8-16.4-16.6-16.4
        H175v-25.9h12.8c11,0,18.1-5.7,18.1-16.4v-21.7c0-11-3.9-18.1-14.6-18.1s-14.6,7.1-14.6,19.6v20.5h-31V132
        c0-29.7,12.2-50.5,47.3-50.5C224.3,81.5,238,99,238,127.6"
        />
        {!quantitative && (
          <path
            d="M867.1,626C840.7,589.1,721.6,441.5,500,441.5S159.3,589.1,132.9,626c-1.1,1.6-2.1,3-2.9,4.1
        c0.8,1.2,1.8,2.5,2.9,4.2c26.4,37,145.5,184.5,367.1,184.5s340.7-147.6,367.1-184.5c1.2-1.6,2.1-3,2.8-4.2
        C869.2,629,868.2,627.6,867.1,626 M376.5,534.8c2-2.9,8.6-11.3,9.4-12.3c1.7-2.2,5.1-2.7,7.5-3.1s5.5,0.9,5.9,2.6s-0.9,8.6-2.1,9.8
        c-3.2,3.4-11.7,8.1-16.4,7.4C377.2,538.7,375.8,535.9,376.5,534.8 M368.5,550.6c0.4-0.4,0.7-0.8,0.8-0.9c2.8-3.2,8.3-3.9,12.2-4.5
        s9,1.3,9.6,3.8s-9.6,7.2-11.5,9c-5.3,4.9-13.7,14.9-18.5,16c-1.3,0.3-2.8,0.2-4-0.4C360.2,565.6,364,557.9,368.5,550.6 M451.4,720.7
        c-3,11.8-6.5,16-9.5,19.8s-14,8.6-21,8s-8-19.2-8-28.9c0-3.3-4.7,6.5-7.2-13.5c-1.6-12.8-9.8,1.3-10.4-7.2s-4.7-6.8-9-12.2
        s-9.7,0.5-15.7,3.2s-3.5,4.1-12,1.4c-0.2-0.1-0.3-0.1-0.5-0.2c-8.1-19-12.2-39.4-12.2-60.1c0-5.2,0.3-10.3,0.8-15.4
        c0.3-0.5,0.6-1,1-1.4c8.2-9.7,8-11.9,8-11.9l9-3.1c0,0,14.4,2.2,25.3,6.3c9,3.3,23,10.9,31.2,7.6c5.9-2.4,10.6-5.7,10-10.6
        c-0.7-6.2-5.5-7.7-11.4-3.5c-2.2,1.5-6.8-9.3-10.5-8.8s4.5,12.8,1.4,13.3s-9.3-12.7-10.4-14.9s-5.9-7.5-10.2-3.4
        c-9.1,8.7-23.9,8.1-26.9,10.3c-9,6.8-11.4-2.2-11.2-7.7c0.4-1.2,0.7-2.5,1.1-3.8c3-3.2,13.5-4.3,17.2-1.9c4,2.7,6.9-0.7,8.4-2.3
        s1-4.2,0-6.3s2-3.7,4.1-4.3s9-5.4,11.7-7s17-3.3,23.4-0.1c5.2,2.8,11.7,1.5,15.4-3.1c3.1-3.7,6.9-6.9,11.2-9.3
        c2.2-1-5.5-8.3-11.9-0.4s-9.6,8.6-12.6,8.6s-20.8-4.4-23-10.1s5.6-9.8,12.1-13s24.6-3.1,29.2-4.1c9.4-2,21.3-6.8,27.3-2.7
        s-25.1,11.1-14.9,16.7c3.6,2,20.1-9.5,25.8-12.4c13.3-6.8-12.9-9.1-9.5-23c3.8-15.7-32.1-9.6-50-8.3c71.8-45.9,167.2-25,213.1,46.8
        c9.3,14.5,16,30.4,20.1,47.1c0.1,2.4-0.2,4.8-0.8,7.2c-1.4,5.6-12,10.3-18.1,1.4c-1.6-2.3-8.2-8.5-8,2.2s10.4,11.8,0.5,18.2
        s-11.7,4.9-16.2,6.5s-9,12.6-7.9,18.5s15.2,22,4.7,21.3c-2.5-0.2-20.9-12.8-23.9-20.9c-3.2-8.5-6.7-16.9-9.2-23.3s-9-8-14.5-4.3
        s1.5,7.5-2.4,15.5s-6.8,15.2-12.5,8.6c-15.1-17.3-37-8.8-40.4-28c-1.9-10.4-10.8-9.4-18.3-15.3s-11.7-9-13-4.8
        c-1.1,3.7,23.6,23.3,25.4,28.3c2.6,7.5-7.4,14-14.7,15.8s-10.5-4.1-17.7-11.6s-10.3-12.8-10.8-6.9c-0.7,8.5,6.8,21,14.1,25.6
        c6.2,4,13.2,5.7,11.2,12.2s0,2.8-7,9.7s-8.3,9.2-7.8,18.8s-2,10.2-3.5,18.2S454.4,708.9,451.4,720.7 M617,659.1
        c5.2-0.4,13,6.8,9.9,9.5s-10.8,1.7-14.7-1.3S614.7,659.3,617,659.1 M610.4,654.4c-1.7-0.6-3.1-2.2-4.4-6s1.9-6,5-4.4
        s7.3,6.3,7.3,8.8S612.1,655,610.4,654.4 M542.3,654.1c-3,2.7-10.8,1.7-14.8-1.3s2.5-8,4.8-8.2C537.5,644.1,545.3,651.3,542.3,654.1
         M479.3,684.7c-2.1,3.5-7.9,29.4-11.8,26.4s1.6-30.1,2.7-32.2C476.3,667.8,489.5,668.4,479.3,684.7 M500.3,785.3
        c-14.7,0-29.3-2.1-43.4-6.2c-2.3-1.8-3-4.9-1.9-7.5c4.8-12.5,19-17.3,30.2-18.4c25-2.4,57.9,16.2,63.1,13.2s15.8-16.8,31.3-16.2
        c10.6,0.4,10.5,2.2,14.1,3.5C567,774.3,534.1,785.4,500.3,785.3 M609.2,740.4c-1.7-0.4-3.3-1-4.8-1.8c-8.4-4.3-7.4,2.6-11.6,1
        s4.7-11.2-7.8-3s-9-1.3-14.5-15s6.2-29.4,16-33c13.4-4.8,21.7-5.8,28-7.4c18.5-4.6,22.5-15.6,25.8-8.9c0.6,1.2,1.2,2.5,1.8,3.6
        c1.5,3.2,2.3,6.6,2.3,10.1C636.7,706.4,624.6,725,609.2,740.4 M651.4,662.5c-4.1-1.1-21.5-25.1-7.8-40.8c2.3-2.6-4.6-10.2-2.7-10.4
        c7.5-0.6,11.5,4.1,13.5,10.8c0.2,3,0.3,5.9,0.3,9C654.6,641.7,653.6,652.2,651.4,662.5"
          />
        )}
        <path
          d="M319.1,145.6v-40.4c0-13,6.1-22.5,20.9-22.5c15.5,0,19.8,8.6,19.8,20.9v9.8H347v-11c0-5.2-1.7-8.1-6.8-8.1
        s-7.1,3.6-7.1,8.6v44.8c0,5,2.1,8.6,7.1,8.6s6.8-3.2,6.8-8.1v-15.4h12.8v14.4c0,11.9-4.9,20.8-19.8,20.8S319.1,158.5,319.1,145.6z"
        />
        <path d="M368.7,83.7h14v72h16.7v11.4h-30.7V83.7z" />
        <path d="M407.1,83.7h14v83.4h-14V83.7z" />
        <path d="M470.2,113h-0.4l-9.5,54.1h-6.5L443.4,113h-0.2v54.1h-11.6V83.7h16.4l9.1,47h0.1l8.1-47H483v83.4h-12.8V113z" />
        <path
          d="M490,167.1l15.8-83.4h16l15.9,83.4h-14.4l-2.6-15.3h-14.9l-2.5,15.3H490z M507.6,140.7h11.2l-5.5-33.5h-0.1
        L507.6,140.7z"
        />
        <path d="M535.8,83.7h37.3v11.4h-11.6v72h-14.2v-72h-11.6V83.7z" />
        <path d="M580.8,83.7h33.5v11.4h-19.4V119h13.9v11.3h-13.9v25.4h19.5v11.4h-33.5V83.7z" />
        <path
          d="M316.6,285.4l15.8-83.4h16l15.9,83.4h-14.4l-2.6-15.3h-14.9l-2.5,15.3L316.6,285.4z M334.2,259h11.2l-5.5-33.5
        h-0.1L334.2,259z"
        />
        <path
          d="M368.3,263.9v-40.4c0-13.1,6.2-22.5,20.9-22.5c15.5,0,19.8,8.6,19.8,20.9v9.8h-12.8v-10.9
        c0-5.2-1.7-8.1-6.8-8.1s-7.1,3.6-7.1,8.6v44.8c0,5,2.1,8.6,7.1,8.6s6.8-3.2,6.8-8.1v-15.4h12.8v14.4c0,11.9-4.9,20.8-19.8,20.8
        S368.3,276.8,368.3,263.9z"
        />
        <path d="M414,202h37.3v11.4h-11.6v72h-14.2v-72H414V202z" />
        <path d="M459,202h14v83.4h-14V202z" />
        <path
          d="M482.4,263.9v-40.4c0-13.1,6.4-22.5,21.2-22.5c14.8,0,21.3,9.5,21.3,22.5v40.4c0,12.9-6.4,22.5-21.3,22.5
        S482.4,276.8,482.4,263.9z M510.8,266.1v-44.8c0-5-2.2-8.6-7.3-8.6s-7.1,3.6-7.1,8.6v44.8c0,5,2.2,8.6,7.1,8.6
        S510.8,271.1,510.8,266.1z"
        />
        <path d="M545.9,233v52.4H534V202h13.8l15.2,47.9V202h11.7v83.4h-12.3L545.9,233z" />
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <path
              d="m0 0c-2.395.655-12.423 14.516-4.495 23.639 1.317 1.499-2.661 5.912-1.573 5.999 4.337.336 6.644-2.354 7.782-6.234.087-1.708.154-3.434.154-5.176 0-6.247-.653-12.341-1.868-18.228m-24.461-45.083c-.895.25-1.812.54-2.806 1.035-4.873 2.481-4.29-1.483-6.685-.609-2.412.894 2.703 6.456-4.498 1.752-7.167-4.691-5.233.725-8.361 8.672-3.16 7.954 3.599 17.029 9.242 19.083 7.757 2.809 12.574 3.38 16.212 4.278 10.728 2.68 12.996 9.046 14.942 5.171.368-.725.723-1.415 1.046-2.064.625-1.158 1.345-3.503 1.38-5.817-4.554-11.938-11.581-22.654-20.472-31.501m-62.981-25.996c-8.727 0-17.14 1.271-25.1 3.596-1.145.933-1.798 2.493-1.082 4.364 2.764 7.206 10.991 10.026 17.487 10.651 14.482 1.411 33.514-9.4 36.54-7.655 3.038 1.741 9.158 9.702 18.14 9.369 6.131-.236 6.086-1.265 8.144-2.041-15.019-11.458-33.77-18.284-54.129-18.284m-12.143 58.206c-1.229-2.011-4.586-17.029-6.84-15.28-2.265 1.752.913 17.418 1.566 18.609 3.525 6.47 11.156 6.15 5.274-3.329m36.47 17.731c-1.763-1.57-6.278-.995-8.536.767-2.244 1.746 1.425 4.644 2.767 4.751 3.006.269 7.518-3.927 5.769-5.518m39.413-.154c-.962.36-1.812 1.271-2.543 3.463-.726 2.194 1.117 3.444 2.918 2.562 1.833-.93 4.211-3.664 4.211-5.125 0-1.462-3.603-1.287-4.586-.9m3.796-2.744c3.002.242 7.51-3.918 5.748-5.515-1.756-1.584-6.257-1.003-8.515.764-2.247 1.748 1.418 4.64 2.767 4.751m-95.797-35.61c-1.734-6.827-3.761-9.288-5.488-11.441-1.724-2.178-8.119-4.956-12.174-4.658-4.063.305-4.628 11.144-4.628 16.716 0 1.927-2.725-3.783-4.147 7.819-.91 7.428-5.678-.774-6.012 4.18-.34 4.943-2.721 3.958-5.228 7.048-2.49 3.087-5.598-.302-9.081-1.863-3.463-1.54-2.037-2.351-6.963-.801-.127.041-.19.078-.313.122-4.519 10.683-7.016 22.429-7.016 34.756 0 3.017.162 5.98.443 8.912.168.299.344.585.551.831 4.723 5.588 4.617 6.896 4.617 6.896l5.226 1.81s8.343-1.285 14.628-3.652c5.176-1.942 13.33-6.333 18.071-4.399 3.427 1.413 6.109 3.286 5.786 6.141-.386 3.58-3.206 4.432-6.619 2.017-1.26-.888-3.943 5.397-6.047 5.078-2.103-.313 2.602-7.385.819-7.685-1.791-.305-5.387 7.372-6.002 8.615-.604 1.235-3.381 4.316-5.874 1.965-5.267-5.004-13.821-4.698-15.539-5.985-5.228-3.912-6.608 1.287-6.492 4.454.21.723.425 1.454.656 2.17 1.707 1.882 7.835 2.505 9.938 1.103 2.31-1.543 3.968.397 4.871 1.334.915.915.593 2.398.017 3.629-.586 1.242 1.155 2.149 2.349 2.469 1.204.319 5.183 3.104 6.77 4.034 1.605.922 9.861 1.925 13.562.074 3.697-1.863 7.092-.342 8.912 1.8 2.282 2.707 5.186 4.772 6.475 5.397 1.295.605-3.185 4.788-6.869.228-3.694-4.536-5.573-4.956-7.307-4.956-1.735 0-12.044 2.572-13.316 5.83-1.257 3.252 3.224 5.691 7.03 7.536 3.803 1.814 14.215 1.789 16.877 2.391 5.411 1.187 12.328 3.905 15.812 1.533 3.469-2.33-14.552-6.435-8.628-9.633 2.107-1.158 11.633 5.481 14.899 7.179 7.68 3.96-7.448 5.269-5.485 13.32 2.219 9.102-18.554 5.582-28.909 4.807 13.887 8.898 30.381 14.074 48.089 14.074 42.13 0 77.42-29.185 86.831-68.431.063-1.94-.239-3.339-.436-4.133-.807-3.218-6.913-5.985-10.456-.804-.903 1.306-4.734 4.923-4.604-1.264.123-6.191 6.015-6.823.306-10.538-5.703-3.713-6.749-2.818-9.386-3.753-2.631-.931-5.184-7.31-4.555-10.718.639-3.409 8.778-12.716 2.739-12.334-1.415.105-12.087 7.392-13.849 12.08-1.858 4.933-3.887 9.762-5.327 13.484-1.458 3.706-5.222 4.654-8.414 2.472-3.174-2.176.889-4.346-1.397-8.998-2.276-4.644-3.912-8.792-7.265-4.955-8.716 9.989-21.382 5.062-23.369 16.176-1.071 6.025-6.261 5.448-10.598 8.861-4.361 3.392-6.787 5.239-7.521 2.781-.646-2.157 13.649-13.489 14.667-16.393 1.517-4.312-4.28-8.119-8.526-9.141-4.224-1.013-6.089 2.381-10.249 6.716-4.158 4.324-5.981 7.421-6.269 4.02-.417-4.912 3.951-12.128 8.189-14.825 3.613-2.289 7.662-3.325 6.493-7.039-1.176-3.725-.021-1.617-4.07-5.621-4.056-4.027-4.828-5.32-4.533-10.879.291-5.578-1.159-5.897-2.03-10.533-.867-4.637-2.879-.624-4.632-7.426m-47.973 98.419c.203.242.386.44.464.54 1.612 1.837 4.821 2.23 7.04 2.576 2.223.381 5.186-.739 5.544-2.216.38-1.469-5.572-4.166-6.66-5.175-3.084-2.841-7.912-8.628-10.735-9.251-.924-.207-1.682-.067-2.307.242 1.857 4.628 4.076 9.081 6.654 13.284m4.579 9.105c1.155 1.696 4.993 6.538 5.46 7.15.987 1.271 2.946 1.53 4.322 1.774 1.36.264 3.175-.503 3.393-1.526.235-1.025-.527-4.993-1.198-5.675-1.879-1.951-6.773-4.706-9.47-4.272-2.086.319-2.904 1.934-2.507 2.549m283.891-52.77c-15.244 21.383-84.202 106.755-212.384 106.755-128.203 0-197.14-85.372-212.408-106.755-.65-.915-1.208-1.705-1.664-2.377.456-.69 1.014-1.477 1.664-2.402 15.268-21.373 84.205-106.748 212.408-106.748 128.182 0 197.14 85.375 212.384 106.748.667.925 1.215 1.712 1.654 2.402-.439.672-.987 1.462-1.654 2.377"
              transform="translate(460.3002 173.2217)"
            />
          )}
          <path
            d="m0 0v-145.649h-24.494v111.49h-.214l-17.179-17.827h-.223v25.564l22.555 26.422z"
            transform="translate(84.1779 669.3677)"
          />
          <path
            d="m0 0v-12.669c0-12.24-6.658-20.402-16.753-23.634 12.24-2.79 18.042-11.381 18.042-24.7v-21.485c0-20.191-10.735-33.296-35.444-33.296-24.923 0-33.738 14.179-33.738 36.305v19.12h22.353v-20.844c0-8.591 3-14.17 11.385-14.17 7.508 0 10.942 5.364 10.942 13.104v24.056c0 7.74-3.434 11.814-12.021 11.814h-10.306v18.691h9.24c7.943 0 13.087 4.088 13.087 11.815v15.683c0 7.951-2.781 13.104-10.512 13.104-7.728 0-10.526-5.153-10.526-14.178v-14.819h-22.353v12.884c0 21.485 8.815 36.524 34.159 36.524 22.564 0 32.445-12.679 32.445-33.305"
            transform="translate(164.9473 637.7826)"
          />
          <path
            d="m0 0h-.27l-6.965-39.79h-4.792l-7.687 39.79h-.181v-39.79h-8.501v61.313h12.028l6.694-34.542h.089l5.969 34.542h13.023v-61.313h-9.407z"
            transform="translate(226.2691 643.6195)"
          />
          <path
            d="m0 0h24.599v-8.409h-14.289v-17.541h10.218v-8.326h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(239.8512 665.1427)"
          />
          <path
            d="m0 0v8.23h9.588v-8.414c0-3.435 1.536-5.426 5.063-5.426 3.256 0 4.703 2.176 4.703 5.426v2.353c0 3.53-1.447 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.59 9.312-8.59 16.365v2.08c0 7.6 4.43 13.478 14.47 13.478 10.31 0 14.378-5.064 14.378-13.93v-4.974h-9.405v5.337c0 3.53-1.628 5.247-4.884 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.265c0-3.441 1.899-5.432 4.882-8.32l6.602-6.513c5.606-5.698 8.319-9.133 8.319-15.919v-2.983c0-8.408-4.522-14.381-15.01-14.381-10.491 0-14.562 5.877-14.562 13.929"
            transform="translate(267.2641 617.033)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.07-15.646-14.562-15.646-10.851 0-15.373 6.15-15.373 15.646v46.392h10.31v-47.384c0-3.619 1.448-6.062 5.063-6.062 3.619 0 5.066 2.443 5.066 6.062v47.384z"
            transform="translate(330.4981 665.1427)"
          />
          <path
            d="m0 0v-19.08h3.434c3.53 0 5.067 1.806 5.067 5.062v9.045c0 3.345-1.537 4.973-5.067 4.973zm0-24.779v-28.125h-10.31v61.313h15.014c10.398 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.351-10.487-8.231-11.849l9.859-27.851h-10.851z"
            transform="translate(344.9836 656.7339)"
          />
          <path
            d="m0 0h24.598v-8.409h-14.288v-17.541h10.218v-8.326h-10.218v-18.629h14.288v-8.408h-24.598z"
            transform="translate(367.7853 665.1427)"
          />
          <path
            d="m0 0v8.23h9.588v-8.414c0-3.435 1.536-5.426 5.063-5.426 3.256 0 4.703 2.176 4.703 5.426v2.353c0 3.53-1.447 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.59 9.312-8.59 16.365v2.08c0 7.6 4.43 13.478 14.47 13.478 10.31 0 14.377-5.064 14.377-13.93v-4.974h-9.403v5.337c0 3.53-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.265c0-3.441 1.899-5.432 4.882-8.32l6.601-6.513c5.607-5.698 8.32-9.133 8.32-15.919v-2.983c0-8.408-4.519-14.381-15.01-14.381s-14.562 5.877-14.562 13.929"
            transform="translate(395.1982 617.033)"
          />
          <path
            d="m0 0v-19.08h3.435c3.527 0 5.066 1.806 5.066 5.062v9.045c0 3.345-1.539 4.973-5.066 4.973zm0-24.779v-28.125h-10.31v61.313h15.014c10.399 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.351-10.487-8.231-11.849l9.859-27.851h-10.851z"
            transform="translate(455.3643 656.7339)"
          />
          <path
            d="m0 0h24.599v-8.409h-14.289v-17.541h10.218v-8.326h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(478.166 665.1427)"
          />
          <path
            d="m0 0h10.31v-52.905h12.298v-8.408h-22.608z"
            transform="translate(506.5741 665.1427)"
          />
          <path
            d="m0 0h8.227l-4.067 24.601h-.093zm-12.933-19.444 11.575 61.314h11.757l11.665-61.314h-10.58l-1.899 11.214h-10.943l-1.809-11.214z"
            transform="translate(543.4829 623.2731)"
          />
          <path
            d="m0 0h27.403v-8.409h-8.5v-52.904h-10.402v52.904h-8.501z"
            transform="translate(562.3984 665.1427)"
          />
          <path d="m592.887 665.143h10.31v-61.313h-10.31z" />
          <path
            d="m0 0-11.669-61.313h-11.212l-11.665 61.313h10.488l7.053-42.773h.093l7.234 42.773z"
            transform="translate(640.4617 665.1427)"
          />
          <path
            d="m0 0h24.598v-8.409h-14.288v-17.541h10.217v-8.326h-10.217v-18.629h14.288v-8.408h-24.598z"
            transform="translate(643.0057 665.1427)"
          />
          <path
            d="m0 0v8.23h9.588v-8.414c0-3.435 1.536-5.426 5.063-5.426 3.256 0 4.703 2.176 4.703 5.426v2.353c0 3.53-1.447 5.699-4.611 8.682l-6.061 6.061c-5.878 5.788-8.59 9.312-8.59 16.365v2.08c0 7.6 4.43 13.478 14.47 13.478 10.31 0 14.377-5.064 14.377-13.93v-4.974h-9.403v5.337c0 3.53-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.265c0-3.441 1.899-5.432 4.882-8.32l6.601-6.513c5.607-5.698 8.32-9.133 8.32-15.919v-2.983c0-8.408-4.522-14.381-15.01-14.381-10.491 0-14.562 5.877-14.562 13.929"
            transform="translate(670.4186 617.033)"
          />
          <path
            d="m0 0h8.227l-4.067 24.601h-.093zm-3.708 53.357 16.187-3.435v-5.788l-16.187 2.08zm-9.225-72.801 11.575 61.314h11.757l11.665-61.314h-10.58l-1.899 11.214h-10.943l-1.809-11.214z"
            transform="translate(209.1786 541.8484)"
          />
          <path
            d="m0 0h10.31v-52.904h12.298v-8.409h-22.608z"
            transform="translate(247.5687 583.7181)"
          />
          <path
            d="m0 0h8.227l-4.068 24.601h-.092zm-12.934-19.444 11.576 61.314h11.756l11.666-61.314h-10.581l-1.899 11.214h-10.942l-1.81-11.214z"
            transform="translate(284.4807 541.8484)"
          />
          <path
            d="m0 0h10.31v-52.904h12.298v-8.409h-22.608z"
            transform="translate(322.8701 583.7181)"
          />
          <path
            d="m0 0v-46.392c0-9.495-4.07-15.646-14.562-15.646-10.851 0-15.373 6.151-15.373 15.646v46.392h10.31v-47.384c0-3.619 1.448-6.061 5.063-6.061 3.619 0 5.066 2.442 5.066 6.061v47.384z"
            transform="translate(377.5051 583.7181)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.5v-52.905h-10.402v52.905h-8.501z"
            transform="translate(380.5037 583.7181)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.501v-52.905h-10.401v52.905h-8.501z"
            transform="translate(409.8184 583.7181)"
          />
          <path
            d="m0 0h24.598v-8.408h-14.288v-17.542h10.217v-8.326h-10.217v-18.628h14.288v-8.409h-24.598z"
            transform="translate(440.3067 583.7181)"
          />
          <path
            d="m0 0v29.664c0 9.586 4.522 16.55 15.373 16.55 11.394 0 14.562-6.328 14.562-15.373v-7.237h-9.407v8.051c0 3.798-1.266 5.966-4.974 5.966s-5.244-2.62-5.244-6.328v-32.921c0-3.708 1.536-6.328 5.244-6.328s4.974 2.353 4.974 5.966v11.308h9.407v-10.584c0-8.77-3.62-15.283-14.562-15.283-10.851 0-15.373 7.053-15.373 16.549"
            transform="translate(482.4932 538.2292)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.329-5.336 6.329-3.616 0-5.244-2.621-5.244-6.329v-32.921c0-3.708 1.628-6.328 5.244-6.328 3.708 0 5.336 2.62 5.336 6.328m-20.89 1.628v29.665c0 9.585 4.703 16.549 15.554 16.549 10.943 0 15.646-6.964 15.646-16.549v-29.665c0-9.496-4.703-16.549-15.646-16.549-10.851 0-15.554 7.053-15.554 16.549"
            transform="translate(537.22 536.601)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.128l11.125-35.179v35.179h8.589v-61.314h-9.041z"
            transform="translate(560.3911 560.9293)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.5v-52.905h-10.402v52.905h-8.501z"
            transform="translate(584.5501 583.7181)"
          />
          <path
            d="m0 0v-19.081h3.434c3.527 0 5.067 1.806 5.067 5.063v9.044c0 3.346-1.54 4.974-5.067 4.974zm0-24.78v-28.125h-10.31v61.313h15.014c10.398 0 14.195-5.151 14.195-13.744v-7.868c0-6.602-2.35-10.488-8.23-11.849l9.858-27.852h-10.85z"
            transform="translate(625.3484 575.3099)"
          />
          <path
            d="m0 0h24.598v-8.408h-14.288v-17.542h10.217v-8.326h-10.217v-18.628h14.288v-8.409h-24.598z"
            transform="translate(648.1535 583.7181)"
          />
          <path
            d="m0 0h10.31v-52.905h12.298v-8.408h-22.608z"
            transform="translate(197.8734 502.2876)"
          />
          <path
            d="m0 0h24.599v-8.408h-14.288v-17.542h10.217v-8.326h-10.217v-18.629h14.288v-8.408h-24.599z"
            transform="translate(223.4764 502.2876)"
          />
          <path
            d="m0 0v8.23h9.588v-8.408c0-3.441 1.536-5.432 5.063-5.432 3.256 0 4.704 2.175 4.704 5.432v2.347c0 3.53-1.448 5.699-4.612 8.682l-6.061 6.06c-5.877 5.788-8.59 9.312-8.59 16.365v2.081c0 7.6 4.431 13.477 14.47 13.477 10.31 0 14.378-5.062 14.378-13.929v-4.974h-9.404v5.337c0 3.53-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.266c0-3.44 1.899-5.425 4.882-8.325l6.602-6.507c5.607-5.699 8.32-9.133 8.32-15.92v-2.983c0-8.408-4.52-14.38-15.011-14.38s-14.562 5.876-14.562 13.929"
            transform="translate(250.8893 454.1785)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.372 16.55 11.395 0 14.563-6.329 14.563-15.373v-7.238h-9.408v8.052c0 3.797-1.265 5.966-4.974 5.966-3.707 0-5.243-2.621-5.243-6.328v-32.921c0-3.708 1.536-6.329 5.243-6.329 3.709 0 4.974 2.354 4.974 5.966v11.309h9.408v-10.584c0-8.77-3.62-15.283-14.563-15.283-10.85 0-15.372 7.053-15.372 16.549"
            transform="translate(297.9677 456.7987)"
          />
          <path
            d="m0 0h-9.947v-27.038h-10.31v61.314h10.31v-25.95h9.947v25.95h10.399v-61.314h-10.399z"
            transform="translate(352.0614 468.012)"
          />
          <path
            d="m0 0h8.226l-4.067 24.601h-.092zm-12.934-19.444 11.576 61.314h11.756l11.666-61.314h-10.581l-1.899 11.214h-10.942l-1.81-11.214z"
            transform="translate(377.9419 460.4179)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.129l11.124-35.179v35.179h8.589v-61.314h-9.041z"
            transform="translate(411.2347 479.4988)"
          />
          <path
            d="m0 0h14.651v-32.737h-7.416v6.692c-1.355-4.611-4.249-7.416-9.858-7.416-8.861 0-12.931 7.053-12.931 16.549v29.664c0 9.585 4.611 16.55 15.465 16.55 11.394 0 14.74-6.329 14.74-15.373v-5.426h-9.404v6.24c0 3.797-1.447 5.966-5.155 5.966s-5.336-2.621-5.336-6.328v-32.921c0-3.708 1.536-6.329 5.063-6.329 3.345 0 5.066 1.902 5.066 5.877v10.857h-4.885z"
            transform="translate(452.128 473.7108)"
          />
          <path
            d="m0 0h24.599v-8.408h-14.289v-17.542h10.218v-8.326h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(470.9543 502.2876)"
          />
          <path
            d="m0 0h-.27l-6.965-39.79h-4.792l-7.687 39.79h-.181v-39.79h-8.501v61.313h12.028l6.691-34.542h.092l5.969 34.542h13.023v-61.313h-9.407z"
            transform="translate(527.7581 480.7643)"
          />
          <path
            d="m0 0h24.599v-8.408h-14.289v-17.542h10.218v-8.326h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(541.3402 502.2876)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.129l11.124-35.179v35.179h8.589v-61.314h-9.041z"
            transform="translate(578.4306 479.4988)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.5v-52.905h-10.402v52.905h-8.501z"
            transform="translate(602.593 502.2876)"
          />
          <path
            d="m0 0v8.23h9.588v-8.408c0-3.441 1.536-5.432 5.063-5.432 3.256 0 4.703 2.175 4.703 5.432v2.347c0 3.53-1.447 5.699-4.611 8.682l-6.061 6.06c-5.877 5.788-8.59 9.312-8.59 16.365v2.081c0 7.6 4.43 13.477 14.47 13.477 10.31 0 14.378-5.062 14.378-13.929v-4.974h-9.405v5.337c0 3.53-1.628 5.247-4.884 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.266c0-3.44 1.899-5.425 4.882-8.325l6.602-6.507c5.606-5.699 8.319-9.133 8.319-15.92v-2.983c0-8.408-4.522-14.38-15.01-14.38-10.491 0-14.562 5.876-14.562 13.929"
            transform="translate(631.6341 454.1785)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.372 16.55 11.396 0 14.563-6.329 14.563-15.373v-7.238h-9.407v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.244-2.62-5.244-6.328v-32.921c0-3.709 1.536-6.329 5.244-6.329s4.974 2.353 4.974 5.966v11.308h9.407v-10.583c0-8.77-3.62-15.283-14.563-15.283-10.85 0-15.372 7.053-15.372 16.549"
            transform="translate(197.8734 375.3682)"
          />
          <path
            d="m0 0h10.31v-52.905h12.298v-8.408h-22.608z"
            transform="translate(231.71 420.8564)"
          />
          <path d="m257.314 420.856h10.31v-61.313h-10.31z" />
          <path
            d="m0 0h-.27l-6.965-39.79h-4.792l-7.686 39.79h-.181v-39.79h-8.501v61.313h12.027l6.694-34.543h.089l5.97 34.543h13.022v-61.313h-9.407z"
            transform="translate(300.2769 399.3338)"
          />
          <path
            d="m0 0h8.227l-4.067 24.602h-.093zm-12.933-19.443 11.575 61.313h11.757l11.665-61.313h-10.58l-1.899 11.213h-10.943l-1.809-11.213z"
            transform="translate(325.1647 378.9868)"
          />
          <path
            d="m0 0h27.404v-8.408h-8.501v-52.905h-10.402v52.905h-8.501z"
            transform="translate(344.077 420.8564)"
          />
          <path d="m374.565 420.856h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v33.461c0 3.708-1.628 6.328-5.336 6.328-3.616 0-5.244-2.62-5.244-6.328v-33.461c0-3.619 1.628-6.329 5.244-6.329 3.708 0 5.336 2.71 5.336 6.329m-9.133-17.815v4.159c-8.23 1.444-11.757 7.505-11.757 15.825v29.664c0 9.585 4.703 16.55 15.554 16.55 10.943 0 15.646-6.965 15.646-16.55v-29.664c0-6.692-2.35-11.938-7.597-14.47l7.597-1.444v-7.689z"
            transform="translate(410.0204 373.1994)"
          />
          <path
            d="m0 0v-46.392c0-9.495-4.071-15.646-14.562-15.646-10.85 0-15.373 6.151-15.373 15.646v46.392h10.311v-47.384c0-3.619 1.446-6.061 5.062-6.061 3.62 0 5.066 2.442 5.066 6.061v47.384z"
            transform="translate(454.4437 420.8564)"
          />
          <path
            d="m0 0h24.598v-8.408h-14.288v-17.541h10.217v-8.326h-10.217v-18.63h14.288v-8.408h-24.598z"
            transform="translate(458.6198 420.8564)"
          />
          <path
            d="m0 0v8.23h9.588v-8.414c0-3.435 1.536-5.426 5.063-5.426 3.256 0 4.704 2.176 4.704 5.426v2.353c0 3.53-1.448 5.699-4.612 8.681l-6.061 6.062c-5.877 5.788-8.59 9.312-8.59 16.365v2.08c0 7.6 4.431 13.478 14.47 13.478 10.31 0 14.377-5.064 14.377-13.93v-4.974h-9.403v5.337c0 3.53-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.265c0-3.441 1.899-5.432 4.882-8.32l6.602-6.513c5.607-5.698 8.32-9.133 8.32-15.919v-2.983c0-8.408-4.523-14.381-15.011-14.381-10.491 0-14.562 5.877-14.562 13.929"
            transform="translate(486.0321 372.7474)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg14 = ({ lang }) => {
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)" fill="currentColor">
          <path
            d="m0 0c-13.279 0-24.042 10.778-24.042 24.05 0 13.274 10.763 24.023 24.042 24.023 13.311 0 24.069-10.749 24.069-24.023 0-13.272-10.758-24.05-24.069-24.05m104.412 11.206c-9.096 12.287-67.844 87.189-150.21 87.189-71.525 0-148.04-64.874-148.04-64.874s-28.743 58.828-87.537 64.481c-.346 0-.714.077-1.105.077h-.364c-1.227-.068-2.377-1.26-2.245-2.327.167-1.03.921-2.151.921-2.151 7.578-12.581 26.918-48.376 26.918-84.137 0-35.876-19.454-71.768-26.962-84.289l-.509-.798c-.219-.377-.368-.754-.368-1.241 0-1.241.964-2.206 2.171-2.316l.636.053c.197 0 .408 0 .618.057 58.977 5.495 87.826 64.503 87.826 64.503s76.515-64.88 148.04-64.88c82.366 0 141.114 74.906 150.21 87.166.25.335.452.625.631.844.106.287.193.556.193.901 0 .322-.087.647-.193.897-.179.25-.381.537-.631.845"
            transform="translate(457.2316 191.4867)"
          />
          <path
            d="m0 0c.189.268.364.464.627.651.386.241.816.443 1.298.443.614 0 1.198-.25 1.61-.658.022-.039.07-.072.105-.101 44.9-42.802 92.005-8.108 101.807 0l.961.917c.276.109.574.149.89.149.342 0 .666-.04.947-.149l.961-.917c9.792-8.108 56.881-42.802 101.797 0 .009.029.049.062.084.101.421.408.969.658 1.592.658.496 0 .942-.202 1.303-.443.28-.187.464-.383.666-.651 8.701-8.563 46.307-40.944 86.107-6.364.416.424.697.979.697 1.66v16.438c0 1.309-1.052 2.352-2.346 2.352-.172 0-.329-.066-.509-.098-.369-.178-.755-.384-1.193-.597-12.218-6.131-50.162-20.665-84.58 11.863-.321.307-.658.614-.996.946-.32.177-.622.234-1.008.234-.242 0-.496-.057-.711-.178-.517-.129-.921-.456-1.197-.881-10.254-7.811-57.355-39.703-99.299-.577l-.613.614c-.435.419-1.036.658-1.702.658-.614 0-1.229-.239-1.641-.658l-.648-.614c-41.918-39.126-89.063-7.234-99.308.577-.267.425-.666.752-1.162.881-.241.121-.495.178-.754.178-.338 0-.662-.057-.978-.234-.325-.332-.671-.639-1.022-.946-34.423-32.528-72.331-17.994-84.567-11.863-.43.213-.834.419-1.206.597-.185.032-.303.098-.452.098-1.307 0-2.368-1.043-2.368-2.352v-16.438c0-.681.258-1.236.684-1.66 39.764-34.58 77.414-2.199 86.124 6.364"
            transform="translate(257.9946 357.0206)"
          />
          <path
            d="m0 0c-.18.04-.303.101-.452.101-1.303 0-2.364-1.063-2.364-2.388v-16.393c0-.687.258-1.29.688-1.698 39.76-34.547 77.406-2.177 86.12 6.377.18.259.364.509.623.667.39.249.816.427 1.302.427.614 0 1.193-.236 1.601-.633.031-.044.079-.081.114-.101 44.913-42.863 92.005-8.146 101.803 0l.965.882c.276.128.574.177.894.177.334 0 .667-.049.934-.177l.97-.882c9.792-8.146 56.885-42.863 101.793 0 .009.02.066.057.088.101.421.397.974.633 1.597.633.486 0 .937-.178 1.302-.427.272-.158.46-.408.663-.667 8.704-8.554 46.311-40.924 86.106-6.377.412.408.684 1.011.684 1.698v16.393c0 1.325-1.031 2.388-2.333 2.388-.172 0-.329-.061-.509-.101-.369-.21-.75-.408-1.193-.618-12.227-6.127-50.154-20.696-84.58 11.876-.325.302-.663.605-1.001.956-.315.13-.617.215-1.003.215-.242 0-.501-.068-.711-.11-.513-.206-.921-.533-1.197-.929-10.262-7.822-57.355-39.703-99.294-.581l-.614.598c-.439.389-1.035.706-1.702.706-.618 0-1.232-.317-1.64-.706l-.653-.598c-41.918-39.122-89.063-7.241-99.308.581-.267.396-.662.723-1.166.929-.242.042-.483.11-.75.11-.334 0-.667-.085-.987-.215-.307-.351-.671-.654-1.009-.956-34.422-32.572-72.335-18.003-84.571-11.876-.43.21-.838.408-1.21.618"
            transform="translate(174.0026 430.6695)"
          />
          <path
            d="m0 0v-145.649h-24.494v111.49h-.214l-17.179-17.827h-.224v25.563l22.556 26.423z"
            transform="translate(100.934 669.1859)"
          />
          <path
            d="m0 0 21.924 59.964h.215v-59.964zm44.922-42.768v23.638h9.885v19.13h-9.885v102.947h-24.073l-42.338-107.03v-15.047h43.198v-23.638z"
            transform="translate(130.5932 566.2719)"
          />
          <path
            d="m0 0-11.668-61.313h-11.213l-11.668 61.313h10.492l7.053-42.773h.092l7.235 42.773z"
            transform="translate(277.3321 669.1473)"
          />
          <path d="m281.597 669.147h10.31v-61.313h-10.31z" />
          <path
            d="m0 0h24.599v-8.409h-14.289v-17.541h10.218v-8.326h-10.218v-18.629h14.289v-8.408h-24.599z"
            transform="translate(297.8824 669.1473)"
          />
          <path
            d="m0 0h8.227l-4.067 24.601h-.093zm-12.933-19.444 11.575 61.314h11.757l11.665-61.314h-10.58l-1.899 11.214h-10.943l-1.809-11.214z"
            transform="translate(255.6278 541.3245)"
          />
          <path
            d="m0 0v33.461c0 3.708-1.628 6.329-5.336 6.329-3.616 0-5.244-2.621-5.244-6.329v-33.461c0-3.619 1.628-6.329 5.244-6.329 3.708 0 5.336 2.71 5.336 6.329m-9.133-17.815v4.159c-8.231 1.444-11.757 7.506-11.757 15.825v29.664c0 9.585 4.703 16.55 15.554 16.55 10.942 0 15.646-6.965 15.646-16.55v-29.664c0-6.691-2.35-11.938-7.597-14.47l7.597-1.443v-7.69z"
            transform="translate(301.4919 535.5365)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.562-15.646-10.851 0-15.373 6.15-15.373 15.646v46.392h10.31v-47.384c0-3.619 1.447-6.062 5.063-6.062 3.619 0 5.066 2.443 5.066 6.062v47.384z"
            transform="translate(347.6327 583.1942)"
          />
          <path
            d="m0 0h8.227l-4.067 24.601h-.093zm-12.933-19.444 11.575 61.314h11.757l11.665-61.314h-10.58l-1.899 11.214h-10.943l-1.809-11.214z"
            transform="translate(363.4728 541.3245)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.501v-52.905h-10.401v52.905h-8.501z"
            transform="translate(384.1025 583.1942)"
          />
          <path d="m416.311 583.194h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v33.461c0 3.708-1.628 6.329-5.336 6.329-3.616 0-5.244-2.621-5.244-6.329v-33.461c0-3.619 1.628-6.329 5.244-6.329 3.708 0 5.336 2.71 5.336 6.329m-9.133-17.815v4.159c-8.23 1.444-11.757 7.506-11.757 15.825v29.664c0 9.585 4.703 16.55 15.554 16.55 10.942 0 15.646-6.965 15.646-16.55v-29.664c0-6.691-2.353-11.938-7.597-14.47l7.597-1.443v-7.69z"
            transform="translate(453.4866 535.5365)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.07-15.646-14.562-15.646-10.851 0-15.373 6.15-15.373 15.646v46.392h10.31v-47.384c0-3.619 1.447-6.062 5.063-6.062 3.619 0 5.066 2.443 5.066 6.062v47.384z"
            transform="translate(499.6242 583.1942)"
          />
          <path
            d="m0 0h24.598v-8.408h-14.288v-17.542h10.218v-8.326h-10.218v-18.629h14.288v-8.408h-24.598z"
            transform="translate(505.5171 583.1942)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg15 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon points="319.6,83.7 319.6,165.5 349.7,165.5 349.7,154.3 333.3,154.3 333.3,83.7 " />
        <rect x="357.2" y="83.7" width="13.7" height="81.8" />
        <polygon
          points="380,165.5 393.7,165.5 393.7,129.4 407.5,129.4 407.5,118.3 393.7,118.3 393.7,94.9 412.1,94.9
        412.1,83.7 380,83.7 "
        />
        <polygon
          points="419.4,165.5 452.2,165.5 452.2,154.3 433.1,154.3 433.1,129.4 446.8,129.4 446.8,118.3 433.1,118.3
        433.1,94.9 452.2,94.9 452.2,83.7 419.4,83.7 "
        />
        <polygon points="73.2,120.3 73.2,155.7 73.5,155.7 97.3,131 97.6,131 97.6,285.3 131.5,285.3 131.5,83.7 104.4,83.7 " />
        <path
          d="M212.1,147.6c-13.4,0-23.2,4.8-28.6,14h-0.3v-50.3h58.3V83.7h-89.2v113.6h30.9v-4.5c0-11.9,5.4-18.4,14.9-18.4
        c10.4,0,14.6,7.1,14.6,18.1v48.8c0,10.7-3.9,18.1-14.3,18.1c-11.6,0-15.7-7.7-15.7-19.6v-25.3h-31v22.9c0,30.6,12.2,50.2,46.7,50.2
        c34.2,0,48.2-18.1,48.2-46.1v-49.4C246.5,160.4,230.2,147.6,212.1,147.6"
        />
        <path
          d="M319.5,264.3v-39.4c0-12.7,6.2-22,20.7-22s20.8,9.2,20.8,22v39.4c0,12.6-6.2,22-20.8,22
        S319.5,276.9,319.5,264.3 M347.2,266.5v-43.7c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.7c0,4.9,2.2,8.4,7,8.4S347.2,271.4,347.2,266.5
        "
        />
        <polygon
          points="380.2,234.2 380.2,285.3 368.7,285.3 368.7,203.9 382.2,203.9 396.9,250.6 396.9,203.9 408.4,203.9
        408.4,285.3 396.4,285.3 "
        />
        <polygon points="438,203.9 451.7,203.9 451.7,274.2 468.1,274.2 468.1,285.3 438,285.3 " />
        <path
          d="M472.1,285.3l15.4-81.4h15.6l15.5,81.4h-14.1l-2.5-14.9h-14.5l-2.4,14.9L472.1,285.3z M489.3,259.5h10.9
        l-5.4-32.7h-0.1L489.3,259.5z"
        />
        <polygon
          points="535.7,234.2 535.7,285.3 524.2,285.3 524.2,203.9 537.7,203.9 552.4,250.6 552.4,203.9 563.8,203.9
        563.8,285.3 551.8,285.3 "
        />
        <path
          d="M613.7,225.8v37.7c0,12.5-5.2,21.9-19.8,21.9h-21.1v-81.4h21.1C608.5,203.9,613.7,213.1,613.7,225.8
         M592.2,274.2c5.6,0,7.8-3.4,7.8-8.3v-42.6c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.1L592.2,274.2z"
        />
        {!quantitative && (
          <g>
            <path
              d="M419.2,676.1c1.2,0,2.2,1,2.2,2.2l0,0v72.8c0,1.2-1,2.2-2.2,2.2c0,0,0,0,0,0h-29.5c-1.2,0-2.2-1-2.2-2.2
          c0,0,0,0,0,0v-72.8c0-1.2,1-2.2,2.2-2.2c0,0,0,0,0,0H419.2z"
            />
            <path
              d="M742.8,784.6H257.2c-1.2,0-2.2,1-2.2,2.3v29.7c0,1.2,1,2.2,2.2,2.2h485.6c1.2,0,2.2-1,2.2-2.2v-29.7
          C745,785.7,744,784.7,742.8,784.6"
            />
            <path
              d="M742.8,843.6H257.2c-1.2,0-2.2,1-2.2,2.2v29.8c0,1.2,1,2.2,2.2,2.2h485.6c1.2,0,2.2-1,2.2-2.2v-29.8
          C745,844.6,744,843.6,742.8,843.6"
            />
            <path
              d="M650.4,595.5c-6.1-4.8-22.3-15.8-42-15.8c-14.1,0-27.2,5.6-39,16.6c-0.8,0.8-1.3,1.9-1.3,3v2.7
          c-0.1,1.3,0.5,2.5,1.4,3.3c0.9,0.8,2.2,1.1,3.4,0.8c0.3,0,0.6-0.1,0.9-0.2c0.9-0.3,1.7-0.9,2.4-1.5c2.5-1.7,9.5-4,19.5-4
          c10.3,0,30.5,2.8,50,21l0.5,0.4c1.1,1.1,2.6,1.8,4.2,1.8c1.5,0,3-0.6,4.1-1.7l0.4-0.4c19.6-18.2,39.8-21,50.1-21
          c10,0,17,2.3,19.5,4c0.8,0.7,1.7,1.3,2.7,1.6c0.9,0.2,1.9,0.2,2.8,0c1.8-0.5,3.1-2.1,3.1-4v-2.3c0-1.1-0.5-2.2-1.3-3
          c-11.9-11.3-25.1-17-39.5-17C672.7,579.7,656.6,590.6,650.4,595.5"
            />
            <path
              d="M620.3,402c-1,0.5-1.8,1.4-2.1,2.6l-0.5,1.6c-0.4,1.2-0.1,2.6,0.6,3.6c0.7,1,1.8,1.6,3,1.6c0.2,0,0.4,0,0.6,0
          c0.8,0,1.6-0.2,2.3-0.6c1-0.2,2-0.3,3-0.3c2.2,0,21.8,0.7,34.7,22.7l0.2,0.3c0.6,1.2,1.8,2.1,3.1,2.5c0.5,0.1,1,0.2,1.5,0.2
          c0.9,0,1.7-0.2,2.5-0.6l0.3-0.2c6.7-3.4,14.1-5.3,21.7-5.4c12.3,0,20.3,5,22.2,7.1c0.4,0.7,0.9,1.3,1.6,1.8c0.5,0.3,1,0.5,1.6,0.8
          c0.2,0.1,0.5,0.1,0.7,0.1c0.1,0,0.3,0,0.4,0c0.7,0,1.3-0.2,1.9-0.5c1-0.5,1.7-1.4,2.1-2.5l0.4-1.4c0.1-0.4,0.2-0.8,0.2-1.2
          c0-0.7-0.2-1.5-0.6-2.1c-9.4-16.4-23.1-19.8-32.9-19.8c-6,0.1-11.9,1.2-17.5,3.3c-4.4-6-15.7-18.4-32.8-18.4
          C632.1,397.4,625.9,399,620.3,402"
            />
            <path
              d="M517.7,476.7l0.1,2.2c0.1,2.3,2.1,4,4.4,3.9c0.3,0,0.5-0.1,0.8-0.1c0.2-0.1,0.5-0.1,0.7-0.2
          c0.8-0.3,1.5-0.9,2.1-1.5c2.1-1.5,8.7-4.2,18.5-4.2c9.4,0,23.8,2.5,38.4,14.5l0.3,0.4c1,0.9,2.4,1.4,3.8,1.4h0.4
          c1.5-0.1,2.8-0.8,3.8-1.8l0.3-0.4c16.2-17.1,33.6-19.7,42.6-19.7c6.4,0,10.9,1.3,12.7,2.3c0.7,0.6,1.6,1.1,2.5,1.3
          c0.9,0.2,1.9,0.2,2.8-0.1c1.7-0.6,2.9-2.3,2.8-4.2l-0.1-1.9c-0.1-1.1-0.6-2.2-1.5-2.9c-9.7-8.1-20.1-12.2-31.1-12.2
          c-17.1,0-30.7,10.1-36.3,15c-5.2-3.5-17.7-10.8-32.4-10.8c-12.9,0-24.5,5.4-34.5,15.9C518,474.4,517.6,475.5,517.7,476.7"
            />
            <path
              d="M271.9,515.7c0-29.1,23.6-52.7,52.6-52.7c0,0,0,0,0,0c1.1,0,2.2,0.1,3.4,0.2c2.9-39.2,37.1-68.6,76.3-65.7
          s68.6,37.1,65.7,76.3c-0.7,9-3,17.8-7,25.9c42.9,9.5,70,51.9,60.6,94.9c-8.1,36.5-40.4,62.5-77.8,62.4c-3.2,0-106.2-0.6-106.2-0.6
          l0,0c-31.1,0-56.3-25.1-56.4-56.2c0-14.4,5.5-28.3,15.4-38.7C282,552,271.9,534.5,271.9,515.7z"
            />
          </g>
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)">
          {!quantitative && (
            <>
              <path
                d="m0 0c.881 0 1.592-.717 1.592-1.598v-52.623c0-.895-.711-1.601-1.592-1.601h-21.297c-.885 0-1.6.706-1.6 1.601v52.623c0 .881.715 1.598 1.6 1.598z"
                transform="translate(311.3463 241.3572)"
              />
              <path
                d="m0 0h-350.934c-.877 0-1.606-.755-1.606-1.649v-21.45c0-.872.729-1.579 1.606-1.579h350.934c.864 0 1.609.707 1.609 1.579v21.45c0 .894-.745 1.649-1.609 1.649"
                transform="translate(545.2074 162.9409)"
              />
              <path
                d="m0 0h-350.934c-.877 0-1.606-.706-1.606-1.579v-21.515c0-.86.729-1.584 1.606-1.584h350.934c.864 0 1.609.724 1.609 1.584v21.515c0 .873-.745 1.579-1.609 1.579"
                transform="translate(545.2074 120.3085)"
              />
              <path
                d="m0 0c-4.386 3.43-16.087 11.437-30.357 11.437-10.201 0-19.692-4.019-28.182-11.974-.601-.571-.938-1.36-.938-2.202v-1.912c0-.941.311-1.82.999-2.399.764-.577 1.562-.794 2.474-.577.202.029.452.092.658.169.649.226 1.258.616 1.754 1.112 1.841 1.237 6.868 2.925 14.056 2.925 7.433 0 22.042-1.991 36.159-15.155l.324-.289c.794-.818 1.89-1.27 3.053-1.27 1.105 0 2.249.461 2.969 1.242l.285.293c14.196 13.188 28.778 15.179 36.212 15.179 7.24 0 12.244-1.688 14.09-2.925.505-.496 1.123-.895 1.939-1.189.311-.092 1.206-.273 2.057-.063 1.298.366 2.21 1.534 2.21 2.892v1.693c0 .802-.347 1.611-.943 2.171-8.569 8.168-18.16 12.297-28.523 12.297-14.14 0-25.788-7.883-30.296-11.455"
                transform="translate(478.4284 299.6088)"
              />
              <path
                d="m0 0c-.746-.346-1.286-1.028-1.531-1.849l-.355-1.17c-.263-.921-.097-1.893.46-2.636.544-.713 1.316-1.142 2.171-1.182.162-.02.32-.059.438-.02.611.02 1.158.151 1.698.435.311.063.96.236 2.127.236 1.57 0 15.718-.475 25.072-16.375l.118-.226c.51-.921 1.303-1.555 2.246-1.799.272-.088.794-.173 1.118-.173.649 0 1.303.173 1.768.438l.232.113c5.118 2.558 10.421 3.872 15.656 3.872 8.864 0 14.653-3.616 16.004-5.122.276-.512.697-.956 1.175-1.309.298-.172.824-.437 1.14-.549.158-.04.342-.061.518-.074.096-.02.21-.02.316-.02.477 0 .938.118 1.39.349.719.361 1.259 1.017 1.491 1.798l.294 1.035c.088.263.123.55.123.853 0 .548-.141 1.079-.408 1.506-6.816 11.835-16.705 14.308-23.805 14.308-5.285 0-9.908-1.37-12.631-2.37-3.214 4.324-11.341 13.262-23.668 13.262-4.334 0-8.75-1.114-13.157-3.331"
                transform="translate(456.6498 439.4759)"
              />
              <path
                d="m0 0 .101-1.579c.048-.986.565-1.84 1.403-2.363.693-.437 1.579-.588 2.359-.358.172.039.365.103.514.16.605.248 1.118.633 1.517 1.121 1.491 1.076 6.297 3.039 13.385 3.039 6.815 0 17.182-1.82 27.747-10.497l.246-.252c.754-.652 1.719-1.02 2.706-1.02h.259c1.105.086 2.127.594 2.754 1.324l.237.266c11.696 12.378 24.295 14.218 30.765 14.218 4.608 0 7.876-.952 9.148-1.671.482-.416 1.078-.745 1.824-.947.21-.05.728-.143 1.285-.084.228.024.513.103.737.176 1.254.439 2.078 1.662 1.991 3.017l-.079 1.372c-.052.819-.434 1.553-1.057 2.088-6.981 5.872-14.516 8.833-22.445 8.833-12.345 0-22.192-7.289-26.27-10.863-3.733 2.541-12.789 7.771-23.415 7.771-9.337 0-17.708-3.879-24.897-11.505-.566-.603-.85-1.424-.815-2.246"
                transform="translate(382.4982 385.485)"
              />
              <path
                d="m0 0c0 21.015 17.038 38.045 38.045 38.045.824 0 1.627-.073 2.439-.118 2.004 26.593 24.164 47.568 51.275 47.568 28.433 0 51.483-23.044 51.483-51.476 0-8.054-1.908-15.644-5.206-22.433 25.765-5.707 45.049-28.651 45.049-56.121 0-31.77-25.757-57.527-57.525-57.527-2.321 0-76.77.448-76.77.448-22.503.005-40.738 18.231-40.738 40.731 0 10.808 4.237 20.595 11.104 27.888-11.433 6.563-19.156 18.863-19.156 32.995"
                transform="translate(204.9082 357.3121)"
              />
            </>
          )}
          <path
            d="m0 0v-25.572h.21l17.192 17.836h.219v-111.539h24.498v145.715h-19.56z"
            transform="translate(58.4865 643.059)"
          />
          <path
            d="m0 0c-9.666 0-16.753-3.43-20.63-10.096h-.219v36.322h42.128v19.981h-64.468v-82.103h22.34v3.237c0 8.586 3.868 13.319 10.745 13.319 7.526 0 10.542-5.162 10.542-13.113v-35.248c0-7.727-2.798-13.104-10.323-13.104-8.377 0-11.376 5.588-11.376 14.184v18.266h-22.367v-16.556c0-22.13 8.815-36.313 33.743-36.313 24.717 0 34.813 13.113 34.813 33.313v35.677c0 22.998-11.815 32.234-24.928 32.234"
            transform="translate(158.8461 623.2845)"
          />
          <path
            d="m0 0-11.668-61.313h-11.213l-11.668 61.313h10.491l7.054-42.773h.092l7.235 42.773z"
            transform="translate(276.8109 669.145)"
          />
          <path d="m281.076 669.145h10.31v-61.313h-10.31z" />
          <path
            d="m0 0h24.598v-8.409h-14.288v-17.541h10.217v-8.326h-10.217v-18.629h14.288v-8.408h-24.598z"
            transform="translate(297.3611 669.145)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.501v-52.905h-10.402v52.905h-8.5z"
            transform="translate(242.6246 583.1919)"
          />
          <path
            d="m0 0h24.598v-8.408h-14.288v-17.542h10.218v-8.326h-10.218v-18.629h14.288v-8.408h-24.598z"
            transform="translate(274.8329 583.1919)"
          />
          <path
            d="m0 0v-19.081h3.434c3.53 0 5.066 1.806 5.066 5.063v9.044c0 3.346-1.536 4.974-5.066 4.974zm0-24.78v-28.125h-10.31v61.313h15.013c10.399 0 14.196-5.151 14.196-13.745v-7.867c0-6.602-2.35-10.488-8.23-11.849l9.858-27.852h-10.85z"
            transform="translate(315.2717 574.7837)"
          />
          <path
            d="m0 0v-19.081h3.435c3.527 0 5.066 1.806 5.066 5.063v9.044c0 3.346-1.539 4.974-5.066 4.974zm0-24.78v-28.125h-10.31v61.313h15.014c10.399 0 14.196-5.151 14.196-13.745v-7.867c0-6.602-2.351-10.488-8.23-11.849l9.858-27.852h-10.85z"
            transform="translate(350.1035 574.7837)"
          />
          <path
            d="m0 0h24.599v-8.408h-14.288v-17.542h10.217v-8.326h-10.217v-18.629h14.288v-8.408h-24.599z"
            transform="translate(374.6253 583.1919)"
          />
          <path
            d="m0 0v8.23h9.588v-8.414c0-3.435 1.536-5.426 5.063-5.426 3.256 0 4.703 2.175 4.703 5.426v2.353c0 3.53-1.447 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.59 9.311-8.59 16.365v2.08c0 7.6 4.43 13.477 14.47 13.477 10.31 0 14.378-5.063 14.378-13.929v-4.974h-9.404v5.337c0 3.529-1.629 5.247-4.885 5.247-2.894 0-4.882-1.628-4.882-5.063v-1.266c0-3.44 1.899-5.431 4.882-8.319l6.602-6.513c5.606-5.698 8.319-9.133 8.319-15.92v-2.983c0-8.408-4.522-14.38-15.01-14.38-10.491 0-14.562 5.876-14.562 13.929"
            transform="translate(403.7589 535.0829)"
          />
          <path
            d="m0 0h27.403v-8.408h-8.501v-52.905h-10.401v52.905h-8.501z"
            transform="translate(436.2409 583.1919)"
          />
          <path
            d="m0 0v-19.081h3.435c3.53 0 5.066 1.806 5.066 5.063v9.044c0 3.346-1.536 4.974-5.066 4.974zm0-24.78v-28.125h-10.31v61.313h15.014c10.399 0 14.196-5.151 14.196-13.745v-7.867c0-6.602-2.351-10.488-8.231-11.849l9.859-27.852h-10.851z"
            transform="translate(478.756 574.7837)"
          />
          <path
            d="m0 0h24.598v-8.408h-14.288v-17.542h10.217v-8.326h-10.217v-18.629h14.288v-8.408h-24.598z"
            transform="translate(503.2817 583.1919)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg16 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon points="77.2,120.6 77.2,156 77.5,156 101.3,131.3 101.6,131.3 101.6,285.6 135.5,285.6 135.5,84 108.5,84 " />
        <path
          d="M254.1,237.1v-29.7c0-33-13.1-49.7-37.5-49.7c-14.3,0-22.9,6.5-27.9,16.4h-0.3v-43.4c0-12.2,3.9-20.8,16.1-20.8
        s15.8,7.1,15.8,19.6v13.4h30.9v-10.7c0-29.7-9.8-50.5-47.3-50.5c-35.7,0-49.1,22.9-49.1,54.4v98.1c0,31.2,13.7,53.8,49.4,53.8
        C240.2,288,254.2,268.4,254.1,237.1 M220.6,240.1c0,12.8-4.8,20.2-16.4,20.2c-11.3,0-15.8-7.7-15.8-20.2v-36.9
        c0.6-11.3,5.3-18.4,16.1-18.4c11.6,0,16.1,7.1,16.1,20.2V240.1z"
        />
        {!quantitative && (
          <g>
            <path
              d="M646.1,491c0,0-8.4,11.2-6,22.1c2.4,10.9,14.9,17.4,14.9,17.4s8.4-11.2,6-22.1
          C658.6,497.5,646.1,491,646.1,491"
            />
            <path d="M632.4,554.8c0,0,8.4-11.2,6-22.1s-14.9-17.4-14.9-17.4s-8.4,11.2-6,22.1S632.4,554.8,632.4,554.8" />
            <path d="M667,542.9c0,0,8.9,9,19,8.1s17.6-11.3,17.6-11.3s-8.9-9-19-8.1S667,542.9,667,542.9" />
            <path d="M681.6,495c-8.2,8.4-7.1,23.1-7.1,23.1s14.5,1.3,22.8-7.1c8.2-8.3,7.1-23.1,7.1-23.1S689.8,486.7,681.6,495" />
            <path d="M663.4,576.1c10.1,1.2,19.6-7.5,19.6-7.5s-6.9-10.6-17-11.8s-19.6,7.5-19.6,7.5S653.3,574.9,663.4,576.1" />
            <path
              d="M672.4,751.2H597c-5.9,0-10.7,4.8-10.7,10.7c0,5.9,4.8,10.7,10.7,10.7h75.4c5.9,0,10.7-4.8,10.7-10.7
          C683.1,756,678.3,751.2,672.4,751.2"
            />
            <path
              d="M672.4,868.7H597c-5.9,0-10.7,4.8-10.7,10.7c0,5.9,4.8,10.7,10.7,10.7h75.4c5.9,0,10.7-4.8,10.7-10.7
          C683.1,873.5,678.3,868.7,672.4,868.7"
            />
            <path d="M333.5,725.3c-1.7-0.5-3.5-1-5.2-1.3C328.3,724,330.2,724.6,333.5,725.3" />
            <path
              d="M669.6,780h-69.8c-3.3,0-6.1,2.7-6.1,6.1v21.2l-45.6,5l-66.6-1.5V770c9-1.1,17.8-2.9,26.5-5.4
          c64.1-18.1,78.1-71.1,76.7-107.8c-1.4-37.3,10.6-51.8,27.7-58.3c4.6-1.7,9.4-3,14.2-3.8c0.2,9.2,2,19.8,6.2,32.5
          c1.5-0.1,3-0.2,4.5-0.4c-4.3-13-6.2-23.7-6.3-32.8c5-0.6,10.1-0.8,15.2-0.5c-5.1-3-10-6.4-14.5-10.3c2.9-17.7,13.4-28.5,24.3-39.7
          c6-6.1,12.1-12.4,17-19.9l-3.8-2.4c-4.6,7.1-10.6,13.3-16.4,19.2c-10.6,10.8-21.3,21.9-24.9,39.5c-3.9-3.5-7.5-7.2-11-11.1
          c-15.8-17.7-36.2-4.7-65.2,22.3s-65.5,27.9-101.2-8.5c-47-48.2-88.1-47.9-116.2-45.2c19.2,8.2,26,26.2,35.7,71.9
          c10.2,48,36,69.7,71.2,72.7c-19.6,6.9-20.6,18-46.8,36.1c-20.5,14.1-49.4,9.7-61,7c21.5,6.7,46.9,29.2,69.6,37
          c13.4,4.6,27.4,7.4,41.5,8.5v38.9L325.4,807v27.2l222.8-5.1l45.6,5v21.1c0,3.4,2.7,6.1,6.1,6.1h69.8c3.4,0,6.1-2.7,6.1-6.1v-69.2
          C675.7,782.7,673,780,669.6,780z M455.6,771.5c5,0.1,10-0.1,14.9-0.4v39.4l-14.9-0.3V771.5z"
            />
            <path
              d="M318.8,829.8c0,5.7-4,10.4-8.9,10.4h-5.4c-4.9,0-8.9-4.6-8.9-10.4V811c0-5.7,4-10.4,8.9-10.4h5.4
          c4.9,0,8.9,4.6,8.9,10.4V829.8z"
            />
          </g>
        )}
        <g>
          <path
            d="M319.4,83.9h20.4c13.9,0,18.9,6.9,18.9,18.3v17.2c0,11.4-5.1,18.4-18.9,18.4h-6.6v27.7h-13.7V83.9z
           M333.1,95.1v32.2h5.1c4.7,0,6.8-2.3,6.8-6.8v-18.8c0-4.5-2-6.6-6.8-6.6H333.1z"
          />
          <path d="M364.7,83.9h32.8v11.2h-19.1v23.4h13.6v11.1h-13.6v24.8h19v11.2h-32.8V83.9z" />
          <path
            d="M402.8,165.6l15.4-81.7h15.7l15.5,81.7h-14.1l-2.5-15h-14.6l-2.4,15H402.8z M420,139.7h11l-5.4-32.8h-0.1
          L420,139.7z"
          />
          <path
            d="M454,144.5V105c0-12.8,6-22.1,20.5-22.1c15.2,0,19.4,8.4,19.4,20.5v9.6h-12.5v-10.7c0-5.1-1.7-8-6.6-8
          s-7,3.5-7,8.4v43.9c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-8v-15h12.5v14.1c0,11.7-4.8,20.4-19.4,20.4S454,157.2,454,144.5z"
          />
          <path d="M501.4,83.9h32.8v11.2h-19v23.4h13.6v11.1h-13.7v24.8h19v11.2h-32.7V83.9z" />
          <path d="M556.2,153.5l-7,18.4h-7.7l1.7-19.5h13L556.2,153.5z" />
          <path
            d="M614.4,83.9V147c0,11.8-5.2,19.5-18.9,19.5c-14.2,0-18.1-7.8-18.1-18.2v-16.2h13v16.5c0,4.1,1.5,6.5,5.1,6.5
          s5.2-2.4,5.2-6.6V83.9H614.4z"
          />
          <path
            d="M662.7,83.9v61.8c0,12.6-5.4,20.9-19.4,20.9c-14.5,0-20.5-8.2-20.5-20.9V83.9h13.7V147c0,4.8,1.9,8.1,6.8,8.1
          s6.8-3.2,6.8-8.1V83.9H662.7z"
          />
          <path
            d="M670.4,148v-11h12.8v11.2c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2v-3.1c0-4.7-1.9-7.6-6.2-11.6l-8.1-8.1
          c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.7,0,19.2,6.8,19.2,18.6v6.6h-12.5v-7c0-4.7-2.2-7-6.5-7
          c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4c0,11.2-6,19.2-20,19.2
          S670.4,158.7,670.4,148z"
          />
          <path d="M716,83.9h36.5v11.2h-11.3v70.5h-13.9V95.1H716V83.9z" />
          <path d="M759.6,83.9h13.7v81.7h-13.7V83.9z" />
          <path
            d="M781.8,144.5V105c0-12.8,6-22.1,20.5-22.1c15.2,0,19.4,8.4,19.4,20.5v9.6h-12.5v-10.7c0-5.1-1.7-8-6.6-8
          s-7,3.5-7,8.4v43.9c0,4.9,2,8.4,7,8.4s6.6-3.1,6.6-8v-15h12.5v14.1c0,11.7-4.8,20.4-19.4,20.4S781.8,157.2,781.8,144.5z"
          />
          <path d="M829.8,83.9h32.8v11.2h-19v23.4h13.6v11.1h-13.6v24.8h19v11.2h-32.8V83.9z" />
        </g>
        <g>
          <path
            d="M317.7,285.5l15.4-81.7h15.7l15.5,81.7h-14.1l-2.5-14.9h-14.6l-2.4,14.9H317.7z M334.9,259.5h11l-5.4-32.8
          h-0.1L334.9,259.5z"
          />
          <path d="M382.8,234.1v51.3h-11.6v-81.7h13.5l14.8,46.9v-46.9H411v81.7h-12.1L382.8,234.1z" />
          <path
            d="M461.1,225.7v37.9c0,12.5-5.2,21.9-19.9,21.9H420v-81.7h21.2C456,203.7,461.1,213,461.1,225.7z M439.6,274.2
          c5.7,0,7.8-3.4,7.8-8.3v-42.8c0-4.8-2.2-8.2-7.8-8.2h-5.8v59.3H439.6z"
          />
          <path
            d="M483.3,267.9v-11h12.8v11.2c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2V265c0-4.7-1.9-7.6-6.1-11.6l-8.1-8.1
          c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.7,0,19.2,6.8,19.2,18.6v6.7h-12.5v-7.1c0-4.7-2.2-7-6.5-7
          c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4c0,11.2-6,19.2-20,19.2
          S483.3,278.6,483.3,267.9z"
          />
          <path d="M527.8,203.7h36.5V215H553v70.5h-13.9V215h-11.3V203.7z" />
          <path
            d="M585.6,248v37.5h-13.7v-81.7h20c13.9,0,18.9,6.9,18.9,18.3v10.5c0,8.8-3.1,14-11,15.8l13.2,37.1h-14.5
          L585.6,248z M585.6,215v25.4h4.6c4.7,0,6.7-2.4,6.7-6.7v-12.1c0-4.5-2-6.6-6.7-6.6L585.6,215z"
          />
          <path
            d="M619.5,264.4v-39.5c0-12.8,6.3-22.1,20.7-22.1s20.8,9.3,20.8,22.1v39.5c0,12.7-6.3,22.1-20.8,22.1
          S619.5,277,619.5,264.4z M647.3,266.5v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9c0,4.9,2.2,8.4,7,8.4S647.3,271.5,647.3,266.5
          z"
          />
          <path d="M681.7,234.1v51.3h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12L681.7,234.1z" />
          <path
            d="M739.7,241.8h19.5v43.6h-9.9v-8.9c-1.8,6.1-5.7,9.9-13.1,9.9c-11.8,0-17.2-9.4-17.2-22.1v-39.5
          c0-12.8,6.2-22.1,20.6-22.1c15.2,0,19.7,8.4,19.7,20.5v7.2h-12.5v-8.3c0-5.1-1.9-8-6.9-8s-7.1,3.5-7.1,8.4v43.9
          c0,4.9,2,8.4,6.8,8.4c4.5,0,6.8-2.5,6.8-7.8v-14.4h-6.5V241.8z"
          />
          <path d="M320,324.9h13.7v81.7H320V324.9z" />
          <path d="M354.5,355.3v51.4h-11.6v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12.1L354.5,355.3z" />
          <path
            d="M391,389v-11h12.8v11.2c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2v-3.1c0-4.7-1.9-7.6-6.1-11.6l-8.1-8.1
          c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.7,0,19.2,6.8,19.2,18.6v6.6H417v-7c0-4.7-2.2-7-6.5-7
          c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4c0,11.2-6,19.2-20,19.2
          S391,399.7,391,389z"
          />
          <path d="M435.5,324.9H472v11.2h-11.4v70.5h-13.9v-70.5h-11.3V324.9z" />
          <path d="M479.6,324.9h13.7v81.7h-13.7V324.9z" />
          <path d="M500.9,324.9h36.5v11.2h-11.3v70.5h-13.9v-70.5h-11.3V324.9z" />
          <path
            d="M584.9,324.9v61.8c0,12.6-5.4,20.9-19.4,20.9c-14.5,0-20.5-8.2-20.5-20.9v-61.8h13.7V388
          c0,4.8,1.9,8.1,6.8,8.1s6.8-3.2,6.8-8.1v-63.1H584.9z"
          />
          <path d="M592.4,324.9h36.5v11.2h-11.3v70.5h-13.9v-70.5h-11.3V324.9z" />
          <path d="M636.5,324.9h13.7v81.7h-13.7V324.9z" />
          <path
            d="M659.4,385.5V346c0-12.8,6.3-22.1,20.7-22.1S701,333.2,701,346v39.5c0,12.7-6.3,22.1-20.8,22.1
          S659.4,398.2,659.4,385.5z M687.2,387.7v-43.9c0-4.9-2.2-8.4-7.1-8.4s-7,3.5-7,8.4v43.9c0,4.9,2.2,8.4,7,8.4
          S687.2,392.6,687.2,387.7L687.2,387.7z"
          />
          <path d="M721.6,355.3v51.4H710v-81.7h13.5l14.8,46.9v-46.9h11.5v81.7h-12.1L721.6,355.3z" />
          <path
            d="M758.1,389v-11h12.8v11.2c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2v-3.1c0-4.7-1.9-7.6-6.2-11.6l-8.1-8.1
          c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.7,0,19.2,6.8,19.2,18.6v6.6h-12.5v-7c0-4.7-2.2-7-6.5-7
          c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4c0,11.2-6,19.2-20,19.2
          S758.1,399.7,758.1,389z"
          />
        </g>
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)" fill="currentColor">
          {!quantitative && (
            <>
              <path
                d="m0 0s-6.589-8.752-4.674-17.276c1.93-8.529 11.651-13.602 11.651-13.602s6.592 8.752 4.67 17.276c-1.922 8.533-11.647 13.602-11.647 13.602"
                transform="translate(479.2921 389.6379)"
              />
              <path
                d="m0 0s6.592 8.757 4.67 17.284c-1.929 8.532-11.647 13.592-11.647 13.592s-6.595-8.743-4.68-17.274c1.933-8.524 11.657-13.602 11.657-13.602"
                transform="translate(468.5542 339.663)"
              />
              <path
                d="m0 0s6.959-7.019 14.884-6.313c7.923.702 13.797 8.858 13.797 8.858s-6.949 7.018-14.88 6.316c-7.924-.706-13.801-8.861-13.801-8.861"
                transform="translate(495.6367 349.0355)"
              />
              <path
                d="m0 0c-6.446-6.543-5.537-18.119-5.537-18.119s11.365-.985 17.825 5.549c6.447 6.537 5.538 18.114 5.538 18.114s-11.373.985-17.826-5.544"
                transform="translate(507.0371 386.5225)"
              />
              <path
                d="m0 0c7.896-.935 15.321 5.846 15.321 5.846s-5.378 8.292-13.268 9.225c-7.903.928-15.327-5.853-15.327-5.853s5.377-8.287 13.274-9.218"
                transform="translate(492.8125 323.0204)"
              />
              <path
                d="m0 0h-59.021c-4.618 0-8.362-3.727-8.362-8.344 0-4.611 3.744-8.354 8.362-8.354h59.021c4.611 0 8.347 3.743 8.347 8.354 0 4.617-3.736 8.344-8.347 8.344"
                transform="translate(499.8654 196.0781)"
              />
              <path
                d="m0 0h-59.021c-4.618 0-8.362-3.73-8.362-8.347 0-4.608 3.744-8.351 8.362-8.351h59.021c4.611 0 8.347 3.743 8.347 8.351 0 4.617-3.736 8.347-8.347 8.347"
                transform="translate(499.8654 104.0413)"
              />
              <path
                d="m0 0c-1.388.43-2.762.806-4.097 1.056 0 0 1.513-.47 4.097-1.056"
                transform="translate(234.425 216.3481)"
              />
              <path
                d="m0 0c3.889-.066 7.793.05 11.703.316v-30.836l-11.703.267zm167.607-6.674h-54.692c-2.623 0-4.752-2.133-4.752-4.751v-16.563l-35.704-3.924-52.159 1.193v31.86c6.928.887 13.867 2.267 20.754 4.211 50.209 14.167 61.158 45.44 60.065 74.161-1.092 29.251 8.268 40.61 21.72 45.662 3.85 1.446 7.659 2.361 11.147 2.954.149-7.186 1.606-15.537 4.819-25.49 1.192.066 2.379.167 3.559.295-3.393 10.181-4.84 18.555-4.92 25.696 6.949.821 11.908.357 11.908.357s-4.698 2.523-11.332 8.071c2.256 13.851 10.506 22.356 19.009 31.052 4.673 4.79 9.503 9.732 13.305 15.623l-2.963 1.911c-3.597-5.597-8.323-10.408-12.871-15.067-8.292-8.483-16.66-17.151-19.495-30.902-2.696 2.432-5.61 5.308-8.594 8.656-12.382 13.881-28.32 3.684-51.048-17.479-22.742-21.151-51.333-21.876-79.263 6.698-36.844 37.721-68.985 37.506-91.026 35.366 15.078-6.423 20.352-20.512 27.984-56.323 7.997-37.575 28.168-54.575 55.76-56.923-12.791-2.071-16.108-3.845-36.668-18.048-16.06-11.079-38.649-7.577-47.808-5.497 16.813-5.24 36.727-22.877 54.546-29.014 10.373-3.57 21.312-5.779 32.515-6.667v-30.499l-98.939 2.133v-21.278l179.995 3.993 35.704-3.93v-16.549c0-2.62 2.129-4.761 4.752-4.761h54.692c2.627 0 4.76 2.141 4.76 4.761v54.261c0 2.618-2.133 4.751-4.76 4.751"
                transform="translate(330.0831 180.2227)"
              />
              <path
                d="m0 0c0-4.486-3.13-8.125-6.988-8.125h-4.204c-3.851 0-6.991 3.639-6.991 8.125v14.707c0 4.493 3.14 8.125 6.991 8.125h4.204c3.858 0 6.988-3.632 6.988-8.125z"
                transform="translate(217.4399 134.5408)"
              />
            </>
          )}
          <path
            d="m0 0v-25.572h.219l17.192 17.836h.219v-111.539h24.498v145.716h-19.551z"
            transform="translate(62.7503 642.9362)"
          />
          <path
            d="m0 0c0-9.241-3.439-14.613-11.815-14.613-8.166 0-11.385 5.583-11.385 14.613v26.646c.421 8.167 3.859 13.328 11.604 13.328 8.368 0 11.596-5.161 11.596-14.617zm24.287 2.145v21.493c0 23.854-9.455 35.897-27.076 35.897-10.324 0-16.552-4.729-20.2-11.824h-.211v31.379c0 8.815 2.781 15.047 11.604 15.047 8.807 0 11.386-5.158 11.386-14.179v-9.688h22.348v7.745c0 21.493-7.087 36.532-34.172 36.532-25.787 0-35.462-16.547-35.462-39.33v-70.919c0-22.564 9.894-38.9 35.681-38.9 25.998 0 36.102 14.183 36.102 36.747"
            transform="translate(166.3469 556.5403)"
          />
          <path
            d="m0 0v-24.143h3.803c3.524 0 5.063 1.717 5.063 5.063v14.107c0 3.345-1.539 4.973-5.063 4.973zm-10.311 8.409h15.284c10.406 0 14.203-5.153 14.203-13.745v-12.93c0-8.593-3.797-13.84-14.203-13.84h-4.973v-20.798h-10.311z"
            transform="translate(252.5468 660.7384)"
          />
          <path
            d="m0 0h8.23l-4.071 24.601h-.088zm-12.931-19.444 11.576 61.314h11.753l11.666-61.314h-10.578l-1.902 11.214h-10.939l-1.813-11.214z"
            transform="translate(284.7552 627.2776)"
          />
          <path d="m311.086 669.147h10.31v-61.313h-10.31z" />
          <path
            d="m0 0-9.044 28.844h10.761l5.699-20.258 5.877 20.258h9.769l-9.044-29.303 10.037-32.011h-10.762l-6.78 23.241-6.513-23.241h-9.769z"
            transform="translate(335.8725 640.3035)"
          />
          <path
            d="m0 0-5.247-13.84h-5.788l1.266 14.654h9.769z"
            transform="translate(375.1409 616.8784)"
          />
          <path
            d="m0 0v-47.384c0-8.867-3.893-14.654-14.203-14.654-10.666 0-13.56 5.876-13.56 13.655v12.212h9.763v-12.39c0-3.078 1.088-4.885 3.797-4.885 2.805 0 3.892 1.807 3.892 4.974v48.472z"
            transform="translate(417.9205 669.1473)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.559-15.646-10.857 0-15.379 6.15-15.379 15.646v46.392h10.31v-47.384c0-3.619 1.45-6.062 5.069-6.062 3.613 0 5.063 2.443 5.063 6.062v47.384z"
            transform="translate(453.6588 669.1473)"
          />
          <path
            d="m0 0v8.23h9.585v-8.414c0-3.435 1.54-5.426 5.069-5.426 3.251 0 4.7 2.176 4.7 5.426v2.353c0 3.53-1.449 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.312-8.593 16.365v2.08c0 7.6 4.433 13.478 14.47 13.478 10.31 0 14.381-5.064 14.381-13.93v-4.973h-9.407v5.336c0 3.53-1.628 5.247-4.879 5.247-2.894 0-4.885-1.628-4.885-5.062v-1.266c0-3.441 1.896-5.432 4.885-8.32l6.602-6.513c5.604-5.698 8.32-9.133 8.32-15.919v-2.983c0-8.408-4.523-14.381-15.017-14.381-10.489 0-14.559 5.877-14.559 13.929"
            transform="translate(459.0073 621.0376)"
          />
          <path
            d="m0 0h27.4v-8.409h-8.504v-52.904h-10.399v52.904h-8.497z"
            transform="translate(491.4898 669.1473)"
          />
          <path d="m523.698 669.147h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v29.664c0 9.586 4.522 16.55 15.379 16.55 11.391 0 14.558-6.329 14.558-15.373v-7.238h-9.406v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.247-2.621-5.247-6.328v-32.921c0-3.708 1.539-6.329 5.247-6.329s4.974 2.353 4.974 5.966v11.309h9.406v-10.584c0-8.77-3.618-15.283-14.558-15.283-10.857 0-15.379 7.053-15.379 16.549"
            transform="translate(539.9806 623.6584)"
          />
          <path
            d="m0 0h24.602v-8.409h-14.292v-17.541h10.221v-8.326h-10.221v-18.629h14.292v-8.408h-24.602z"
            transform="translate(575.5405 669.1473)"
          />
          <path
            d="m0 0h24.602v-8.408h-14.291v-17.542h10.22v-8.326h-10.22v-18.629h14.291v-8.408h-24.602z"
            transform="translate(242.2362 583.1942)"
          />
          <path
            d="m0 0h27.4v-8.408h-8.503v-52.905h-10.4v52.905h-8.497z"
            transform="translate(271.1946 583.1942)"
          />
          <path d="m318.9 583.194h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.132l11.125-35.179v35.179h8.592v-61.314h-9.044z"
            transform="translate(343.8694 560.4055)"
          />
          <path
            d="m0 0v8.23h9.584v-8.414c0-3.435 1.54-5.426 5.07-5.426 3.25 0 4.7 2.175 4.7 5.426v2.353c0 3.53-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.311-8.593 16.365v2.08c0 7.6 4.433 13.477 14.469 13.477 10.31 0 14.381-5.063 14.381-13.929v-4.974h-9.407v5.337c0 3.529-1.628 5.247-4.878 5.247-2.894 0-4.885-1.628-4.885-5.063v-1.266c0-3.441 1.896-5.431 4.885-8.319l6.602-6.513c5.603-5.698 8.319-9.133 8.319-15.92v-2.983c0-8.408-4.522-14.38-15.017-14.38-10.487 0-14.558 5.876-14.558 13.929"
            transform="translate(370.3796 535.0852)"
          />
          <path
            d="m0 0h27.4v-8.408h-8.504v-52.905h-10.399v52.905h-8.497z"
            transform="translate(402.8615 583.1942)"
          />
          <path d="m435.07 583.194h10.31v-61.313h-10.31z" />
          <path
            d="m0 0h27.4v-8.408h-8.504v-52.905h-10.399v52.905h-8.497z"
            transform="translate(450.1819 583.1942)"
          />
          <path
            d="m0 0v-46.392c0-9.496-4.071-15.646-14.559-15.646-10.856 0-15.379 6.15-15.379 15.646v46.392h10.31v-47.384c0-3.619 1.45-6.062 5.069-6.062 3.613 0 5.063 2.443 5.063 6.062v47.384z"
            transform="translate(512.3217 583.1942)"
          />
          <path
            d="m0 0h27.4v-8.408h-8.503v-52.905h-10.4v52.905h-8.497z"
            transform="translate(517.0475 583.1942)"
          />
          <path d="m549.249 583.194h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.329-5.336 6.329-3.619 0-5.247-2.621-5.247-6.329v-32.921c0-3.708 1.628-6.329 5.247-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.893 1.628v29.665c0 9.585 4.706 16.549 15.557 16.549 10.946 0 15.646-6.964 15.646-16.549v-29.665c0-9.496-4.7-16.549-15.646-16.549-10.851 0-15.557 7.053-15.557 16.549"
            transform="translate(586.4317 536.0771)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.132l11.124-35.179v35.179h8.593v-61.314h-9.045z"
            transform="translate(611.3131 560.4055)"
          />
          <path
            d="m0 0v8.23h9.585v-8.414c0-3.435 1.539-5.426 5.069-5.426 3.251 0 4.701 2.175 4.701 5.426v2.353c0 3.53-1.45 5.699-4.612 8.682l-6.061 6.061c-5.877 5.788-8.593 9.311-8.593 16.365v2.08c0 7.6 4.434 13.477 14.47 13.477 10.31 0 14.381-5.063 14.381-13.929v-4.974h-9.407v5.337c0 3.529-1.628 5.247-4.879 5.247-2.893 0-4.885-1.628-4.885-5.063v-1.266c0-3.441 1.896-5.431 4.885-8.319l6.602-6.513c5.604-5.698 8.319-9.133 8.319-15.92v-2.983c0-8.408-4.522-14.38-15.016-14.38-10.488 0-14.559 5.876-14.559 13.929"
            transform="translate(637.8226 535.0852)"
          />
          <path
            d="m0 0h24.602v-8.408h-14.291v-17.541h10.22v-8.327h-10.22v-18.628h14.291v-8.409h-24.602z"
            transform="translate(242.2362 497.2411)"
          />
          <path
            d="m0 0h24.15v-8.408h-13.84v-17.541h10.31v-8.327h-10.31v-27.037h-10.31z"
            transform="translate(272.365 497.2411)"
          />
          <path
            d="m0 0h24.15v-8.408h-13.84v-17.541h10.31v-8.327h-10.31v-27.037h-10.31z"
            transform="translate(301.0499 497.2411)"
          />
          <path d="m329.728 497.241h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v29.664c0 9.585 4.523 16.55 15.379 16.55 11.392 0 14.559-6.329 14.559-15.373v-7.238h-9.407v8.052c0 3.797-1.266 5.966-4.974 5.966-3.707 0-5.247-2.621-5.247-6.329v-32.92c0-3.709 1.54-6.329 5.247-6.329 3.708 0 4.974 2.353 4.974 5.966v11.308h9.407v-10.583c0-8.771-3.619-15.284-14.559-15.284-10.856 0-15.379 7.054-15.379 16.55"
            transform="translate(346.0171 451.7529)"
          />
          <path
            d="m0 0h8.23l-4.071 24.602h-.089zm-12.931-19.443 11.576 61.313h11.753l11.666-61.313h-10.578l-1.902 11.213h-10.939l-1.813-11.213z"
            transform="translate(391.9769 455.3715)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.379 16.55 11.391 0 14.558-6.329 14.558-15.373v-7.238h-9.406v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.247-2.621-5.247-6.329v-32.92c0-3.709 1.539-6.329 5.247-6.329s4.974 2.353 4.974 5.966v11.308h9.406v-10.583c0-8.771-3.618-15.284-14.558-15.284-10.857 0-15.379 7.054-15.379 16.55"
            transform="translate(416.9409 451.7529)"
          />
          <path
            d="m0 0h24.602v-8.408h-14.292v-17.541h10.221v-8.327h-10.221v-18.628h14.292v-8.409h-24.602z"
            transform="translate(452.5008 497.2411)"
          />
          <path
            d="m0 0v8.23h9.585v-8.414c0-3.435 1.539-5.426 5.069-5.426 3.25 0 4.7 2.176 4.7 5.426v2.353c0 3.53-1.45 5.699-4.611 8.681l-6.061 6.062c-5.877 5.788-8.593 9.312-8.593 16.365v2.08c0 7.6 4.433 13.478 14.469 13.478 10.31 0 14.381-5.064 14.381-13.93v-4.974h-9.407v5.337c0 3.529-1.628 5.247-4.878 5.247-2.894 0-4.885-1.628-4.885-5.063v-1.266c0-3.44 1.896-5.431 4.885-8.319l6.602-6.513c5.603-5.698 8.319-9.133 8.319-15.919v-2.984c0-8.408-4.522-14.38-15.017-14.38-10.487 0-14.558 5.877-14.558 13.929"
            transform="translate(481.6377 449.1321)"
          />
        </g>
      </g>
    </svg>
  )
}

export const Sdg17 = ({ lang, quantitative }) => {
  if (lang == "en") {
    return (
      <svg
        height="983.03998"
        viewBox="0 0 983.03998 983.03998"
        width="983.03998"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M319.1,83.7h20.4c13.9,0,18.9,6.9,18.9,18.3v17.2c0,11.5-5.1,18.5-18.9,18.5h-6.6v27.7h-13.8V83.7z M332.9,94.9
        v32.2h5c4.7,0,6.7-2.3,6.7-6.8v-18.8c0-4.4-2-6.6-6.7-6.6H332.9z"
        />
        <path
          d="M360.1,165.5l15.4-81.8h15.7l15.5,81.8h-14.1l-2.5-15h-14.6l-2.4,15H360.1z M377.4,139.5h11l-5.4-32.8h-0.1
        L377.4,139.5z"
        />
        <path
          d="M427.4,128v37.5h-13.7V83.7h20c13.9,0,18.9,6.9,18.9,18.3v10.5c0,8.8-3.1,14-11,15.8l13.1,37.1h-14.5L427.4,128
        z M427.4,94.9v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12.1c0-4.4-2-6.6-6.8-6.6L427.4,94.9z"
        />
        <polygon points="457.5,83.7 494,83.7 494,94.9 482.6,94.9 482.6,165.5 468.8,165.5 468.8,94.9 457.5,94.9 " />
        <polygon
          points="514.3,114.1 514.3,165.5 502.7,165.5 502.7,83.7 516.2,83.7 531,130.6 531,83.7 542.5,83.7
        542.5,165.5 530.4,165.5 "
        />
        <polygon
          points="553.8,83.7 586.5,83.7 586.5,94.9 567.5,94.9 567.5,118.3 581.1,118.3 581.1,129.4 567.5,129.4
        567.5,154.2 586.5,154.2 586.5,165.5 553.8,165.5 "
        />
        <path
          d="M608.8,128v37.5h-13.7V83.7h20c13.9,0,18.9,6.9,18.9,18.3v10.5c0,8.8-3.1,14-11,15.8l13.1,37.1h-14.4L608.8,128
        z M608.8,94.9v25.4h4.6c4.7,0,6.8-2.4,6.8-6.8v-12.1c0-4.4-2-6.6-6.8-6.6L608.8,94.9z"
        />
        <path
          d="M640.9,147.8v-11h12.8V148c0,4.6,2,7.2,6.7,7.2c4.3,0,6.3-2.9,6.3-7.2V145c0-4.7-1.9-7.6-6.2-11.6l-8.1-8.1
        c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.7,0,19.2,6.8,19.2,18.6v6.6h-12.6v-7.1c0-4.7-2.2-7-6.5-7
        c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4c0,11.2-6,19.2-20,19.2
        S640.9,158.6,640.9,147.8"
        />
        <polygon
          points="715.8,129.4 702.5,129.4 702.5,165.5 688.8,165.5 688.8,83.7 702.5,83.7 702.5,118.3 715.8,118.3
        715.8,83.7 729.6,83.7 729.6,165.5 715.8,165.5 "
        />
        <rect x="738.7" y="83.7" width="13.7" height="81.8" />
        <path
          d="M761.6,83.7H782c13.9,0,18.9,6.9,18.9,18.3v17.2c0,11.5-5.1,18.5-18.9,18.5h-6.6v27.7h-13.8V83.7z M775.3,94.9
        v32.2h5c4.7,0,6.8-2.3,6.8-6.8v-18.8c0-4.4-2-6.6-6.8-6.6H775.3z"
        />
        <path
          d="M806.2,147.8v-11H819V148c0,4.6,2,7.2,6.8,7.2c4.3,0,6.3-2.9,6.3-7.2V145c0-4.7-1.9-7.6-6.2-11.6l-8.1-8.1
        c-7.8-7.7-11.5-12.4-11.5-21.8v-2.8c0-10.1,5.9-18,19.3-18c13.8,0,19.2,6.8,19.2,18.6v6.6h-12.5v-7.1c0-4.7-2.2-7-6.5-7
        c-3.9,0-6.5,2.2-6.5,6.8v1.7c0,4.6,2.5,7.2,6.5,11.1l8.8,8.7c7.5,7.6,11.1,12.2,11.1,21.2v4c0,11.2-6,19.2-20,19.2
        S806.3,158.6,806.2,147.8"
        />
        <polygon
          points="149.6,83.8 149.6,285.4 115.7,285.4 115.7,131.1 115.4,131.1 91.6,155.8 91.3,155.8 91.3,120.4
        122.6,83.8 "
        />
        <polygon points="165.1,83.8 250.2,83.8 250.2,115 205.8,285.4 172.2,285.4 217.4,111.5 165.1,111.5 " />
        <polygon
          points="319.1,202.5 351.8,202.5 351.8,213.8 333.1,213.8 333.1,237.6 347,237.6 347,248.8 333.1,248.8
        333.1,285.5 319.1,285.5 "
        />
        <path
          d="M356.7,264v-40.1c0-13,6.4-22.4,21-22.4s21.3,9.4,21.3,22.4V264c0,12.9-6.4,22.4-21.2,22.4s-21-9.5-21-22.4
         M385.1,266.2v-44.5c0-5-2.2-8.6-7.2-8.6s-7.1,3.6-7.1,8.6v44.6c0,5,2.2,8.6,7.1,8.6S385.1,271.3,385.1,266.2"
        />
        <path
          d="M422,247.4v38.1h-14v-83h20.3c14.1,0,19.2,7,19.2,18.6v10.6c0,8.9-3.2,14.2-11.1,16l13.3,37.7h-14.7L422,247.4z
         M422,213.8v25.8h4.6c4.8,0,6.9-2.4,6.9-6.9v-12.2c0-4.5-2.1-6.7-6.9-6.7L422,213.8z"
        />
        <polygon points="469.6,202.5 506.7,202.5 506.7,213.8 495.2,213.8 495.2,285.5 481.1,285.5 481.1,213.8 469.6,213.8 " />
        <polygon
          points="540.6,248.8 527.2,248.8 527.2,285.5 513.2,285.5 513.2,202.5 527.2,202.5 527.2,237.6 540.6,237.6
        540.6,202.5 554.7,202.5 554.7,285.5 540.6,285.5 "
        />
        <polygon
          points="563.8,202.5 597.1,202.5 597.1,213.8 577.8,213.8 577.8,237.6 591.6,237.6 591.6,248.8 577.8,248.8
        577.8,274.1 597.1,274.1 597.1,285.5 563.8,285.5 "
        />
        <path
          d="M641.7,241.1h19.8v44.3h-10v-9.1c-1.8,6.2-5.8,10-13.3,10c-12,0-17.5-9.5-17.5-22.4v-40.1
        c0-13,6.2-22.4,20.9-22.4c15.4,0,20,8.6,20,20.8v7.3h-12.8v-8.4c0-5.1-2-8.1-7-8.1s-7.2,3.6-7.2,8.6v44.6c0,5,2.1,8.6,6.9,8.6
        c4.5,0,6.8-2.6,6.8-8v-14.6h-6.6L641.7,241.1z"
        />
        <path
          d="M669.5,264v-40.1c0-13,6.4-22.4,21-22.4s21.2,9.4,21.2,22.4V264c0,12.9-6.4,22.4-21.2,22.4
        S669.5,276.8,669.5,264 M697.8,266.2v-44.5c0-5-2.2-8.6-7.2-8.6s-7.1,3.6-7.1,8.6v44.6c0,5,2.2,8.6,7.1,8.6S697.8,271.3,697.8,266.2
        "
        />
        <path
          d="M715.6,285.5l15.7-83h15.9l15.8,83h-14.3l-2.6-15.2h-14.8l-2.4,15.2H715.6z M733.1,259.1h11.2l-5.5-33.3h-0.1
        L733.1,259.1z"
        />
        <polygon points="771,202.5 785,202.5 785,274.1 801.6,274.1 801.6,285.5 771,285.5 " />
        <path
          d="M806.6,267.6v-11.1h13v11.4c0,4.6,2.1,7.4,6.8,7.4c4.4,0,6.4-3,6.4-7.4v-3.2c0-4.8-2-7.7-6.2-11.8l-8.2-8.2
        c-8-7.8-11.6-12.6-11.6-22.2v-2.8c0-10.3,6-18.2,19.6-18.2c14,0,19.5,6.9,19.5,18.9v6.7H833v-7.2c0-4.8-2.2-7.1-6.6-7.1
        c-3.9,0-6.6,2.2-6.6,6.9v1.7c0,4.6,2.6,7.4,6.6,11.3l8.9,8.8c7.6,7.7,11.3,12.4,11.3,21.5v4c0,11.4-6.1,19.5-20.3,19.5
        S806.6,278.4,806.6,267.6"
        />
        {!quantitative && (
          <path
            d="M748.3,606.5c0-70.2-55.9-127.6-125.5-130.1c-23.9-67.8-98.3-103.4-166.1-79.5c-37.1,13.1-66.4,42.3-79.5,79.5
        c-69.6,2.5-125.4,59.9-125.4,130.1c0,40.1,18.6,78,50.3,102.7c-3.4,11.8-5.1,23.9-5.1,36.2c0,71.8,58.4,130.2,130.3,130.2
        c26.2,0,51.9-7.9,73.5-22.8c21.4,14.3,46.5,22,72.3,21.9c71.8,0,130.2-58.4,130.2-130.2c0-12-1.7-23.9-4.9-35.4
        C729.8,684.4,748.2,646.5,748.3,606.5 M604,519.7c0,52.1-38.6,95.3-88.7,102.8c-0.9-5.3-1.3-10.6-1.4-16
        c0.1-51.5,37.8-95.2,88.7-102.8C603.5,509,604,514.3,604,519.7 M500.5,818.9c-41.2-39.8-42.3-105.5-2.5-146.7c0.5-0.5,1-1,1.5-1.5
        c41.2,39.8,42.3,105.4,2.5,146.6C501.5,817.9,501,818.4,500.5,818.9 M397.3,503.7c50.1,7.5,88.7,50.6,88.7,102.8
        c0,5.4-0.5,10.7-1.4,16C434.6,615,396,571.8,396,519.7C396,514.3,396.5,509,397.3,503.7 M474.9,653c-25.5,51.2-87.7,72.1-138.9,46.6
        c-0.6-0.3-1.2-0.6-1.7-0.9c25.5-51.2,87.7-72.1,138.9-46.6C473.7,652.4,474.3,652.7,474.9,653 M524.8,652.3
        c50.7-26.6,113.4-7.1,140,43.6c0.5,0.9,0.9,1.8,1.4,2.7c-50.7,26.6-113.4,7.1-140-43.6C525.7,654.1,525.2,653.2,524.8,652.3
         M500,415.7c41.4,0,78.8,24.6,95.3,62.5c-41.8,7.5-77.3,34.8-95.3,73.2c-18-38.4-53.6-65.7-95.4-73.2
        C421.2,440.3,458.6,415.7,500,415.7 M278,606.5c0.1-53.1,40.1-97.7,92.9-103.4c-5.5,42.1,9.9,84.3,41.4,112.9
        c-42.3,4.9-79.6,30.2-99.9,67.7C290.5,663.9,278,635.9,278,606.5 M323.1,745.3c0-7.2,0.8-14.5,2.3-21.6c38,18.4,82.6,17.2,119.5-3.3
        c-7.8,41.5,5.1,84.3,34.6,114.5c-49.5,29-113.1,12.4-142.1-37C328,782,323.1,763.8,323.1,745.3 M676.9,744.4
        c0.1,57.4-46.3,103.9-103.7,104c-18.1,0-35.9-4.7-51.6-13.7c29-30.5,41.4-73.1,33.3-114.4c37,20.6,81.8,21.8,119.9,3.3
        C676.2,730.5,676.9,737.4,676.9,744.4 M588.5,615.2c26.6-24.6,41.8-59.2,41.8-95.5c0-5.6-0.4-11.1-1.1-16.6
        c57,6,98.4,57.2,92.3,114.2c-2.7,25.4-14.7,48.9-33.6,66.1C667.8,645.8,630.7,620.3,588.5,615.2"
          />
        )}
      </svg>
    )
  }
  return (
    <svg
      height="983.03998"
      viewBox="0 0 983.03998 983.03998"
      width="983.03998"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <path d="m0 737.28h737.28v-737.28h-737.28z" />
      </clipPath>
      <g transform="matrix(1.3333333 0 0 -1.3333333 0 983.04)">
        <g clipPath="url(#a)" fill="currentColor">
          {!quantitative && (
            <path
              d="m0 0c13.422 12.456 21.847 30.23 21.847 49.946 0 2.949-.209 5.854-.571 8.709 27.276-2.921 48.6-26.067 48.6-54.116 0-15.934-6.926-30.244-17.884-40.21-10.257 19.219-29.446 32.963-51.992 35.671m46.266-67.649c0-30.003-24.419-54.422-54.433-54.422-9.767 0-18.906 2.62-26.838 7.141 11.577 12.22 18.715 28.709 18.715 46.829 0 4.461-.45 8.819-1.27 13.041 9.787-5.44 21.034-8.548 33.006-8.548 10.647 0 20.735 2.459 29.715 6.838.724-3.52 1.105-7.156 1.105-10.879m-185.14-.452c0 3.87.413 7.639 1.191 11.279 8.967-4.346 19.018-6.786 29.63-6.786 11.933 0 23.142 3.088 32.907 8.496-.759-4.065-1.178-8.253-1.178-12.537 0-18.407 7.36-35.125 19.265-47.402-8.056-4.718-17.398-7.471-27.382-7.471-30.02 0-54.433 24.416-54.433 54.421m-23.609 72.64c0 28.049 21.317 51.191 48.594 54.116-.362-2.855-.572-5.76-.572-8.709 0-19.922 8.599-37.875 22.266-50.346-22.606-2.574-41.89-16.236-52.254-35.412-11.038 9.964-18.034 24.342-18.034 40.351m116.173 99.836c22.304 0 41.49-13.488 49.895-32.729-22.142-3.905-40.626-18.52-49.895-38.298-9.256 19.781-27.747 34.397-49.889 38.298 8.405 19.241 27.591 32.729 49.889 32.729m12.962-123.813c7.542 3.953 16.09 6.222 25.181 6.222 21.399 0 39.899-12.446 48.794-30.449-7.545-3.956-16.106-6.224-25.181-6.224-21.406 0-39.909 12.446-48.794 30.451m-26.095-.367c-8.955-17.808-27.354-30.084-48.61-30.084-9.015 0-17.509 2.243-25.003 6.138 8.955 17.808 27.359 30.082 48.615 30.082 9.019 0 17.503-2.238 24.998-6.136m-40.583 78.12c26.211-3.898 46.406-26.491 46.406-53.776 0-2.847-.289-5.63-.714-8.362-26.214 3.901-46.403 26.488-46.403 53.769 0 2.853.286 5.637.711 8.369m53.97-164.95c-10.19 9.894-16.544 23.707-16.544 38.986 0 15.048 6.148 28.687 16.042 38.548 10.184-9.894 16.544-23.709 16.544-39 0-15.039-6.141-28.675-16.042-38.534m54.179 156.581c0-27.281-20.189-49.868-46.403-53.769-.425 2.732-.707 5.515-.707 8.362 0 27.285 20.189 49.875 46.399 53.773.425-2.729.711-5.513.711-8.366m75.473-45.407c0 36.748-29.232 66.772-65.648 68.099-9.368 26.453-34.631 45.459-64.258 45.459-29.621 0-54.881-19.006-64.258-45.459-36.416-1.331-65.636-31.354-65.636-68.099 0-21.804 10.308-41.239 26.299-53.723-1.737-6.012-2.693-12.354-2.693-18.917 0-37.566 30.573-68.142 68.157-68.142 14.261 0 27.506 4.414 38.464 11.933 10.828-7.246 23.832-11.479 37.81-11.479 37.578 0 68.151 30.573 68.151 68.14 0 6.432-.911 12.647-2.582 18.543 15.925 12.489 26.194 31.887 26.194 53.645"
              transform="translate(419.2518 195.5781)"
            />
          )}
          <path
            d="m0 0v-145.707h-24.498v111.539h-.219l-17.191-17.836h-.211v25.572l22.568 26.432z"
            transform="translate(115.4833 669.4217)"
          />
          <path
            d="m0 0h61.468v-22.563l-32.024-123.144h-24.296l32.673 125.727h-37.821z"
            transform="translate(126.6582 669.4217)"
          />
          <path
            d="m0 0v-24.143h3.804c3.523 0 5.062 1.717 5.062 5.063v14.107c0 3.345-1.539 4.973-5.062 4.973zm-10.31 8.409h15.283c10.406 0 14.203-5.153 14.203-13.745v-12.93c0-8.593-3.797-13.84-14.203-13.84h-4.973v-20.799h-10.31z"
            transform="translate(258.5254 658.7371)"
          />
          <path
            d="m0 0h8.23l-4.07 24.601h-.089zm-12.931-19.444 11.576 61.314h11.754l11.665-61.314h-10.577l-1.902 11.214h-10.94l-1.812-11.214z"
            transform="translate(290.7338 625.2763)"
          />
          <path
            d="m0 0v-19.08h3.441c3.523 0 5.062 1.806 5.062 5.062v9.045c0 3.345-1.539 4.973-5.062 4.973zm0-24.779v-28.126h-10.31v61.314h15.016c10.399 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.353-10.487-8.23-11.849l9.859-27.852h-10.851z"
            transform="translate(327.3756 658.7371)"
          />
          <path
            d="m0 0h27.401v-8.409h-8.504v-52.904h-10.4v52.904h-8.497z"
            transform="translate(349.8205 667.146)"
          />
          <path
            d="m0 0h24.601v-8.409h-14.291v-17.541h10.221v-8.326h-10.221v-18.629h14.291v-8.408h-24.601z"
            transform="translate(382.0295 667.146)"
          />
          <path
            d="m0 0v-38.524h-8.682v61.313h10.133l11.124-35.179v35.179h8.592v-61.313h-9.044z"
            transform="translate(420.8394 644.3566)"
          />
          <path
            d="m0 0h8.23l-4.07 24.601h-.089zm-12.931-19.444 11.576 61.314h11.754l11.665-61.314h-10.577l-1.902 11.214h-10.94l-1.812-11.214z"
            transform="translate(459.1986 625.2763)"
          />
          <path
            d="m0 0v-19.08h3.441c3.523 0 5.062 1.806 5.062 5.062v9.045c0 3.345-1.539 4.973-5.062 4.973zm0-24.779v-28.126h-10.31v61.314h15.016c10.399 0 14.196-5.153 14.196-13.745v-7.868c0-6.602-2.353-10.487-8.23-11.849l9.859-27.852h-10.851z"
            transform="translate(495.8404 658.7371)"
          />
          <path d="m520.359 667.146h10.31v-61.313h-10.31z" />
          <path
            d="m0 0h8.23l-4.07 24.601h-.089zm-12.93-19.444 11.575 61.314h11.754l11.665-61.314h-10.577l-1.902 11.214h-10.94l-1.812-11.214z"
            transform="translate(547.9496 625.2763)"
          />
          <path
            d="m0 0h27.4v-8.409h-8.503v-52.904h-10.4v52.904h-8.497z"
            transform="translate(568.5891 667.146)"
          />
          <path
            d="m0 0v8.23h9.585v-8.414c0-3.435 1.54-5.426 5.069-5.426 3.251 0 4.7 2.176 4.7 5.426v2.353c0 3.53-1.449 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.312-8.593 16.365v2.08c0 7.6 4.434 13.478 14.47 13.478 10.31 0 14.381-5.064 14.381-13.93v-4.974h-9.407v5.337c0 3.53-1.628 5.247-4.879 5.247-2.894 0-4.885-1.628-4.885-5.063v-1.265c0-3.441 1.896-5.432 4.885-8.32l6.602-6.513c5.604-5.698 8.32-9.133 8.32-15.919v-2.983c0-8.408-4.523-14.381-15.017-14.381-10.488 0-14.559 5.877-14.559 13.929"
            transform="translate(599.347 619.0363)"
          />
          <path
            d="m0 0v-24.143h3.804c3.523 0 5.062 1.716 5.062 5.062v14.107c0 3.346-1.539 4.974-5.062 4.974zm-10.31 8.408h15.283c10.406 0 14.203-5.152 14.203-13.744v-12.931c0-8.592-3.797-13.84-14.203-13.84h-4.973v-20.798h-10.31z"
            transform="translate(258.5254 577.3132)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.329-5.336 6.329-3.619 0-5.247-2.621-5.247-6.329v-32.921c0-3.708 1.628-6.328 5.247-6.328 3.708 0 5.336 2.62 5.336 6.328m-20.893 1.628v29.665c0 9.585 4.706 16.549 15.557 16.549 10.946 0 15.646-6.964 15.646-16.549v-29.665c0-9.496-4.7-16.549-15.646-16.549-10.851 0-15.557 7.053-15.557 16.549"
            transform="translate(303.9375 538.6042)"
          />
          <path
            d="m0 0v-46.392c0-9.495-4.071-15.646-14.559-15.646-10.857 0-15.379 6.151-15.379 15.646v46.392h10.31v-47.384c0-3.619 1.45-6.061 5.069-6.061 3.613 0 5.063 2.442 5.063 6.061v47.384z"
            transform="translate(350.0816 585.7213)"
          />
          <path
            d="m0 0v-19.081h3.441c3.523 0 5.063 1.806 5.063 5.063v9.044c0 3.346-1.54 4.974-5.063 4.974zm0-24.78v-28.125h-10.31v61.313h15.016c10.399 0 14.196-5.152 14.196-13.744v-7.868c0-6.602-2.353-10.488-8.229-11.849l9.858-27.852h-10.851z"
            transform="translate(366.2812 577.3132)"
          />
          <path
            d="m0 0h10.31v-52.905h12.3v-8.408h-22.61z"
            transform="translate(248.2155 504.2908)"
          />
          <path
            d="m0 0h8.23l-4.07 24.601h-.09zm-12.93-19.444 11.575 61.314h11.754l11.665-61.314h-10.577l-1.902 11.214h-10.94l-1.812-11.214z"
            transform="translate(286.8411 462.4212)"
          />
          <path
            d="m0 0v-19.081h3.441c3.523 0 5.063 1.806 5.063 5.063v9.044c0 3.346-1.54 4.974-5.063 4.974zm0-24.78v-28.125h-10.31v61.313h15.017c10.398 0 14.196-5.152 14.196-13.745v-7.867c0-6.602-2.354-10.488-8.23-11.849l9.858-27.852h-10.851z"
            transform="translate(338.9786 495.8827)"
          />
          <path
            d="m0 0-16.187-2.08v5.788l16.187 3.435zm-21.435-4.344h24.602v-8.408h-14.292v-17.542h10.222v-8.326h-10.222v-18.629h14.292v-8.409h-24.602z"
            transform="translate(384.9384 508.635)"
          />
          <path
            d="m0 0h8.23l-4.07 24.601h-.089zm-12.93-19.444 11.575 61.314h11.754l11.665-61.314h-10.577l-1.902 11.214h-10.94l-1.812-11.214z"
            transform="translate(404.941 462.4212)"
          />
          <path
            d="m0 0h10.31v-52.905h12.301v-8.408h-22.611z"
            transform="translate(431.2663 504.2908)"
          />
          <path d="m458.59 504.291h10.311v-61.313h-10.311z" />
          <path
            d="m0 0v8.23h9.585v-8.408c0-3.441 1.539-5.432 5.069-5.432 3.251 0 4.701 2.175 4.701 5.432v2.347c0 3.53-1.45 5.699-4.612 8.681l-6.061 6.061c-5.877 5.788-8.593 9.312-8.593 16.366v2.08c0 7.6 4.434 13.477 14.47 13.477 10.31 0 14.381-5.063 14.381-13.929v-4.973h-9.407v5.336c0 3.53-1.628 5.247-4.879 5.247-2.894 0-4.885-1.628-4.885-5.063v-1.266c0-3.44 1.896-5.425 4.885-8.325l6.602-6.507c5.604-5.699 8.32-9.133 8.32-15.92v-2.983c0-8.408-4.523-14.38-15.017-14.38-10.488 0-14.559 5.876-14.559 13.929"
            transform="translate(474.3316 456.1818)"
          />
          <path
            d="m0 0h8.23l-4.07 24.601h-.089zm-12.931-19.444 11.576 61.314h11.754l11.665-61.314h-10.577l-1.902 11.214h-10.94l-1.812-11.214z"
            transform="translate(519.7444 462.4212)"
          />
          <path
            d="m0 0h27.401v-8.408h-8.504v-52.905h-10.4v52.905h-8.497z"
            transform="translate(540.3832 504.2908)"
          />
          <path d="m572.586 504.291h10.31v-61.313h-10.31z" />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.328-5.337 6.328-3.618 0-5.246-2.62-5.246-6.328v-32.921c0-3.708 1.628-6.329 5.246-6.329 3.709 0 5.337 2.621 5.337 6.329m-20.893 1.628v29.665c0 9.585 4.706 16.549 15.556 16.549 10.947 0 15.647-6.964 15.647-16.549v-29.665c0-9.496-4.7-16.549-15.647-16.549-10.85 0-15.556 7.053-15.556 16.549"
            transform="translate(609.768 457.1737)"
          />
          <path
            d="m0 0v-38.525h-8.682v61.314h10.132l11.124-35.179v35.179h8.593v-61.314h-9.045z"
            transform="translate(634.6493 481.5021)"
          />
          <path
            d="m0 0c4.248 0 5.877 2.531 5.877 6.239v32.107c0 3.619-1.629 6.15-5.877 6.15h-4.344v-44.496zm16.186 36.451v-28.399c0-9.407-3.886-16.46-14.921-16.46h-15.919v61.313h15.919c11.035 0 14.921-6.965 14.921-16.454"
            transform="translate(262.8696 369.9552)"
          />
          <path
            d="m0 0h24.602v-8.408h-14.292v-17.542h10.221v-8.325h-10.221v-18.63h14.292v-8.408h-24.602z"
            transform="translate(284.9458 422.8597)"
          />
          <path
            d="m0 0v8.23h9.585v-8.414c0-3.434 1.539-5.425 5.069-5.425 3.25 0 4.7 2.175 4.7 5.425v2.353c0 3.53-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.312-8.593 16.365v2.08c0 7.6 4.434 13.478 14.47 13.478 10.31 0 14.381-5.064 14.381-13.93v-4.974h-9.408v5.337c0 3.53-1.628 5.247-4.878 5.247-2.894 0-4.885-1.628-4.885-5.063v-1.265c0-3.441 1.896-5.432 4.885-8.32l6.602-6.513c5.603-5.698 8.319-9.133 8.319-15.919v-2.983c0-8.408-4.522-14.38-15.016-14.38-10.488 0-14.559 5.876-14.559 13.928"
            transform="translate(314.0885 374.7506)"
          />
          <path
            d="m0 0v32.921c0 3.708-1.628 6.328-5.336 6.328-3.619 0-5.247-2.62-5.247-6.328v-32.921c0-3.708 1.628-6.329 5.247-6.329 3.708 0 5.336 2.621 5.336 6.329m-20.893 1.628v29.665c0 9.584 4.706 16.549 15.557 16.549 10.946 0 15.646-6.965 15.646-16.549v-29.665c0-9.496-4.7-16.549-15.646-16.549-10.851 0-15.557 7.053-15.557 16.549"
            transform="translate(385.4914 375.7432)"
          />
          <path
            d="m0 0v-19.176h4.522c3.441 0 5.069 1.724 5.069 4.974v9.229c0 3.256-1.539 4.973-5.158 4.973zm0 7.868h3.619c3.346 0 4.885 1.717 4.885 4.973v7.506c0 3.345-1.539 4.973-4.974 4.973h-3.53zm-10.31 25.861h14.928c10.31 0 13.744-4.789 13.744-13.471v-6.24c0-5.158-1.901-8.414-6.15-9.769 5.151-1.177 7.689-4.611 7.689-10.221v-8.135c0-8.682-3.892-13.477-14.202-13.477h-16.009z"
            transform="translate(412.001 389.1312)"
          />
          <path
            d="m0 0v-47.384c0-8.866-3.893-14.654-14.203-14.654-10.666 0-13.56 5.877-13.56 13.655v12.212h9.763v-12.389c0-3.079 1.088-4.885 3.797-4.885 2.805 0 3.893 1.806 3.893 4.974v48.471z"
            transform="translate(464.4737 422.8597)"
          />
          <path
            d="m0 0h24.601v-8.408h-14.291v-17.542h10.221v-8.325h-10.221v-18.63h14.291v-8.408h-24.601z"
            transform="translate(470.2741 422.8597)"
          />
          <path
            d="m0 0v29.664c0 9.585 4.522 16.55 15.379 16.55 11.391 0 14.559-6.329 14.559-15.373v-7.238h-9.407v8.052c0 3.797-1.266 5.966-4.974 5.966s-5.247-2.621-5.247-6.328v-32.921c0-3.709 1.539-6.329 5.247-6.329s4.974 2.353 4.974 5.966v11.308h9.407v-10.583c0-8.77-3.619-15.283-14.559-15.283-10.857 0-15.379 7.053-15.379 16.549"
            transform="translate(499.4995 377.3714)"
          />
          <path
            d="m0 0h27.4v-8.408h-8.503v-52.905h-10.4v52.905h-8.497z"
            transform="translate(532.9799 422.8597)"
          />
          <path d="m565.188 422.86h10.31v-61.313h-10.31z" />
          <path
            d="m0 0h24.15v-8.408h-13.84v-17.542h10.31v-8.325h-10.31v-27.038h-10.31z"
            transform="translate(581.4706 422.8597)"
          />
          <path
            d="m0 0v8.23h9.585v-8.414c0-3.434 1.539-5.425 5.069-5.425 3.25 0 4.7 2.175 4.7 5.425v2.353c0 3.53-1.45 5.699-4.611 8.682l-6.061 6.061c-5.877 5.788-8.593 9.312-8.593 16.365v2.08c0 7.6 4.434 13.478 14.47 13.478 10.31 0 14.381-5.064 14.381-13.93v-4.974h-9.408v5.337c0 3.53-1.628 5.247-4.878 5.247-2.894 0-4.885-1.628-4.885-5.063v-1.265c0-3.441 1.896-5.432 4.885-8.32l6.602-6.513c5.603-5.698 8.319-9.133 8.319-15.919v-2.983c0-8.408-4.522-14.38-15.016-14.38-10.488 0-14.559 5.876-14.559 13.928"
            transform="translate(609.6149 374.7506)"
          />
        </g>
      </g>
    </svg>
  )
}

const SdgIcon = ({ id, quantitative }) => {
  // French language by default for icons
  const { language: lang } = i18n
  switch (id) {
    case 1:
      return <Sdg1 lang={lang} quantitative={quantitative} />
    case 2:
      return <Sdg2 lang={lang} quantitative={quantitative} />
    case 3:
      return <Sdg3 lang={lang} quantitative={quantitative} />
    case 4:
      return <Sdg4 lang={lang} quantitative={quantitative} />
    case 5:
      return <Sdg5 lang={lang} quantitative={quantitative} />
    case 6:
      return <Sdg6 lang={lang} quantitative={quantitative} />
    case 7:
      return <Sdg7 lang={lang} quantitative={quantitative} />
    case 8:
      return <Sdg8 lang={lang} quantitative={quantitative} />
    case 9:
      return <Sdg9 lang={lang} quantitative={quantitative} />
    case 10:
      return <Sdg10 lang={lang} quantitative={quantitative} />
    case 11:
      return <Sdg11 lang={lang} quantitative={quantitative} />
    case 12:
      return <Sdg12 lang={lang} quantitative={quantitative} />
    case 13:
      return <Sdg13 lang={lang} quantitative={quantitative} />
    case 14:
      return <Sdg14 lang={lang} quantitative={quantitative} />
    case 15:
      return <Sdg15 lang={lang} quantitative={quantitative} />
    case 16:
      return <Sdg16 lang={lang} quantitative={quantitative} />
    case 17:
      return <Sdg17 lang={lang} quantitative={quantitative} />
    default:
      return <svg></svg>
  }
}

SdgIcon.propTypes = {
  id: PropTypes.number.isRequired,
  quantitative: PropTypes.bool,
}

SdgIcon.defaultProps = {
  quantitative: false,
}

export default SdgIcon
